<template>
  <div class="role-page d-flex">
    <aside class="side-nav">
      <h4 class="mb-3">管理员系统</h4>
      <button class="sub-btn" :class="{ active: activeMenu === 'dashboard' }" @click="activeMenu = 'dashboard'">数据看板</button>
      <button class="sub-btn" :class="{ active: activeMenu === 'user' }" @click="activeMenu = 'user'">用户管理</button>
      <button class="sub-btn" :class="{ active: activeMenu === 'exam' }" @click="openExamMenu">考试信息查询</button>
      <button class="sub-btn" :class="{ active: activeMenu === 'notice' }" @click="openNoticeMenu">公告管理</button>
      <button class="sub-btn" :class="{ active: activeMenu === 'verifyAbnormal' }" @click="openVerifyAbnormalMenu">
        考试核验及异常行为管理
      </button>
      <button class="sub-btn" :class="{ active: activeMenu === 'eventManage' }" type="button" @click="openEventManageMenu">赛事管理</button>
      <button class="sub-btn" :class="{ active: activeMenu === 'citySignup' }" type="button" @click="openCitySignupMenu">地市考试报名系统</button>
      <button class="sub-btn" :class="{ active: activeMenu === 'sessionManage' }" type="button" @click="openExamSessionInfoMenu">
        考试场次信息管理
      </button>
      <button class="sub-btn" :class="{ active: activeMenu === 'cityPaperManage' }" type="button" @click="openCityPaperManageMenu">
        地市试卷设置管理
      </button>
      <button class="sub-btn" :class="{ active: activeMenu === 'questionManage' }" type="button" @click="openQuestionManageMenu">
        题库管理
      </button>
      <button
        class="sub-btn"
        :class="{ active: activeMenu === 'ticketLoginPageManage' }"
        type="button"
        @click="openTicketLoginPageManageMenu"
      >
        准考证登录管理
      </button>
      <button class="btn btn-success w-100 side-nav-logout-btn" @click="logout">退出登录</button>
    </aside>

    <main class="content-area">
      <section class="card-box admin-dashboard-section" v-if="activeMenu === 'dashboard'">
        <h4 class="mb-3">学员与考试概况</h4>
        <p class="small text-muted mb-3">
          在线人数依赖客户端心跳（登录后约每 45 秒上报一次，5 分钟内有效）。「正在考试」统计未交卷且状态为已分配/考试中的考试记录。
        </p>
        <div class="row g-3 mb-3">
          <div class="col-6 col-md-3">
            <div class="admin-stat-tile">
              <div class="admin-stat-label">未交卷 / 考试中（学员）</div>
              <div class="admin-stat-value">{{ dashboardStats ? dashboardStats.examiningCount : '—' }}</div>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="admin-stat-tile">
              <div class="admin-stat-label">在线学员（网站心跳）</div>
              <div class="admin-stat-value">{{ dashboardStats ? dashboardStats.onlineStudentCount : '—' }}</div>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="admin-stat-tile">
              <div class="admin-stat-label">当前在线（全角色）</div>
              <div class="admin-stat-value">{{ dashboardStats ? dashboardStats.onlineAllRolesCount : '—' }}</div>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="admin-stat-tile">
              <div class="admin-stat-label">学员账号总数</div>
              <div class="admin-stat-value">{{ dashboardStats ? dashboardStats.studentTotal : '—' }}</div>
            </div>
          </div>
        </div>
        <div class="row g-3 align-items-stretch">
          <div class="col-lg-6">
            <div class="admin-chart-card">
              <div class="admin-chart-title">学员人数分布</div>
              <div ref="dashboardPie" class="admin-chart-box"></div>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="admin-chart-card">
              <div class="admin-chart-title">各考试最高分（Top）</div>
              <div ref="dashboardBar" class="admin-chart-box"></div>
            </div>
          </div>
        </div>
        <div class="mt-2">
          <button type="button" class="btn btn-sm btn-light" @click="loadDashboardStats">刷新数据</button>
        </div>
      </section>

      <section class="card-box" v-if="activeMenu === 'user'">
        <h4>查询用户</h4>
        <p class="small text-muted mb-3">按条件筛选已有账号，结果在下方列表中展示。</p>
        <div class="row g-2 mb-3 align-items-end">
          <div class="col-md-3">
            <label class="form-label mb-1 small text-muted">关键字</label>
            <input v-model="userFilters.keyword" class="form-control" placeholder="账号 / 姓名 / 手机号" @keyup.enter="runUserQuery" />
          </div>
          <div class="col-md-2">
            <label class="form-label mb-1 small text-muted">角色</label>
            <select v-model="userFilters.role" class="form-select">
              <option value="">全部角色</option>
              <option value="admin">管理员</option>
              <option value="teacher">教师</option>
              <option value="student">学生</option>
            </select>
          </div>
          <div class="col-md-2">
            <label class="form-label mb-1 small text-muted">状态</label>
            <select v-model="userFilters.status" class="form-select">
              <option value="">全部状态</option>
              <option value="1">正常</option>
              <option value="0">禁用</option>
            </select>
          </div>
          <div class="col-md-2">
            <label class="form-label mb-1 small text-muted">省份</label>
            <select v-model="userFilters.province" class="form-select">
              <option value="">全部省份</option>
              <option v-for="p in provinceOptions" :key="'uf-p-' + p" :value="p">{{ p }}</option>
            </select>
          </div>
          <div class="col-md-2">
            <label class="form-label mb-1 small text-muted">地市</label>
            <select v-model="userFilters.city" class="form-select" :disabled="!userFilters.province">
              <option value="">全部地市</option>
              <option v-for="c in filterCityOptions" :key="'uf-c-' + c" :value="c">{{ c }}</option>
            </select>
          </div>
          <div class="col-md-1">
            <button class="btn btn-primary w-100" type="button" @click="runUserQuery">查询</button>
          </div>
        </div>

        <div class="result-shell">
          <table class="table table-striped align-middle modern-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>账号</th>
                <th>姓名</th>
                <th>角色</th>
                <th>手机号</th>
                <th>省份</th>
                <th>地市</th>
                <th>状态</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="u in users" :key="u.id">
                <td>{{ u.id }}</td>
                <td>{{ u.username }}</td>
                <td>{{ u.realName || '-' }}</td>
                <td>{{ roleText(u.role) }}</td>
                <td>{{ u.phone || '-' }}</td>
                <td>{{ u.province || '-' }}</td>
                <td>{{ u.city || '-' }}</td>
                <td>{{ Number(u.status) === 1 ? '正常' : '禁用' }}</td>
                <td>
                  <button class="btn btn-sm btn-light me-2" @click="toggleUserStatus(u)">
                    {{ Number(u.status) === 1 ? '禁用' : '启用' }}
                  </button>
                  <button class="btn btn-sm btn-warning me-2" @click="openUserEditModal(u)">编辑</button>
                  <button class="btn btn-sm btn-danger" @click="deleteUser(u.id)">删除</button>
                </td>
              </tr>
              <tr v-if="users.length === 0">
                <td colspan="9" class="text-muted">暂无用户数据，请调整筛选条件后查询</td>
              </tr>
            </tbody>
          </table>
          <div
            v-if="userTotalElements > 0"
            class="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-3 pt-2 border-top border-secondary-subtle"
          >
            <div class="small text-muted">
              共 {{ userTotalElements }} 条，每页 {{ userPageSize }} 条，第 {{ userPage + 1 }} / {{ userTotalPages }} 页
            </div>
            <div class="btn-group">
              <button type="button" class="btn btn-sm btn-light" :disabled="userPage <= 0" @click="goUserPage(0)">
                首页
              </button>
              <button type="button" class="btn btn-sm btn-light" :disabled="userPage <= 0" @click="goUserPage(userPage - 1)">
                上一页
              </button>
              <button
                type="button"
                class="btn btn-sm btn-light"
                :disabled="userPage >= userTotalPages - 1"
                @click="goUserPage(userPage + 1)"
              >
                下一页
              </button>
              <button
                type="button"
                class="btn btn-sm btn-light"
                :disabled="userPage >= userTotalPages - 1"
                @click="goUserPage(userTotalPages - 1)"
              >
                末页
              </button>
            </div>
          </div>
        </div>
      </section>

      <section class="card-box mt-4" v-if="activeMenu === 'user'">
        <h4>新增用户</h4>
        <p class="small text-muted mb-3">单独创建一条账号；与上方查询筛选互不影响。</p>
        <div class="row g-2 mb-3 align-items-end">
          <div class="col-md-2">
            <label class="form-label mb-1 small text-muted">账号 <span class="text-danger">*</span></label>
            <input v-model.trim="createForm.username" class="form-control" placeholder="登录账号" />
          </div>
          <div class="col-md-2">
            <label class="form-label mb-1 small text-muted">姓名</label>
            <input v-model.trim="createForm.realName" class="form-control" placeholder="真实姓名" />
          </div>
          <div class="col-md-2">
            <label class="form-label mb-1 small text-muted">手机号</label>
            <input v-model.trim="createForm.phone" class="form-control" placeholder="手机号" />
          </div>
          <div class="col-md-2">
            <label class="form-label mb-1 small text-muted">密码 <span class="text-danger">*</span></label>
            <input v-model="createForm.password" type="password" class="form-control" placeholder="登录密码" />
          </div>
          <div class="col-md-2">
            <label class="form-label mb-1 small text-muted">角色</label>
            <select v-model="createForm.role" class="form-select">
              <option value="student">学生</option>
              <option value="teacher">教师</option>
              <option value="admin">管理员</option>
            </select>
          </div>
        </div>
        <div class="row g-2 mb-3 align-items-end">
          <div class="col-md-3">
            <label class="form-label mb-1 small text-muted">省份</label>
            <select v-model="createForm.province" class="form-select">
              <option value="">请选择省份</option>
              <option v-for="p in provinceOptions" :key="'cf-p-' + p" :value="p">{{ p }}</option>
            </select>
          </div>
          <div class="col-md-3">
            <label class="form-label mb-1 small text-muted">地市</label>
            <select v-model="createForm.city" class="form-select" :disabled="!createForm.province">
              <option value="">请选择地市</option>
              <option v-for="c in createCityOptions" :key="'cf-c-' + c" :value="c">{{ c }}</option>
            </select>
          </div>
          <div class="col-md-2">
            <button class="btn btn-success w-100" type="button" @click="createUser">提交新增</button>
          </div>
          <div class="col-md-2">
            <button class="btn btn-light w-100" type="button" @click="resetCreateUserForm">清空表单</button>
          </div>
        </div>
      </section>

      <section class="card-box mt-4" v-if="activeMenu === 'user'">
        <h4>批量导入用户</h4>
        <p class="small text-muted mb-3">通过 Excel 一次导入多名用户；可先下载模板再填写上传。</p>
        <div class="row g-2 align-items-end">
          <div class="col-md-6">
            <label class="form-label mb-1 small text-muted">选择 Excel 文件</label>
            <input ref="userExcelInput" type="file" class="form-control" accept=".xlsx" @change="onUserExcelChange" />
          </div>
          <div class="col-md-3">
            <button class="btn btn-primary w-100" type="button" @click="importUsersByExcel">Excel批量导入</button>
          </div>
          <div class="col-md-3">
            <button class="btn btn-light w-100" type="button" @click="downloadUserTemplate">下载导入模板</button>
          </div>
        </div>
      </section>

      <section class="card-box" v-if="activeMenu === 'exam'">
        <h4>考试信息查询</h4>
        <div class="row g-2 mb-3">
          <div class="col-md-3"><input v-model="examFilters.keyword" class="form-control" placeholder="考试名称关键字" /></div>
          <div class="col-md-2">
            <select v-model="examFilters.status" class="form-select">
              <option value="">全部状态</option>
              <option value="NOT_START">未开始</option>
              <option value="ING">进行中</option>
              <option value="END">已结束</option>
            </select>
          </div>
          <div class="col-md-2"><button class="btn btn-light w-100" @click="loadExams">查询</button></div>
        </div>

        <div class="result-shell">
          <table class="table table-striped align-middle modern-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>考试名称</th>
                <th>试卷ID</th>
                <th>开始时间</th>
                <th>结束时间</th>
                <th>状态</th>
                <th>成绩公开</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="e in exams" :key="e.id">
                <td>{{ e.id }}</td>
                <td>{{ e.examName }}</td>
                <td>{{ e.paperId }}</td>
                <td>{{ $fmtDateTime(e.startTime) }}</td>
                <td>{{ $fmtDateTime(e.endTime) }}</td>
                <td>{{ examStatusText(e.status) }}</td>
                <td>
                  <span class="badge" :class="Number(e.scorePublic || 0) === 1 ? 'text-bg-success' : 'text-bg-secondary'">
                    {{ Number(e.scorePublic || 0) === 1 ? '已公开' : '未公开' }}
                  </span>
                </td>
                <td>
                  <button class="btn btn-sm btn-light me-2" @click="loadExamAnswers(e.id)">查看作答</button>
                  <button
                    v-if="Number(e.scorePublic || 0) !== 1"
                    class="btn btn-sm btn-primary me-2"
                    @click="publishExamScores(e.id)"
                  >
                    一键公开成绩
                  </button>
                  <button
                    v-else
                    class="btn btn-sm btn-warning me-2"
                    @click="unpublishExamScores(e.id)"
                  >
                    取消公开
                  </button>
                  <button class="btn btn-sm btn-light" @click="exportExamScores(e.id)">导出总成绩</button>
                </td>
              </tr>
              <tr v-if="exams.length === 0">
                <td colspan="8" class="text-muted">暂无考试数据</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="mt-3" v-if="answerRows.length > 0">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <h5 class="mb-0">作答记录</h5>
            <div class="d-flex align-items-center gap-2">
              <span class="small text-muted">当前考试成绩公开状态：</span>
              <span class="badge" :class="currentExamScorePublic === 1 ? 'text-bg-success' : 'text-bg-secondary'">
                {{ currentExamScorePublic === 1 ? '已公开' : '未公开' }}
              </span>
              <button
                v-if="currentExamId && currentExamScorePublic !== 1"
                class="btn btn-sm btn-primary"
                @click="publishExamScores(currentExamId)"
              >
                立即公开
              </button>
              <button
                v-if="currentExamId && currentExamScorePublic === 1"
                class="btn btn-sm btn-warning"
                @click="unpublishExamScores(currentExamId)"
              >
                取消公开
              </button>
            </div>
          </div>
          <div class="result-shell">
            <table class="table table-striped align-middle modern-table">
              <thead>
                <tr>
                  <th>记录ID</th>
                  <th>学员ID</th>
                  <th>学员账号</th>
                  <th>状态</th>
                  <th>总分</th>
                  <th>交卷时间</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="r in answerRows" :key="r.recordId">
                  <td>{{ r.recordId }}</td>
                  <td>{{ r.userId }}</td>
                  <td>{{ r.username }}</td>
                  <td>{{ answerRecordStatusText(r.status) }}</td>
                  <td>{{ r.score }}</td>
                  <td>{{ $fmtDateTime(r.submitTime) }}</td>
                  <td>
                    <button class="btn btn-sm btn-primary me-2" @click="viewAnswerDetail(r)">查看详情</button>
                    <button class="btn btn-sm btn-light" @click="exportAnswerExcel(r.recordId)">导出作答</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section class="card-box" v-if="activeMenu === 'sessionManage'">
        <h4>考试场次信息管理</h4>
        <p class="small text-muted mb-3">查询「地市考试报名系统」的场次，并展开查看该场次所有参赛学生（含状态、赛项报名、学生信息）。</p>

        <div class="row g-2 align-items-end mb-2">
          <div class="col-md-3">
            <label class="form-label mb-1 small text-muted">场次名称</label>
            <input v-model.trim="citySignupListFilters.examNameLike" class="form-control form-control-sm" placeholder="如：2026年春季信息学竞赛" />
          </div>
          <div class="col-md-2">
            <label class="form-label mb-1 small text-muted">省份</label>
            <select v-model="citySignupListFilters.province" class="form-select form-select-sm">
              <option value="">全部省份</option>
              <option v-for="p in provinceOptions" :key="'cs-sess-p-' + p" :value="p">{{ p }}</option>
            </select>
          </div>
          <div class="col-md-2">
            <label class="form-label mb-1 small text-muted">地市</label>
            <select v-model="citySignupListFilters.city" class="form-select form-select-sm" :disabled="!citySignupListFilters.province">
              <option value="">全部地市</option>
              <option v-for="c in citySignupListFilterCityOptions" :key="'cs-sess-c-' + c" :value="c">{{ c }}</option>
            </select>
          </div>
          <div class="col-md-2">
            <label class="form-label mb-1 small text-muted">阶段</label>
            <select v-model="citySignupListFilters.examPhase" class="form-select form-select-sm">
              <option value="">全部</option>
              <option value="PRE">考前</option>
              <option value="ING">考试中</option>
              <option value="POST">考后</option>
            </select>
          </div>
          <div class="col-md-1">
            <label class="form-label mb-1 small text-muted">状态</label>
            <select v-model="citySignupListFilters.status" class="form-select form-select-sm">
              <option value="">全部</option>
              <option :value="1">开启</option>
              <option :value="0">关闭</option>
            </select>
          </div>
          <div class="col-md-2 d-flex gap-2">
            <button class="btn btn-sm btn-light w-100" type="button" @click="searchCitySignupList">查询</button>
            <button class="btn btn-sm btn-outline-secondary w-100" type="button" @click="resetCitySignupListFilters">重置</button>
          </div>
        </div>

        <div class="result-shell mb-3">
          <table class="table table-striped align-middle modern-table city-signup-session-table">
            <thead>
              <tr>
                <th>场次</th>
                <th>赛事举办地区</th>
                <th>报名时间</th>
                <th>考试时间</th>
                <th>状态</th>
                <th style="width: 10rem">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in citySignupRows" :key="'sess-m-' + row.id">
                <td class="city-signup-name-cell" :title="row.examName || ''">{{ row.examName || '-' }}</td>
                <td>{{ row.province || '-' }} {{ row.city || '' }}</td>
                <td>{{ $fmtDateTime(row.signupStartTime) }} ~ {{ $fmtDateTime(row.signupEndTime) }}</td>
                <td>{{ $fmtDateTime(row.examTime) }}</td>
                <td>{{ Number(row.status) === 1 ? '开启' : '关闭' }}</td>
                <td>
                  <button class="btn btn-sm btn-primary" type="button" @click="openSessionManageEntries(row)">
                    查看参赛学生
                  </button>
                </td>
              </tr>
              <tr v-if="citySignupRows.length === 0">
                <td colspan="6" class="text-muted">{{ citySignupListEmptyHint }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="citySignupEntryCurrentSignupId" class="mb-2">
          <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2">
            <h5 class="mb-0">参赛学生 · {{ citySignupEntryTitle }}</h5>
            <div class="d-flex flex-wrap gap-2 align-items-center">
              <label class="small d-flex align-items-center mb-0 px-2">
                <input v-model="citySignupExportMaskIdCard" type="checkbox" class="me-1" />
                导出时对身份证号脱敏
              </label>
              <button class="btn btn-sm btn-outline-secondary" type="button" @click="exportCitySignupEntriesCsv">导出Excel(CSV)</button>
              <button class="btn btn-sm btn-light" type="button" @click="closeSessionManageEntries">收起</button>
            </div>
          </div>

          <div class="row g-2 mb-2">
            <div class="col-md-3">
              <input v-model.trim="citySignupEntryFilters.candidateName" class="form-control form-control-sm" placeholder="姓名" />
            </div>
            <div class="col-md-3">
              <input v-model.trim="citySignupEntryFilters.idCard" class="form-control form-control-sm" placeholder="身份证号" />
            </div>
            <div class="col-md-2">
              <select v-model="citySignupEntryFilters.projectName" class="form-select form-select-sm">
                <option value="">全部项目</option>
                <option v-for="p in cityProjectRows.filter((x) => Number(x.status) === 1)" :key="'entry-filter-proj-p-' + p.id" :value="p.projectName">
                  {{ p.projectName }}
                </option>
              </select>
            </div>
            <div class="col-md-2">
              <select v-model="citySignupEntryFilters.status" class="form-select form-select-sm">
                <option value="">全部状态</option>
                <option :value="1">待审</option>
                <option :value="2">通过</option>
                <option :value="0">驳回</option>
              </select>
            </div>
            <div class="col-md-1">
              <button class="btn btn-sm btn-light w-100" type="button" @click="loadCitySignupEntries">筛选</button>
            </div>
            <div class="col-md-1">
              <input v-model.trim="citySignupReviewNote" class="form-control form-control-sm" placeholder="审核备注(可选)" />
            </div>
          </div>

          <div class="row g-2 mb-2">
            <div class="col-12 d-flex flex-wrap gap-2 align-items-center">
              <button
                class="btn btn-sm btn-success"
                type="button"
                :disabled="citySignupBatchReviewing || citySignupBatchSelectedPendingCount === 0"
                @click="batchApproveCitySignupSelected"
              >
                {{ citySignupBatchReviewing ? '处理中…' : `批量同意(${citySignupBatchSelectedPendingCount})` }}
              </button>
              <button
                class="btn btn-sm btn-outline-success"
                type="button"
                :disabled="citySignupBatchReviewing"
                @click="approveAllPendingCitySignupEntries"
              >
                全部同意
              </button>
              <span class="small text-muted">「全部同意」将处理本场次全部待审记录（含当前筛选条件以外的待审）。</span>
            </div>
          </div>

          <div class="result-shell">
            <table class="table table-striped align-middle modern-table">
              <thead>
                <tr>
                  <th style="width: 2.25rem" class="text-center">
                    <input
                      type="checkbox"
                      :checked="citySignupAllPendingSelected"
                      :disabled="citySignupPendingIdsOnPage.length === 0"
                      title="全选当前列表中的待审"
                      @change="onCitySignupSelectAllPending($event)"
                    />
                  </th>
                  <th>姓名</th>
                  <th>性别</th>
                  <th>身份证号</th>
                  <th>联系电话</th>
                  <th>省市</th>
                  <th>学校/年级</th>
                  <th>项目分类</th>
                  <th>状态</th>
                  <th>审核备注</th>
                  <th>提交时间</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in citySignupEntryRowsPaged" :key="'city-entry-panel-' + row.id">
                  <td class="text-center">
                    <input
                      type="checkbox"
                      :checked="citySignupEntrySelectedIds.includes(Number(row.id))"
                      :disabled="Number(row.status) !== 1"
                      @change="onCitySignupEntryRowCheck(row, $event)"
                    />
                  </td>
                  <td>{{ row.candidateName || '-' }}</td>
                  <td>{{ row.gender || '-' }}</td>
                  <td>{{ row.idCard || '-' }}</td>
                  <td>{{ row.phone || '-' }}</td>
                  <td>{{ row.province || '-' }} {{ row.city || '' }}</td>
                  <td>{{ row.schoolName || '-' }} {{ row.gradeName ? ` / ${row.gradeName}` : '' }}</td>
                  <td>{{ row.projectName || '-' }}</td>
                  <td>{{ citySignupEntryStatusText(row.status) }}</td>
                  <td>{{ row.reviewNote || '-' }}</td>
                  <td>{{ $fmtDateTime(row.createTime) }}</td>
                  <td>
                    <div class="d-flex gap-1 city-entry-action-nowrap">
                      <button class="btn btn-sm btn-warning" type="button" @click="openCitySignupEntryEdit(row)">编辑</button>
                      <button class="btn btn-sm btn-success" type="button" @click="reviewCitySignupEntry(row, 2)">通过</button>
                      <button class="btn btn-sm btn-danger" type="button" @click="reviewCitySignupEntry(row, 0)">驳回</button>
                    </div>
                  </td>
                </tr>
                <tr v-if="citySignupEntryRowsPaged.length === 0">
                  <td colspan="12" class="text-muted">暂无报名数据</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div
            v-if="citySignupEntryTotalElements > 0"
            class="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-3 pt-2 border-top border-secondary-subtle"
          >
            <div class="small text-muted">
              共 {{ citySignupEntryTotalElements }} 条，每页 {{ citySignupEntryPageSize }} 条，第
              {{ citySignupEntryPage + 1 }} / {{ citySignupEntryTotalPages }} 页
            </div>
            <div class="btn-group">
              <button type="button" class="btn btn-sm btn-light" :disabled="citySignupEntryPage <= 0" @click="goCitySignupEntryPage(0)">
                首页
              </button>
              <button
                type="button"
                class="btn btn-sm btn-light"
                :disabled="citySignupEntryPage <= 0"
                @click="goCitySignupEntryPage(citySignupEntryPage - 1)"
              >
                上一页
              </button>
              <button
                type="button"
                class="btn btn-sm btn-light"
                :disabled="citySignupEntryPage >= citySignupEntryTotalPages - 1"
                @click="goCitySignupEntryPage(citySignupEntryPage + 1)"
              >
                下一页
              </button>
              <button
                type="button"
                class="btn btn-sm btn-light"
                :disabled="citySignupEntryPage >= citySignupEntryTotalPages - 1"
                @click="goCitySignupEntryPage(citySignupEntryTotalPages - 1)"
              >
                末页
              </button>
            </div>
          </div>
        </div>
      </section>

      <section class="card-box" v-if="activeMenu === 'notice'">
        <h4>公告管理</h4>
        <div class="row g-2 mb-3">
          <div class="col-md-3">
            <input v-model="noticeFilters.keyword" class="form-control" placeholder="标题关键字" />
          </div>
          <div class="col-md-2">
            <select v-model="noticeFilters.status" class="form-select">
              <option value="">全部状态</option>
              <option value="1">已发布</option>
              <option value="0">已下线</option>
            </select>
          </div>
          <div class="col-md-2">
            <button class="btn btn-light w-100" @click="loadNotices">查询</button>
          </div>
          <div class="col-md-2">
            <button class="btn btn-primary w-100" @click="openCreateNoticeModal">发布公告</button>
          </div>
        </div>
        <div class="result-shell">
          <table class="table table-striped align-middle modern-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>标题</th>
                <th>内容</th>
                <th>状态</th>
                <th>排序</th>
                <th>发布时间</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="n in notices" :key="n.id">
                <td>{{ n.id }}</td>
                <td>{{ n.title || '-' }}</td>
                <td>{{ noticeSummary(n) }}</td>
                <td>{{ Number(n.status) === 1 ? '已发布' : '已下线' }}</td>
                <td>{{ n.sort ?? 0 }}</td>
                <td>{{ $fmtDateTime(n.publishTime || n.createTime) }}</td>
                <td>
                  <button class="btn btn-sm btn-light me-2" @click="editNotice(n)">编辑</button>
                  <button class="btn btn-sm btn-warning me-2" @click="toggleNoticeStatus(n)">
                    {{ Number(n.status) === 1 ? '下线' : '发布' }}
                  </button>
                  <button class="btn btn-sm btn-danger" @click="deleteNotice(n.id)">删除</button>
                </td>
              </tr>
              <tr v-if="notices.length === 0">
                <td colspan="7" class="text-muted">暂无公告</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section class="card-box" v-if="activeMenu === 'verifyAbnormal'">
        <h4>考前核验查询</h4>
        <div class="row g-2 mb-3">
          <div class="col-md-2"><input v-model="entryFilters.examId" class="form-control" placeholder="考试ID" /></div>
          <div class="col-md-2"><input v-model="entryFilters.userId" class="form-control" placeholder="用户ID" /></div>
          <div class="col-md-2">
            <select v-model="entryFilters.status" class="form-select">
              <option value="">全部状态</option>
              <option value="PASS">PASS</option>
              <option value="REJECT">REJECT</option>
            </select>
          </div>
          <div class="col-md-1">
            <select v-model.number="entryPageSize" class="form-select" @change="searchEntryChecks" title="每页条数">
              <option :value="10">10</option>
              <option :value="20">20</option>
              <option :value="50">50</option>
            </select>
          </div>
          <div class="col-md-2"><button class="btn btn-light w-100" @click="searchEntryChecks">查询</button></div>
          <div class="col-md-2"><button class="btn btn-light w-100" @click="resetEntryCheckFilters">重置</button></div>
        </div>
        <div class="small text-muted mb-2">
          共 {{ entryTotalElements }} 条，第 {{ entryPage + 1 }} / {{ entryTotalPages }} 页
        </div>

        <div class="result-shell">
          <table class="table table-striped align-middle modern-table">
            <thead>
              <tr>
                <th>序号</th>
                <th>考试名称</th>
                <th>学员账号</th>
                <th>核验状态</th>
                <th>考前照片</th>
                <th>缩略图</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(x, idx) in entryChecks"
                :key="x.id"
                :class="{ 'entry-row-reject': String(x.status || '').toUpperCase() === 'REJECT' }"
              >
                <td>{{ entryPage * entryPageSize + idx + 1 }}</td>
                <td>{{ x.examNameDisplay || '—' }}</td>
                <td>{{ x.studentUsername || '—' }}</td>
                <td style="min-width: 140px;">
                  <select
                    class="form-select form-select-sm entry-status-select"
                    :class="{ reject: String(x.status || '').toUpperCase() === 'REJECT' }"
                    :value="x.status || 'PASS'"
                    @change="updateEntryStatus(x, $event)"
                  >
                    <option value="PASS">通过</option>
                    <option value="REJECT">不通过</option>
                  </select>
                </td>
                <td>
                  <button
                    v-if="x.cameraPhoto"
                    class="btn btn-sm btn-primary"
                    @click="openEntryPhotoModal(x)"
                  >
                    查看照片
                  </button>
                  <span v-else class="text-muted">无</span>
                </td>
                <td>
                  <img
                    v-if="x.cameraPhoto"
                    :src="x.cameraPhoto"
                    alt="entry-thumb"
                    class="entry-thumb-img"
                    @mouseenter="showEntryHoverPreview($event, x.cameraPhoto)"
                    @mousemove="moveEntryHoverPreview($event)"
                    @mouseleave="hideEntryHoverPreview"
                    @click="openEntryPhotoModal(x)"
                  />
                  <span v-else class="text-muted">-</span>
                </td>
                <td>
                  <button class="btn btn-sm btn-danger entry-delete-btn" @click="deleteEntryCheck(x)">删除</button>
                </td>
              </tr>
              <tr v-if="!entryLoading && entryChecks.length === 0">
                <td colspan="7" class="text-muted">暂无核验记录</td>
              </tr>
            </tbody>
          </table>
          <div class="d-flex flex-wrap justify-content-end align-items-center gap-2 mt-3">
            <button type="button" class="btn btn-sm btn-light" :disabled="entryPage <= 0 || entryLoading" @click="goEntryPage(0)">
              首页
            </button>
            <button
              type="button"
              class="btn btn-sm btn-light"
              :disabled="entryPage <= 0 || entryLoading"
              @click="goEntryPage(entryPage - 1)"
            >
              上一页
            </button>
            <span class="small text-muted">{{ entryPage + 1 }} / {{ entryTotalPages }}</span>
            <button
              type="button"
              class="btn btn-sm btn-light"
              :disabled="entryPage >= entryTotalPages - 1 || entryLoading"
              @click="goEntryPage(entryPage + 1)"
            >
              下一页
            </button>
            <button
              type="button"
              class="btn btn-sm btn-light"
              :disabled="entryPage >= entryTotalPages - 1 || entryLoading"
              @click="goEntryPage(entryTotalPages - 1)"
            >
              末页
            </button>
          </div>
        </div>
      </section>

      <section class="card-box mt-4" v-if="activeMenu === 'verifyAbnormal'">
        <h4>考试异常行为（按学员）</h4>
        <p class="small text-muted mb-3">
          下列每名学员一条汇总；点击「查看详情」在弹窗中查看该学员全部异常记录（中文说明）。切屏满 5 次将强制交卷。
        </p>
        <div class="row g-2 mb-3">
          <div class="col-md-4">
            <select v-model="cheatFilters.examId" class="form-select" @change="runCheatQuery" @keyup.enter="runCheatQuery">
              <option value="">全部考试</option>
              <option v-for="e in exams" :key="'cheat-exam-' + e.id" :value="String(e.id)">
                {{ e.examName || ('考试 #' + e.id) }}
              </option>
            </select>
          </div>
          <div class="col-md-3">
            <input v-model="cheatFilters.username" class="form-control" placeholder="学生账号" @keyup.enter="runCheatQuery" />
          </div>
          <div class="col-md-3">
            <input v-model="cheatFilters.userId" class="form-control" placeholder="用户ID" @keyup.enter="runCheatQuery" />
          </div>
          <div class="col-md-1">
            <button type="button" class="btn btn-light w-100" @click="runCheatQuery">查询</button>
          </div>
          <div class="col-md-1">
            <button type="button" class="btn btn-outline-secondary w-100" @click="resetCheatFilters">重置</button>
          </div>
        </div>
        <div class="result-shell">
          <table class="table table-striped align-middle modern-table">
            <thead>
              <tr>
                <th>考试名称</th>
                <th>学员账号</th>
                <th>用户ID</th>
                <th>异常次数</th>
                <th>最近异常时间</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in cheatUserSummaries" :key="'cheat-u-' + row.userId">
                <td>{{ cheatExamNameDisplay(row) }}</td>
                <td>{{ row.username || '-' }}</td>
                <td>{{ row.userId }}</td>
                <td>{{ row.violationCount }}</td>
                <td>{{ $fmtDateTime(row.lastTime) }}</td>
                <td>
                  <button type="button" class="btn btn-sm btn-primary" @click="openCheatDetailModal(row)">查看详情</button>
                </td>
              </tr>
              <tr v-if="cheatUserSummaries.length === 0">
                <td colspan="6" class="text-muted">暂无学员异常记录</td>
              </tr>
            </tbody>
          </table>
          <div
            v-if="cheatTotalElements > 0"
            class="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-3 pt-2 border-top border-secondary-subtle"
          >
            <div class="small text-muted">
              共 {{ cheatTotalElements }} 名学员，第 {{ cheatPage + 1 }} / {{ cheatTotalPages }} 页
            </div>
            <div class="btn-group">
              <button type="button" class="btn btn-sm btn-light" :disabled="cheatPage <= 0" @click="goCheatPage(cheatPage - 1)">上一页</button>
              <button
                type="button"
                class="btn btn-sm btn-light"
                :disabled="cheatPage >= cheatTotalPages - 1"
                @click="goCheatPage(cheatPage + 1)"
              >
                下一页
              </button>
            </div>
          </div>
        </div>
      </section>

      <section class="card-box" v-if="activeMenu === 'eventManage'">
        <h4>赛事管理</h4>
        <div class="d-flex flex-column align-items-start gap-2">
          <p class="small text-muted mb-0">
            配置赛事信息、学生端赛事页展示等。
          </p>
          <button type="button" class="btn btn-sm btn-primary" @click="openEventPublicIntro">
            打开赛事详情页面
          </button>
        </div>

        <div class="mt-3 d-flex gap-2 flex-wrap align-items-center">
        </div>

        <div class="row g-3 mt-1">
          <div class="col-12">
            <div class="query-card">
              <div class="k">赛季与轮播图管理</div>
              <div class="d-flex gap-2 flex-wrap align-items-center">
                <button type="button" class="btn btn-sm btn-primary" @click="openEventBannerModal">打开赛季与轮播图管理</button>
                <button type="button" class="btn btn-sm btn-light" @click="loadEventBannersAndEvents" :disabled="eventBannerLoading || eventListLoading">刷新统计</button>
                <span class="small text-muted">赛季数量：{{ eventSeasons.length }}</span>
                <span class="small text-muted">当前赛季轮播图：{{ eventBanners.length }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="query-card mt-3">
          <div class="k">赛事管理</div>
          <div class="d-flex gap-2 flex-wrap align-items-center mb-2">
            <button type="button" class="btn btn-sm btn-primary" @click="openEventEditNew">新增赛事</button>
            <button type="button" class="btn btn-sm btn-light" @click="loadEventList" :disabled="eventListLoading">刷新赛事列表</button>
            <div class="ms-auto d-flex gap-2 flex-wrap align-items-center">
              <div class="small text-muted">当前赛季</div>
              <select v-model.number="eventSeasonSelected" class="form-select form-select-sm" style="min-width: 160px;" @change="loadEventBannersAndEvents">
                <option v-for="s in eventSeasonsEnabled" :key="'ev-season-' + s.year" :value="Number(s.year)">{{ s.year }}年赛季</option>
              </select>
            </div>
          </div>
          <div class="result-shell">
            <table class="table table-striped align-middle modern-table mb-0">
              <thead>
                <tr>
                  <th>赛季</th>
                  <th>标题</th>
                  <th>标签/分类</th>
                  <th>状态</th>
                  <th>排序</th>
                  <th>启用</th>
                  <th style="width: 180px;">操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="e in eventList" :key="'evt-' + e.id">
                  <td>{{ e.seasonYear }}</td>
                  <td>{{ e.title }}</td>
                  <td>
                    <div class="small text-muted">{{ e.category || '-' }}</div>
                    <div class="small">{{ e.tags || '' }}</div>
                  </td>
                  <td>{{ e.status || '-' }}</td>
                  <td>{{ e.sort ?? 0 }}</td>
                  <td>{{ Number(e.enabled) === 1 ? '启用' : '禁用' }}</td>
                  <td>
                    <button type="button" class="btn btn-sm btn-light me-2" @click="openEventEditExisting(e)">编辑</button>
                    <button type="button" class="btn btn-sm btn-danger" @click="deleteEventRow(e)">删除</button>
                  </td>
                </tr>
                <tr v-if="eventList.length === 0">
                  <td colspan="7" class="text-muted">暂无赛事</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <Teleport to="body">
          <div v-if="showEventEditModal" class="modal-mask event-edit-modal-mask" @click.self="closeEventEditModal">
            <div class="modal-panel city-signup-edit-modal" role="dialog" aria-modal="true">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <h5 class="mb-0">{{ eventEditForm.id ? '编辑赛事' : '新增赛事' }}</h5>
                <div class="d-flex gap-2">
                  <button type="button" class="btn btn-sm btn-light" :disabled="!eventEditForm.id" @click="openEventDetailBannerModal">
                    详情轮播图管理
                  </button>
                  <button type="button" class="btn btn-sm btn-light" @click="closeEventEditModal">取消</button>
                  <button type="button" class="btn btn-sm btn-primary" @click="saveEventEdit" :disabled="eventEditSaving">
                    {{ eventEditSaving ? '保存中…' : '保存' }}
                  </button>
                </div>
              </div>
              <div class="city-signup-edit-body-scroll">
                <div class="row g-2">
                  <div class="col-md-3">
                    <label class="form-label small">赛季</label>
                    <select v-model.number="eventEditForm.seasonYear" class="form-select form-select-sm">
                      <option v-for="s in eventSeasonsEnabled" :key="'opt-' + s.year" :value="Number(s.year)">{{ s.year }}年</option>
                    </select>
                  </div>
                  <div class="col-md-6">
                    <label class="form-label small">标题</label>
                    <input v-model="eventEditForm.title" class="form-control form-control-sm" placeholder="赛事标题" />
                  </div>
                  <div class="col-md-3">
                    <label class="form-label small">状态文案</label>
                    <input v-model="eventEditForm.status" class="form-control form-control-sm" placeholder="如：报名中/即将开始" />
                  </div>
                  <div class="col-md-4">
                    <label class="form-label small">分类</label>
                    <div class="d-flex gap-2 mb-2">
                      <input v-model.trim="eventCategoryDraft" class="form-control form-control-sm" placeholder="输入后可新增分类" />
                      <button type="button" class="btn btn-sm btn-light" @click="addEventOption('category')">新增</button>
                    </div>
                    <div class="event-pick-wrap">
                      <label v-for="c in eventCategoryOptions" :key="'ec-' + c" class="event-pick-item">
                        <input
                          type="checkbox"
                          :checked="isEventOptionChecked(eventEditForm.category, c)"
                          @change="toggleEventOption('category', c, $event.target.checked)"
                        />
                        <span>{{ c }}</span>
                        <button type="button" class="btn btn-sm btn-link p-0 text-danger event-pick-remove" @click.prevent="removeEventOption('category', c)">x</button>
                      </label>
                    </div>
                  </div>
                  <div class="col-md-8">
                    <label class="form-label small">标签（可多选）</label>
                    <div class="d-flex gap-2 mb-2">
                      <input v-model.trim="eventTagDraft" class="form-control form-control-sm" placeholder="输入后可新增标签" />
                      <button type="button" class="btn btn-sm btn-light" @click="addEventOption('tags')">新增</button>
                    </div>
                    <div class="event-pick-wrap">
                      <label v-for="t in eventTagOptions" :key="'et-' + t" class="event-pick-item">
                        <input
                          type="checkbox"
                          :checked="isEventOptionChecked(eventEditForm.tags, t)"
                          @change="toggleEventOption('tags', t, $event.target.checked)"
                        />
                        <span>{{ t }}</span>
                        <button type="button" class="btn btn-sm btn-link p-0 text-danger event-pick-remove" @click.prevent="removeEventOption('tags', t)">x</button>
                      </label>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <label class="form-label small">时间文案</label>
                    <input v-model="eventEditForm.timeText" class="form-control form-control-sm" placeholder="如：2026-03 ~ 2026-05" />
                  </div>
                  <div class="col-md-3">
                    <label class="form-label small">排序</label>
                    <input v-model.number="eventEditForm.sort" class="form-control form-control-sm" />
                  </div>
                  <div class="col-md-3">
                    <label class="form-label small">启用</label>
                    <select v-model.number="eventEditForm.enabled" class="form-select form-select-sm">
                      <option :value="1">启用</option>
                      <option :value="0">禁用</option>
                    </select>
                  </div>
                  <div class="col-12">
                    <label class="form-label small">卡片简介（summary）</label>
                    <textarea v-model="eventEditForm.summary" class="form-control form-control-sm" rows="3" placeholder="在赛事卡片中展示的简介"></textarea>
                  </div>
                  <div class="col-12">
                    <label class="form-label small">赛事介绍资料（detail）</label>
                    <div class="d-flex gap-2 flex-wrap align-items-center mb-2">
                      <button type="button" class="btn btn-sm btn-light" @click="openEventDetailRichModal">编辑赛事介绍资料</button>
                      <span class="small text-muted">点击按钮可在弹窗中使用完整富文本功能（含上传图片/文件）</span>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label class="form-label small">参加赛事跳转链接</label>
                    <input v-model="eventEditForm.joinPayload" class="form-control form-control-sm" placeholder="如：https://example.com/signup" />
                  </div>
                  <div class="col-md-6">
                    <label class="form-label small">更多按钮文案</label>
                    <input v-model="eventEditForm.moreButtonText" class="form-control form-control-sm" />
                  </div>
                  <div class="col-12">
                    <label class="form-label small">封面图片（存库）</label>
                    <input type="file" class="form-control form-control-sm" accept="image/*" @change="onEventCoverPicked" />
                    <div class="small text-muted mt-1" v-if="eventEditForm.id">保存赛事后再上传封面也可以。</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Teleport>

        <Teleport to="body">
          <div v-if="showEventDetailRichModal" class="modal-mask event-edit-modal-mask">
            <div class="modal-panel modal-wide" role="dialog" aria-modal="true">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <h5 class="mb-0">编辑赛事介绍资料（detail）</h5>
                <div class="d-flex gap-2">
                  <button type="button" class="btn btn-sm btn-light" @click="closeEventDetailRichModal">关闭</button>
                  <button type="button" class="btn btn-sm btn-primary" @click="applyEventDetailRichModal">应用到赛事</button>
                </div>
              </div>
              <div class="d-flex gap-2 flex-wrap align-items-center mb-2">
                <select v-model="eventDetailFontSize" class="form-select form-select-sm" style="max-width: 120px;" @change="applyEventDetailFontSize">
                  <option value="12">12px</option>
                  <option value="14">14px</option>
                  <option value="16">16px</option>
                  <option value="18">18px</option>
                  <option value="20">20px</option>
                  <option value="24">24px</option>
                  <option value="28">28px</option>
                </select>
                <input v-model="eventDetailTextColor" type="color" class="form-control form-control-color form-control-sm" title="文字颜色" @change="applyEventDetailTextColor" />
                <input v-model="eventDetailBackColor" type="color" class="form-control form-control-color form-control-sm" title="背景颜色" @change="applyEventDetailBackColor" />
                <button type="button" class="btn btn-sm btn-light" @click="applyEventDetailCommand('bold')"><b>B</b></button>
                <button type="button" class="btn btn-sm btn-light" @click="applyEventDetailCommand('italic')"><i>I</i></button>
                <button type="button" class="btn btn-sm btn-light" @click="applyEventDetailCommand('underline')"><u>U</u></button>
                <button type="button" class="btn btn-sm btn-light" @click="applyEventDetailCommand('justifyLeft')">左对齐</button>
                <button type="button" class="btn btn-sm btn-light" @click="applyEventDetailCommand('justifyCenter')">居中</button>
                <button type="button" class="btn btn-sm btn-light" @click="applyEventDetailCommand('justifyRight')">右对齐</button>
                <button type="button" class="btn btn-sm btn-light" @click="applyEventDetailCommand('insertUnorderedList')">无序列表</button>
                <button type="button" class="btn btn-sm btn-light" @click="applyEventDetailCommand('insertOrderedList')">有序列表</button>
                <button type="button" class="btn btn-sm btn-light" @click="triggerEventDetailAssetPick('image')" :disabled="eventDetailAssetUploading">上传图片</button>
                <button type="button" class="btn btn-sm btn-light" @click="triggerEventDetailAssetPick('video')" :disabled="eventDetailAssetUploading">上传视频</button>
                <button type="button" class="btn btn-sm btn-light" @click="triggerEventDetailAssetPick('file')" :disabled="eventDetailAssetUploading">上传文件</button>
                <span class="small text-muted">{{ eventDetailAssetUploading ? '上传中…' : '支持图文混排、空格、换行，保存后按相同样式展示' }}</span>
              </div>
              <input
                ref="eventDetailAssetInput"
                type="file"
                class="d-none"
                @change="onEventDetailAssetPicked"
              />
              <div
                ref="eventDetailEditor"
                class="event-detail-editor form-control"
                contenteditable="true"
                @input="onEventDetailEditorInput"
                @mouseup="saveEventDetailSelection"
                @keyup="saveEventDetailSelection"
              ></div>
            </div>
          </div>
        </Teleport>

        <Teleport to="body">
          <div v-if="showEventBannerModal" class="modal-mask event-edit-modal-mask" @click.self="closeEventBannerModal">
            <div class="modal-panel modal-wide" role="dialog" aria-modal="true">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <h5 class="mb-0">赛季与轮播图管理</h5>
                <button type="button" class="btn btn-sm btn-light" @click="closeEventBannerModal">关闭</button>
              </div>
              <div style="max-height: 74vh; overflow:auto;">
                <div class="query-card mb-3">
                  <div class="k">赛季管理</div>
                  <div class="d-flex gap-2 flex-wrap align-items-center">
                    <input v-model.number="eventSeasonForm.year" class="form-control form-control-sm" placeholder="赛季年份，如 2026" style="max-width: 170px;" />
                    <input v-model="eventSeasonForm.seasonName" class="form-control form-control-sm" placeholder="赛季名称（可选）" />
                  </div>
                  <div class="d-flex gap-2 flex-wrap align-items-center mt-2">
                    <select v-model.number="eventSeasonForm.enabled" class="form-select form-select-sm" style="max-width: 140px;">
                      <option :value="1">启用</option>
                      <option :value="0">禁用</option>
                    </select>
                    <input v-model.number="eventSeasonForm.sort" class="form-control form-control-sm" placeholder="排序（大在前）" style="max-width: 140px;" />
                    <button type="button" class="btn btn-sm btn-primary" @click="saveEventSeason" :disabled="eventSeasonSaving">
                      {{ eventSeasonSaving ? '保存中…' : '保存赛季' }}
                    </button>
                  </div>
                  <div class="mt-2 small text-muted">已配置赛季：{{ eventSeasons.length }}</div>
                  <div class="mt-2" style="max-height: 220px; overflow:auto;">
                    <div v-for="s in eventSeasons" :key="'srow-modal-' + s.year" class="d-flex align-items-center justify-content-between gap-2 py-1 border-bottom border-secondary-subtle">
                      <div class="small">
                        <strong>{{ s.year }}</strong> <span class="text-muted">{{ s.seasonName || '' }}</span>
                        <span class="badge text-bg-light border ms-2">{{ Number(s.enabled) === 1 ? '启用' : '禁用' }}</span>
                      </div>
                      <div class="btn-group btn-group-sm">
                        <button type="button" class="btn btn-light" @click="editEventSeasonRow(s)">编辑</button>
                        <button type="button" class="btn btn-danger" @click="deleteEventSeasonRow(s)">删除</button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="query-card">
                  <div class="k">轮播图管理（图片存库）</div>
                <div class="d-flex gap-2 flex-wrap align-items-center mb-2">
                  <input ref="eventBannerFileInput" type="file" class="form-control form-control-sm" multiple accept="image/*" @change="onEventBannerFilesPicked" />
                  <button type="button" class="btn btn-sm btn-primary" @click="triggerEventBannerPick">上传轮播图</button>
                  <button type="button" class="btn btn-sm btn-light" @click="loadEventBanners" :disabled="eventBannerLoading">刷新列表</button>
                  <button type="button" class="btn btn-sm btn-success" @click="saveEventBannerOrder" :disabled="eventBannerSavingOrder || eventBanners.length === 0">
                    {{ eventBannerSavingOrder ? '保存排序中…' : '保存当前排序' }}
                  </button>
                </div>
                <div class="small text-muted mb-2">支持拖拽卡片调整顺序（越靠前 sort 越大）；可保存单张或一键保存当前顺序。</div>
                <div class="row g-2">
                  <div
                    v-for="(b, idx) in eventBanners"
                    :key="'banner-modal-' + b.id"
                    class="col-12 col-md-6"
                    draggable="true"
                    @dragstart="onEventBannerDragStart(idx)"
                    @dragend="onEventBannerDragEnd"
                    @dragenter.prevent="onEventBannerDragEnter(idx)"
                    @dragover.prevent
                    @dragleave="onEventBannerDragLeave(idx)"
                    @drop="onEventBannerDrop(idx)"
                  >
                    <div
                      class="border rounded p-2 h-100"
                      :style="{
                        cursor: 'grab',
                        borderStyle: eventBannerDragOverIndex === idx ? 'dashed' : 'solid',
                        borderColor: eventBannerDragOverIndex === idx ? '#2563eb' : '',
                        background: eventBannerDragOverIndex === idx ? 'rgba(37,99,235,0.06)' : ''
                      }"
                    >
                      <div class="d-flex gap-2">
                        <img :src="b.imageUrl" alt="banner" style="width: 140px; height: 82px; object-fit: cover; border-radius: 8px;" />
                        <div class="flex-grow-1">
                          <input v-model="b.title" class="form-control form-control-sm mb-1" placeholder="标题" />
                          <input v-model="b.subtitle" class="form-control form-control-sm mb-1" placeholder="副标题" />
                          <div class="d-flex gap-2 align-items-center">
                            <input v-model.number="b.sort" class="form-control form-control-sm" placeholder="排序（大在前）" />
                            <select v-model.number="b.enabled" class="form-select form-select-sm" style="max-width: 110px;">
                              <option :value="1">启用</option>
                              <option :value="0">禁用</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex justify-content-end gap-2 mt-2">
                        <button type="button" class="btn btn-sm btn-light" @click="saveEventBannerMeta(b)">保存</button>
                        <button type="button" class="btn btn-sm btn-danger" @click="deleteEventBannerRow(b)">删除</button>
                      </div>
                    </div>
                  </div>
                  <div v-if="eventBanners.length === 0" class="text-muted small">暂无轮播图，请先上传。</div>
                </div>
                </div>
              </div>
            </div>
          </div>
        </Teleport>

        <Teleport to="body">
          <div v-if="showEventDetailBannerModal" class="modal-mask event-edit-modal-mask" @click.self="closeEventDetailBannerModal">
            <div class="modal-panel modal-wide" role="dialog" aria-modal="true">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <h5 class="mb-0">赛事详情轮播图管理 · {{ eventEditForm.title || '-' }}</h5>
                <button type="button" class="btn btn-sm btn-light" @click="closeEventDetailBannerModal">关闭</button>
              </div>
              <div style="max-height: 72vh; overflow:auto;">
                <div class="d-flex gap-2 flex-wrap align-items-center mb-2">
                  <input ref="eventDetailBannerFileInput" type="file" class="form-control form-control-sm" multiple accept="image/*" @change="onEventDetailBannerFilesPicked" />
                  <button type="button" class="btn btn-sm btn-primary" @click="triggerEventDetailBannerPick">上传详情轮播图</button>
                  <button type="button" class="btn btn-sm btn-light" @click="loadEventDetailBanners" :disabled="eventDetailBannerLoading">刷新列表</button>
                  <button type="button" class="btn btn-sm btn-success" @click="saveEventDetailBannerOrder" :disabled="eventDetailBannerSavingOrder || eventDetailBanners.length === 0">
                    {{ eventDetailBannerSavingOrder ? '保存排序中…' : '保存当前排序' }}
                  </button>
                </div>
                <div class="small text-muted mb-2">样式与赛事介绍页轮播一致；支持拖拽排序、保存、删除。</div>
                <div class="row g-2">
                  <div
                    v-for="(b, idx) in eventDetailBanners"
                    :key="'detail-banner-modal-' + b.id"
                    class="col-12 col-md-6"
                    draggable="true"
                    @dragstart="onEventDetailBannerDragStart(idx)"
                    @dragend="onEventDetailBannerDragEnd"
                    @dragenter.prevent="onEventDetailBannerDragEnter(idx)"
                    @dragover.prevent
                    @dragleave="onEventDetailBannerDragLeave(idx)"
                    @drop="onEventDetailBannerDrop(idx)"
                  >
                    <div
                      class="border rounded p-2 h-100"
                      :style="{
                        cursor: 'grab',
                        borderStyle: eventDetailBannerDragOverIndex === idx ? 'dashed' : 'solid',
                        borderColor: eventDetailBannerDragOverIndex === idx ? '#2563eb' : '',
                        background: eventDetailBannerDragOverIndex === idx ? 'rgba(37,99,235,0.06)' : ''
                      }"
                    >
                      <div class="d-flex gap-2">
                        <img :src="b.imageUrl" alt="detail-banner" style="width: 140px; height: 82px; object-fit: cover; border-radius: 8px;" />
                        <div class="flex-grow-1">
                          <input v-model="b.title" class="form-control form-control-sm mb-1" placeholder="标题" />
                          <input v-model="b.subtitle" class="form-control form-control-sm mb-1" placeholder="副标题" />
                          <div class="d-flex gap-2 align-items-center">
                            <input v-model.number="b.sort" class="form-control form-control-sm" placeholder="排序（大在前）" />
                            <select v-model.number="b.enabled" class="form-select form-select-sm" style="max-width: 110px;">
                              <option :value="1">启用</option>
                              <option :value="0">禁用</option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex justify-content-end gap-2 mt-2">
                        <button type="button" class="btn btn-sm btn-light" @click="saveEventDetailBannerMeta(b)">保存</button>
                        <button type="button" class="btn btn-sm btn-danger" @click="deleteEventDetailBannerRow(b)">删除</button>
                      </div>
                    </div>
                  </div>
                  <div v-if="eventDetailBanners.length === 0" class="text-muted small">暂无详情轮播图，请先上传。</div>
                </div>
              </div>
            </div>
          </div>
        </Teleport>
      </section>

      <section class="card-box" v-if="activeMenu === 'citySignup'">
        <h4>地市考试报名系统</h4>
        <p class="small text-muted mb-3">可配置地市考试场次，并为每个场次自动生成一个独立报名地址。</p>
        <div class="d-flex flex-wrap gap-2 mb-3 city-signup-toolbar" role="group" aria-label="地市报名场次与项目">
          <button
            class="btn btn-primary"
            type="button"
            :class="{ active: citySignupTab === 'signup' }"
            @click="citySignupTab = 'signup'"
          >
            场次管理
          </button>
          <button
            class="btn btn-primary"
            type="button"
            :class="{ active: citySignupTab === 'project' }"
            @click="openCitySignupProjectTab"
          >
            项目管理
          </button>
          <button
            v-if="citySignupTab === 'signup'"
            class="btn btn-primary"
            type="button"
            @click="openCreateCitySignupModal"
          >
            新建场次
          </button>
          <button
            v-if="citySignupTab === 'signup'"
            class="btn btn-light border"
            type="button"
            @click="loadCitySignups"
          >
            刷新列表
          </button>
          <button v-if="citySignupTab === 'project'" class="btn btn-light border" type="button" @click="loadCityProjects">
            刷新项目
          </button>
        </div>

        <div v-if="citySignupTab === 'signup'" class="result-shell mb-3">
          <div class="row g-2 align-items-end mb-2">
            <div class="col-md-3 col-lg-2">
              <label class="form-label mb-1 small text-muted">赛事场次</label>
              <input
                v-model.trim="citySignupListFilters.examNameLike"
                class="form-control form-control-sm"
                placeholder="名称模糊查询"
                @keyup.enter="searchCitySignupList"
              />
            </div>
            <div class="col-md-2 col-lg-2">
              <label class="form-label mb-1 small text-muted">省份</label>
              <select v-model="citySignupListFilters.province" class="form-select form-select-sm">
                <option value="">全部</option>
                <option v-for="p in provinceOptions" :key="'cs-filter-p-' + p" :value="p">{{ p }}</option>
              </select>
            </div>
            <div class="col-md-2 col-lg-2">
              <label class="form-label mb-1 small text-muted">地市</label>
              <select
                v-model="citySignupListFilters.city"
                class="form-select form-select-sm"
                :disabled="!citySignupListFilters.province"
              >
                <option value="">全部</option>
                <option v-for="c in citySignupListFilterCityOptions" :key="'cs-filter-c-' + c" :value="c">{{ c }}</option>
              </select>
            </div>
            <div class="col-md-2 col-lg-2">
              <label class="form-label mb-1 small text-muted">是否开考</label>
              <select v-model="citySignupListFilters.examPhase" class="form-select form-select-sm">
                <option value="">全部</option>
                <option value="before_exam">未开考</option>
                <option value="after_exam">已开考</option>
              </select>
            </div>
            <div class="col-md-2 col-lg-2">
              <label class="form-label mb-1 small text-muted">状态</label>
              <select v-model="citySignupListFilters.status" class="form-select form-select-sm">
                <option value="">全部</option>
                <option value="1">开启</option>
                <option value="0">关闭</option>
              </select>
            </div>
            <div class="col-md-12 col-lg-2 d-flex flex-wrap gap-2">
              <button class="btn btn-sm btn-primary" type="button" @click="searchCitySignupList">查询</button>
              <button class="btn btn-sm btn-light" type="button" @click="resetCitySignupListFilters">重置</button>
            </div>
          </div>
        </div>

        <div v-if="citySignupTab === 'signup'" class="result-shell">
          <table class="table table-striped align-middle modern-table city-signup-session-table">
            <thead>
              <tr>
                <th>场次</th>
                <th>赛事举办地区</th>
                <th>横幅</th>
                <th>报名时间</th>
                <th>报名链接</th>
                <th>考前信息</th>
                <th>赛事介绍</th>
                <th class="city-signup-project-col">项目分类</th>
                <th>自动考试账号</th>
                <th>状态</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in citySignupRows" :key="'city-sign-' + row.id">
                <td class="city-signup-name-cell" :title="row.examName || ''">{{ row.examName || '-' }}</td>
                <td>{{ row.province || '-' }} {{ row.city || '' }}</td>
                <td>
                  <div class="city-signup-banner-thumb">
                    <template v-if="citySignupRowBannerUrl(row)">
                      <img
                        v-if="isCitySignupBannerLoaded(row)"
                        :src="citySignupRowBannerUrl(row)"
                        alt="banner-thumb"
                        loading="lazy"
                      />
                      <button
                        v-else
                        class="btn btn-sm btn-outline-primary city-signup-banner-load-btn"
                        type="button"
                        @click="loadCitySignupBanner(row)"
                      >
                        加载横幅
                      </button>
                    </template>
                    <div v-else class="city-signup-banner-thumb--empty">无</div>
                  </div>
                </td>
                <td>{{ $fmtDateTime(row.signupStartTime) }} ~ {{ $fmtDateTime(row.signupEndTime) }}</td>
                <td class="city-signup-cell-stack city-signup-link-cell-td">
                  <button
                    class="btn btn-sm btn-outline-primary text-nowrap"
                    type="button"
                    @click="copyCitySignupLink(row)"
                  >
                    复制链接
                  </button>
                </td>
                <td class="city-signup-cell-stack">
                  <div class="city-signup-action-stack">
                    <div class="city-signup-one-line small text-muted" :title="citySignupPreInfoSnippet(row)">
                      {{ citySignupPreInfoSnippet(row) }}
                    </div>
                    <button class="btn btn-sm btn-outline-primary" type="button" @click="openCitySignupPreInfoModal(row)">
                      修改考试悉知
                    </button>
                  </div>
                </td>
                <td class="city-signup-cell-stack">
                  <div class="city-signup-action-stack">
                    <div class="city-signup-one-line small text-muted" :title="citySignupEventIntroSnippet(row)">
                      {{ citySignupEventIntroSnippet(row) }}
                    </div>
                    <button class="btn btn-sm btn-outline-primary" type="button" @click="openCitySignupEventIntroModal(row)">
                      编辑赛事介绍
                    </button>
                  </div>
                </td>
                <td class="city-signup-project-col city-signup-cell-stack">
                  <div class="city-signup-action-stack">
                    <div class="city-signup-one-line city-signup-one-line--narrow small text-muted" :title="citySignupProjectSummary(row)">
                      {{ citySignupProjectSummary(row) }}
                    </div>
                    <button class="btn btn-sm btn-outline-primary" type="button" @click="openCitySignupProjectModal(row)">
                      管理赛项
                    </button>
                  </div>
                </td>
                <td class="city-signup-cell-stack">
                  <div class="city-signup-action-stack">
                    <div
                      class="city-signup-one-line small text-muted"
                      :title="'当前：' + (Number(row.autoGenerateExamAccount) === 1 ? '是' : '否')"
                    >
                      当前：{{ Number(row.autoGenerateExamAccount) === 1 ? '是' : '否' }}
                    </div>
                    <button
                      class="btn btn-sm btn-outline-primary text-nowrap"
                      type="button"
                      @click="openCitySignupAutoAccountModal(row)"
                    >
                      设置自动生成账号
                    </button>
                  </div>
                </td>
                <td>{{ Number(row.status) === 1 ? '开启' : '关闭' }}</td>
                <td>
                  <div class="city-signup-action-grid">
                    <button class="btn btn-sm btn-primary city-signup-action-btn" type="button" @click="editCitySignup(row)">编辑</button>
                    <button class="btn btn-sm btn-primary city-signup-action-btn" type="button" @click="openCitySignupEntries(row)">报名名单</button>
                    <button class="btn btn-sm btn-primary city-signup-action-btn" type="button" @click="openCitySignupLink(row)">打开网址</button>
                    <button class="btn btn-sm btn-danger city-signup-action-btn city-signup-danger-btn" type="button" @click="deleteCitySignup(row)">删除</button>
                  </div>
                </td>
              </tr>
              <tr v-if="citySignupRows.length === 0">
                <td colspan="11" class="text-muted">{{ citySignupListEmptyHint }}</td>
              </tr>
            </tbody>
          </table>
          <div class="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-2 pt-2 border-top">
            <div class="small text-muted">
              共 {{ citySignupTotalElements }} 条，第 {{ citySignupPage + 1 }} / {{ citySignupTotalPages }} 页
            </div>
            <div class="d-flex flex-wrap align-items-center gap-2">
              <label class="small text-muted mb-0 d-flex align-items-center gap-1">
                每页
                <select v-model.number="citySignupPageSize" class="form-select form-select-sm" style="width: auto" @change="onCitySignupPageSizeChange">
                  <option :value="10">10</option>
                  <option :value="15">15</option>
                  <option :value="20">20</option>
                  <option :value="50">50</option>
                </select>
                条
              </label>
              <button
                type="button"
                class="btn btn-sm btn-light"
                :disabled="citySignupPage <= 0"
                @click="goCitySignupPage(citySignupPage - 1)"
              >
                上一页
              </button>
              <button
                type="button"
                class="btn btn-sm btn-light"
                :disabled="citySignupPage >= citySignupTotalPages - 1"
                @click="goCitySignupPage(citySignupPage + 1)"
              >
                下一页
              </button>
            </div>
          </div>
        </div>

        <div v-else class="result-shell">
          <div class="row g-2 align-items-end mb-2">
            <div class="col-md-6">
              <label class="form-label mb-1">项目命名（可新增/删减）：</label>
              <input v-model.trim="cityProjectForm.projectName" class="form-control" placeholder="例如：信息学竞赛 / 英语口语 / 数学思维" />
            </div>
            <div class="col-md-2">
              <button class="btn btn-primary w-100" type="button" :disabled="cityProjectSaving" @click="createCityProject">
                {{ cityProjectSaving ? '保存中...' : '新增项目' }}
              </button>
            </div>
          </div>

          <table class="table table-striped align-middle modern-table">
            <thead>
              <tr>
                <th style="width: 90px;">ID</th>
                <th>项目名称</th>
                <th style="width: 120px;">状态</th>
                <th style="width: 140px;">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="p in cityProjectRows" :key="'city-proj-' + p.id">
                <td>{{ p.id }}</td>
                <td>{{ p.projectName || '-' }}</td>
                <td>{{ Number(p.status) === 1 ? '启用' : '停用' }}</td>
                <td>
                  <div class="d-flex gap-1">
                    <button class="btn btn-sm btn-light" type="button" @click="toggleCityProjectStatus(p)">
                      {{ Number(p.status) === 1 ? '停用' : '启用' }}
                    </button>
                    <button class="btn btn-sm btn-danger" type="button" @click="deleteCityProject(p)">删除</button>
                  </div>
                </td>
              </tr>
              <tr v-if="cityProjectRows.length === 0">
                <td colspan="4" class="text-muted">暂无项目，请先新增。</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section class="card-box ticket-login-host-card" v-if="activeMenu === 'cityPaperManage'">
        <h4 class="mb-2">地市试卷设置管理</h4>
        <p class="small text-muted mb-3 ticket-login-host-desc">
          按参赛场次与赛项筛选学生，批量创建考试并分配参考人员。
        </p>
        <AdminCityPaperManageView :embedded="true" />
      </section>

      <section class="card-box ticket-login-host-card" v-if="activeMenu === 'questionManage'">
        <h4 class="mb-2">题库管理</h4>
        <p class="small text-muted mb-3 ticket-login-host-desc">
          管理员可查看、编辑全部题库（含各教师创建与私密题库），支持按创建人、私密状态筛选。
        </p>
        <TeacherQuestionManageView :embedded="true" />
      </section>

      <section class="card-box ticket-login-host-card" v-if="activeMenu === 'ticketLoginPageManage'">
        <h4 class="mb-2">准考证登录管理</h4>
        <p class="small text-muted mb-3 ticket-login-host-desc">
          配置登录页、批量生成准考证，并与学生账号关联。
        </p>
        <AdminTicketLoginPageManageView :embedded="true" />
      </section>
    </main>

    <div v-if="showCitySignupPreInfoModal" class="modal-mask" @click.self="closeCitySignupPreInfoModal">
      <div class="modal-panel modal-wide">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h5 class="mb-0">修改考试悉知 · {{ citySignupPreInfoTitle }}</h5>
          <div class="d-flex gap-2">
            <button class="btn btn-sm btn-primary" type="button" :disabled="citySignupPreInfoSaving" @click="saveCitySignupPreInfo">
              {{ citySignupPreInfoSaving ? '保存中...' : '保存' }}
            </button>
            <button class="btn btn-sm btn-light" type="button" :disabled="citySignupPreInfoSaving" @click="closeCitySignupPreInfoModal">关闭</button>
          </div>
        </div>
        <textarea v-model="citySignupPreInfoText" class="form-control" rows="14" placeholder="填写考前信息/考试注意事项（支持多行）"></textarea>
        <div class="small text-muted mt-2">
          提示：保存后，学生端“考前信息”弹窗会展示这里的内容。
        </div>
      </div>
    </div>

    <div v-if="showCitySignupEventIntroModal" class="modal-mask" @click.self="closeCitySignupEventIntroModal">
      <div class="modal-panel modal-wide">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h5 class="mb-0">编辑赛事介绍 · {{ citySignupEventIntroTitle }}</h5>
          <div class="d-flex gap-2">
            <button class="btn btn-sm btn-primary" type="button" :disabled="citySignupEventIntroSaving" @click="saveCitySignupEventIntro">
              {{ citySignupEventIntroSaving ? '保存中...' : '保存' }}
            </button>
            <button class="btn btn-sm btn-light" type="button" :disabled="citySignupEventIntroSaving" @click="closeCitySignupEventIntroModal">关闭</button>
          </div>
        </div>
        <textarea v-model="citySignupEventIntroText" class="form-control" rows="12" placeholder="填写赛事介绍内容（支持多行）"></textarea>
        <div class="small text-muted mt-2">
          提示：保存后，学生端将在“报名时间/考试时间”下方展示该赛事介绍。
        </div>
      </div>
    </div>

    <div v-if="showCitySignupProjectModal" class="modal-mask" @click.self="closeCitySignupProjectModal">
      <div class="modal-panel modal-wide">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h5 class="mb-0">赛项管理 · {{ citySignupProjectTitle }}</h5>
          <div class="d-flex gap-2">
            <button class="btn btn-sm btn-primary" type="button" :disabled="citySignupProjectSaving" @click="saveCitySignupProjects">
              {{ citySignupProjectSaving ? '保存中...' : '保存' }}
            </button>
            <button class="btn btn-sm btn-light" type="button" :disabled="citySignupProjectSaving" @click="closeCitySignupProjectModal">关闭</button>
          </div>
        </div>
        <div class="city-signup-project-pick-wrap">
          <label
            v-for="p in cityProjectRows.filter((x) => Number(x.status) === 1)"
            :key="'city-signup-modal-pick-' + p.id"
            class="city-signup-project-pick"
          >
            <input
              v-model="citySignupProjectSelected"
              type="checkbox"
              :value="String(p.projectName || '').trim()"
            />
            <span>{{ p.projectName || '-' }}</span>
          </label>
          <span v-if="cityProjectRows.filter((x) => Number(x.status) === 1).length === 0" class="small text-muted">
            暂无启用项目，请先到“项目管理”中新增并启用项目。
          </span>
        </div>
      </div>
    </div>

    <div v-if="showCitySignupEntryModal" class="modal-mask" @click.self="closeCitySignupEntries">
      <div class="modal-panel modal-wide">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h5 class="mb-0">报名名单 · {{ citySignupEntryTitle }}</h5>
          <div class="d-flex flex-wrap gap-2 align-items-center">
            <label class="small d-flex align-items-center mb-0 px-2">
              <input v-model="citySignupExportMaskIdCard" type="checkbox" class="me-1" />
              导出时对身份证号脱敏
            </label>
            <button class="btn btn-sm btn-outline-secondary" type="button" @click="exportCitySignupEntriesCsv">导出Excel(CSV)</button>
            <button class="btn btn-sm btn-light" type="button" @click="closeCitySignupEntries">关闭</button>
          </div>
        </div>
        <div class="row g-2 mb-2">
          <div class="col-md-3">
            <input v-model.trim="citySignupEntryFilters.candidateName" class="form-control form-control-sm" placeholder="姓名" />
          </div>
          <div class="col-md-3">
            <input v-model.trim="citySignupEntryFilters.idCard" class="form-control form-control-sm" placeholder="身份证号" />
          </div>
          <div class="col-md-2">
            <select v-model="citySignupEntryFilters.projectName" class="form-select form-select-sm">
              <option value="">全部项目</option>
              <option v-for="p in cityProjectRows.filter((x) => Number(x.status) === 1)" :key="'entry-filter-proj-m-' + p.id" :value="p.projectName">
                {{ p.projectName }}
              </option>
            </select>
          </div>
          <div class="col-md-2">
            <select v-model="citySignupEntryFilters.status" class="form-select form-select-sm">
              <option value="">全部状态</option>
              <option :value="1">待审</option>
              <option :value="2">通过</option>
              <option :value="0">驳回</option>
            </select>
          </div>
          <div class="col-md-1">
            <button class="btn btn-sm btn-light w-100" type="button" @click="loadCitySignupEntries">筛选</button>
          </div>
          <div class="col-md-1">
            <input v-model.trim="citySignupReviewNote" class="form-control form-control-sm" placeholder="审核备注(可选)" />
          </div>
        </div>
        <div class="row g-2 mb-2">
          <div class="col-12 d-flex flex-wrap gap-2 align-items-center">
            <button
              class="btn btn-sm btn-success"
              type="button"
              :disabled="citySignupBatchReviewing || citySignupBatchSelectedPendingCount === 0"
              @click="batchApproveCitySignupSelected"
            >
              {{ citySignupBatchReviewing ? '处理中…' : `批量同意(${citySignupBatchSelectedPendingCount})` }}
            </button>
            <button
              class="btn btn-sm btn-outline-success"
              type="button"
              :disabled="citySignupBatchReviewing"
              @click="approveAllPendingCitySignupEntries"
            >
              全部同意
            </button>
            <span class="small text-muted">「全部同意」将处理本场次全部待审记录（含当前筛选条件以外的待审）。</span>
          </div>
        </div>
        <div class="result-shell">
          <table class="table table-striped align-middle modern-table">
            <thead>
              <tr>
                <th style="width: 2.25rem" class="text-center">
                  <input
                    type="checkbox"
                    :checked="citySignupAllPendingSelected"
                    :disabled="citySignupPendingIdsOnPage.length === 0"
                    title="全选当前列表中的待审"
                    @change="onCitySignupSelectAllPending($event)"
                  />
                </th>
                <th>姓名</th>
                <th>性别</th>
                <th>身份证号</th>
                <th>联系电话</th>
                <th>省市</th>
                <th>学校/年级</th>
                <th>项目分类</th>
                <th>状态</th>
                <th>审核备注</th>
                <th>提交时间</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in citySignupEntryRowsPaged" :key="'city-entry-' + row.id">
                <td class="text-center">
                  <input
                    type="checkbox"
                    :checked="citySignupEntrySelectedIds.includes(Number(row.id))"
                    :disabled="Number(row.status) !== 1"
                    @change="onCitySignupEntryRowCheck(row, $event)"
                  />
                </td>
                <td>{{ row.candidateName || '-' }}</td>
                <td>{{ row.gender || '-' }}</td>
                <td>{{ row.idCard || '-' }}</td>
                <td>{{ row.phone || '-' }}</td>
                <td>{{ row.province || '-' }} {{ row.city || '' }}</td>
                <td>{{ row.schoolName || '-' }} {{ row.gradeName ? ` / ${row.gradeName}` : '' }}</td>
                <td>{{ row.projectName || '-' }}</td>
                <td>{{ citySignupEntryStatusText(row.status) }}</td>
                <td>{{ row.reviewNote || '-' }}</td>
                <td>{{ $fmtDateTime(row.createTime) }}</td>
                <td>
                  <div class="d-flex gap-1 city-entry-action-nowrap">
                    <button class="btn btn-sm btn-warning" type="button" @click="openCitySignupEntryEdit(row)">编辑</button>
                    <button class="btn btn-sm btn-success" type="button" @click="reviewCitySignupEntry(row, 2)">通过</button>
                    <button class="btn btn-sm btn-danger" type="button" @click="reviewCitySignupEntry(row, 0)">驳回</button>
                  </div>
                </td>
              </tr>
              <tr v-if="citySignupEntryRowsPaged.length === 0">
                <td colspan="12" class="text-muted">暂无报名数据</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          v-if="citySignupEntryTotalElements > 0"
          class="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-3 pt-2 border-top border-secondary-subtle"
        >
          <div class="small text-muted">
            共 {{ citySignupEntryTotalElements }} 条，每页 {{ citySignupEntryPageSize }} 条，第
            {{ citySignupEntryPage + 1 }} / {{ citySignupEntryTotalPages }} 页
          </div>
          <div class="btn-group">
            <button type="button" class="btn btn-sm btn-light" :disabled="citySignupEntryPage <= 0" @click="goCitySignupEntryPage(0)">
              首页
            </button>
            <button
              type="button"
              class="btn btn-sm btn-light"
              :disabled="citySignupEntryPage <= 0"
              @click="goCitySignupEntryPage(citySignupEntryPage - 1)"
            >
              上一页
            </button>
            <button
              type="button"
              class="btn btn-sm btn-light"
              :disabled="citySignupEntryPage >= citySignupEntryTotalPages - 1"
              @click="goCitySignupEntryPage(citySignupEntryPage + 1)"
            >
              下一页
            </button>
            <button
              type="button"
              class="btn btn-sm btn-light"
              :disabled="citySignupEntryPage >= citySignupEntryTotalPages - 1"
              @click="goCitySignupEntryPage(citySignupEntryTotalPages - 1)"
            >
              末页
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showCitySignupEntryEditModal" class="modal-mask" @click.self="closeCitySignupEntryEditModal">
      <div class="modal-panel modal-wide">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h5 class="mb-0">编辑参赛学生 · {{ citySignupEntryEditForm.candidateName || '—' }}</h5>
          <button class="btn btn-sm btn-light" type="button" :disabled="citySignupEntryEditSaving" @click="closeCitySignupEntryEditModal">
            关闭
          </button>
        </div>
        <div class="row g-2">
          <div class="col-md-3">
            <label class="form-label mb-1 small text-muted">姓名</label>
            <input v-model.trim="citySignupEntryEditForm.candidateName" class="form-control form-control-sm" />
          </div>
          <div class="col-md-2">
            <label class="form-label mb-1 small text-muted">性别</label>
            <select v-model="citySignupEntryEditForm.gender" class="form-select form-select-sm">
              <option value="">—</option>
              <option value="男">男</option>
              <option value="女">女</option>
              <option value="未知">未知</option>
            </select>
          </div>
          <div class="col-md-3">
            <label class="form-label mb-1 small text-muted">身份证号</label>
            <input v-model.trim="citySignupEntryEditForm.idCard" class="form-control form-control-sm" />
          </div>
          <div class="col-md-2">
            <label class="form-label mb-1 small text-muted">联系电话</label>
            <input v-model.trim="citySignupEntryEditForm.phone" class="form-control form-control-sm" />
          </div>
          <div class="col-md-2">
            <label class="form-label mb-1 small text-muted">年级</label>
            <select v-model="citySignupEntryEditForm.gradeName" class="form-select form-select-sm">
              <option value="">请选择</option>
              <option v-for="g in citySignupGradeOptions" :key="'entry-edit-grade-' + g" :value="g">{{ g }}</option>
            </select>
          </div>
          <div class="col-md-3">
            <label class="form-label mb-1 small text-muted">省份</label>
            <select v-model="citySignupEntryEditForm.province" class="form-select form-select-sm">
              <option value="">请选择</option>
              <option v-for="p in provinceOptions" :key="'entry-edit-p-' + p" :value="p">{{ p }}</option>
            </select>
          </div>
          <div class="col-md-3">
            <label class="form-label mb-1 small text-muted">地市</label>
            <select v-model="citySignupEntryEditForm.city" class="form-select form-select-sm" :disabled="!citySignupEntryEditForm.province">
              <option value="">请选择</option>
              <option v-for="c in citySignupEntryEditCityOptions" :key="'entry-edit-c-' + c" :value="c">{{ c }}</option>
            </select>
          </div>
          <div class="col-md-3">
            <label class="form-label mb-1 small text-muted">学校</label>
            <input v-model.trim="citySignupEntryEditForm.schoolName" class="form-control form-control-sm" />
          </div>
          <div class="col-md-3">
            <label class="form-label mb-1 small text-muted">赛项（报名项目）</label>
            <select v-model="citySignupEntryEditForm.projectName" class="form-select form-select-sm">
              <option value="">请选择</option>
              <option
                v-if="
                  citySignupEntryEditForm.projectName &&
                  !cityProjectRows.some(
                    (x) => String(x.projectName || '').trim() === String(citySignupEntryEditForm.projectName || '').trim()
                  )
                "
                :value="citySignupEntryEditForm.projectName"
              >
                {{ citySignupEntryEditForm.projectName }}（当前）
              </option>
              <option v-for="p in cityProjectRows.filter((x) => Number(x.status) === 1)" :key="'entry-edit-proj-' + p.id" :value="p.projectName">
                {{ p.projectName }}
              </option>
            </select>
          </div>
          <div class="col-md-12">
            <label class="form-label mb-1 small text-muted">备注</label>
            <input v-model.trim="citySignupEntryEditForm.remark" class="form-control form-control-sm" />
          </div>
          <div class="col-12" v-if="citySignupEntryEditForm.generatedUserId">
            <hr class="my-2" />
            <div class="small text-muted mb-2">已生成考试登录账号时可修改登录账号与密码（密码留空表示不修改）。</div>
            <div class="row g-2">
              <div class="col-md-4">
                <label class="form-label mb-1 small text-muted">考试登录账号</label>
                <input v-model.trim="citySignupEntryEditForm.examUsername" class="form-control form-control-sm" autocomplete="off" />
              </div>
              <div class="col-md-4">
                <label class="form-label mb-1 small text-muted">新密码（可选）</label>
                <input
                  v-model.trim="citySignupEntryEditForm.password"
                  type="password"
                  class="form-control form-control-sm"
                  placeholder="留空则不修改"
                  autocomplete="new-password"
                />
              </div>
            </div>
          </div>
          <div v-else class="col-12 small text-muted">该报名记录未关联自动生成的学生账号，无法在此修改登录账号与密码。</div>
        </div>
        <div class="d-flex justify-content-end gap-2 mt-3">
          <button class="btn btn-light" type="button" :disabled="citySignupEntryEditSaving" @click="closeCitySignupEntryEditModal">取消</button>
          <button class="btn btn-primary" type="button" :disabled="citySignupEntryEditSaving" @click="saveCitySignupEntryEdit">
            {{ citySignupEntryEditSaving ? '保存中…' : '保存' }}
          </button>
        </div>
      </div>
    </div>

    <div v-if="showCitySignupEditModal" class="modal-mask" @click.self="closeCitySignupEditModal">
      <div class="modal-panel city-signup-edit-modal">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h5 class="mb-0">{{ citySignupForm.id ? '编辑场次' : '新建场次' }}</h5>
          <button class="btn btn-sm btn-light" type="button" @click="closeCitySignupEditModal">关闭</button>
        </div>
        <div class="row g-2">
          <div class="col-md-6">
            <label class="form-label mb-1">考试场次名称：<span v-if="!citySignupFieldOk('examName')" class="text-danger">*</span></label>
            <input v-model.trim="citySignupForm.examName" class="form-control" placeholder="如：2026年春季信息学竞赛" />
          </div>
          <div class="col-md-3">
            <label class="form-label mb-1">省份：<span v-if="!citySignupFieldOk('province')" class="text-danger">*</span></label>
            <select v-model="citySignupForm.province" class="form-select">
              <option value="">省份</option>
              <option v-for="p in provinceOptions" :key="'cs-modal-p-' + p" :value="p">{{ p }}</option>
            </select>
          </div>
          <div class="col-md-3">
            <label class="form-label mb-1">地市：<span v-if="!citySignupFieldOk('city')" class="text-danger">*</span></label>
            <select v-model="citySignupForm.city" class="form-select" :disabled="!citySignupForm.province">
              <option value="">地市</option>
              <option v-for="c in citySignupCityOptions" :key="'cs-modal-c-' + c" :value="c">{{ c }}</option>
            </select>
          </div>
          <div class="col-md-4">
            <label class="form-label mb-1">项目负责人：<span v-if="!citySignupFieldOk('principalName')" class="text-danger">*</span></label>
            <input v-model.trim="citySignupForm.principalName" class="form-control" placeholder="负责人姓名" />
          </div>
          <div class="col-md-4">
            <label class="form-label mb-1">负责人电话：<span v-if="!citySignupFieldOk('principalPhone')" class="text-danger">*</span></label>
            <input v-model.trim="citySignupForm.principalPhone" class="form-control" placeholder="11位手机号或固话" />
          </div>
          <div class="col-md-4">
            <label class="form-label mb-1">主办单位：</label>
            <input v-model.trim="citySignupForm.organizer" class="form-control" placeholder="如：XX市教育局" />
          </div>
          <div class="col-md-6">
            <label class="form-label mb-1">考试地点：</label>
            <input v-model.trim="citySignupForm.venue" class="form-control" placeholder="如：XX中学机房A栋" />
          </div>
          <div class="col-md-6">
            <label class="form-label mb-1">顶部横幅图（建议尺寸：1920 x 420 像素，16:3）：</label>
            <div class="d-flex gap-2">
              <input
                ref="citySignupBannerInput"
                type="file"
                class="form-control"
                accept="image/png,image/jpeg,image/webp"
                @change="onCitySignupBannerFileChange"
              />
              <button class="btn btn-light flex-shrink-0" type="button" :disabled="citySignupBannerUploading" @click="uploadCitySignupBanner()">
                {{ citySignupBannerUploading ? '上传中...' : '上传横幅' }}
              </button>
            </div>
            <div class="small mt-1" :class="citySignupBannerMeta.ok ? 'text-muted' : 'text-danger'">
              {{
                citySignupBannerMeta.msg
                  ? citySignupBannerMeta.msg
                  : (citySignupBannerHint || '可先上传赛事横幅图，再保存场次。')
              }}
            </div>
            <div v-if="citySignupBannerPreviewUrl()" class="city-signup-banner-preview mt-2">
              <img :src="citySignupBannerPreviewUrl()" alt="city-signup-banner-preview" />
            </div>
          </div>
          <div class="col-md-6">
            <label class="form-label mb-1">赛事附件（供学生下载，可选）：</label>
            <div class="d-flex gap-2">
              <input
                ref="citySignupAttachmentInput"
                type="file"
                class="form-control"
                @change="onCitySignupAttachmentFileChange"
              />
              <button
                class="btn btn-light flex-shrink-0"
                type="button"
                :disabled="citySignupAttachmentUploading"
                @click="uploadCitySignupAttachment()"
              >
                {{ citySignupAttachmentUploading ? '上传中...' : '上传附件' }}
              </button>
            </div>
            <div class="small mt-1" :class="citySignupAttachmentMeta.ok ? 'text-muted' : 'text-danger'">
              {{
                citySignupAttachmentMeta.msg
                  ? citySignupAttachmentMeta.msg
                  : (citySignupAttachmentHint || '可先上传附件，再保存场次（支持 PDF/Word/Excel/压缩包等）。')
              }}
            </div>
            <div v-if="Array.isArray(citySignupForm.attachments) && citySignupForm.attachments.length" class="small mt-2">
              <div class="text-muted mb-1">已上传附件：</div>
              <div class="d-flex flex-column gap-1">
                <div
                  v-for="(a, idx) in citySignupForm.attachments"
                  :key="'cs-att-' + idx"
                  class="d-flex align-items-center gap-2 flex-wrap"
                >
                  <a :href="a.url" target="_blank" rel="noopener noreferrer">
                    {{ a.name || '下载附件' }}
                  </a>
                  <input
                    v-model.trim="a.name"
                    class="form-control form-control-sm"
                    style="max-width: 260px;"
                    placeholder="显示名称（可修改）"
                  />
                  <button class="btn btn-sm btn-light" type="button" @click="removeCitySignupAttachmentAt(idx)">移除</button>
                </div>
              </div>
            </div>
            <div v-else-if="citySignupForm.attachmentUrl" class="small mt-1">
              <span class="text-muted">当前附件：</span>
              <a :href="citySignupForm.attachmentUrl" target="_blank" rel="noopener noreferrer">
                {{ citySignupForm.attachmentName || '下载附件' }}
              </a>
              <button class="btn btn-sm btn-light ms-2" type="button" @click="clearCitySignupAttachment">移除</button>
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label mb-1">考试时间：<span v-if="!citySignupFieldOk('examTime')" class="text-danger">*</span></label>
            <input v-model="citySignupForm.examTime" type="datetime-local" class="form-control" />
          </div>
          <div class="col-md-3">
            <label class="form-label mb-1">计划名额：</label>
            <input v-model.number="citySignupForm.quota" type="number" min="0" class="form-control" placeholder="计划名额" />
          </div>
          <div class="col-md-4">
            <label class="form-label mb-1">报名开始时间：<span v-if="!citySignupFieldOk('signupStartTime')" class="text-danger">*</span></label>
            <input v-model="citySignupForm.signupStartTime" type="datetime-local" class="form-control" />
          </div>
          <div class="col-md-4">
            <label class="form-label mb-1">报名截止时间：<span v-if="!citySignupFieldOk('signupEndTime')" class="text-danger">*</span></label>
            <input v-model="citySignupForm.signupEndTime" type="datetime-local" class="form-control" />
          </div>
          <div class="col-md-4">
            <label class="form-label mb-1">报名状态：</label>
            <select v-model.number="citySignupForm.status" class="form-select">
              <option :value="1">开启报名</option>
              <option :value="0">关闭报名</option>
            </select>
          </div>
          <div class="col-md-12">
            <label class="form-label mb-1">项目分类（本场次可开展项目）：</label>
            <div class="city-signup-project-pick-wrap">
              <label
                v-for="p in cityProjectRows.filter((x) => Number(x.status) === 1)"
                :key="'city-signup-pick-' + p.id"
                class="city-signup-project-pick"
              >
                <input
                  v-model="citySignupForm.selectedProjects"
                  type="checkbox"
                  :value="String(p.projectName || '').trim()"
                />
                <span>{{ p.projectName || '-' }}</span>
              </label>
              <span v-if="cityProjectRows.filter((x) => Number(x.status) === 1).length === 0" class="small text-muted">
                暂无启用项目，请先到“项目管理”中新增并启用项目。
              </span>
            </div>
          </div>
          <div class="col-md-12">
            <label class="form-label mb-1">扩展配置：</label>
            <textarea v-model.trim="citySignupForm.extraConfig" class="form-control" rows="2" placeholder="扩展配置（可选）"></textarea>
            <div class="small text-muted mt-1">
              「是否自动生成考试账号」请在列表中点击对应场次的「设置自动生成账号」进行修改。
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end gap-2 mt-3">
          <button class="btn btn-light" type="button" @click="resetCitySignupForm">重置</button>
          <button class="btn btn-primary" type="button" @click="saveCitySignup">{{ citySignupForm.id ? '更新场次' : '新建场次' }}</button>
        </div>
      </div>
    </div>

    <div v-if="showCitySignupAutoAccountModal" class="modal-mask" @click.self="closeCitySignupAutoAccountModal">
      <div class="modal-panel" style="max-width: 520px;">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h5 class="mb-0">设置自动生成考试账号 · {{ citySignupAutoAccountTitle }}</h5>
          <button class="btn btn-sm btn-light" type="button" :disabled="citySignupAutoAccountSaving" @click="closeCitySignupAutoAccountModal">
            关闭
          </button>
        </div>
        <p class="small text-muted mb-3">
          选「是」后，学员在本场次报名成功时将自动创建学生登录账号，并可下载账号信息。
        </p>
        <label class="form-label mb-1">是否自动生成考试账号</label>
        <select v-model.number="citySignupAutoAccountValue" class="form-select mb-3" :disabled="citySignupAutoAccountSaving">
          <option :value="0">否</option>
          <option :value="1">是</option>
        </select>
        <div class="d-flex justify-content-end gap-2">
          <button class="btn btn-light" type="button" :disabled="citySignupAutoAccountSaving" @click="closeCitySignupAutoAccountModal">
            取消
          </button>
          <button class="btn btn-primary" type="button" :disabled="citySignupAutoAccountSaving" @click="saveCitySignupAutoAccount">
            {{ citySignupAutoAccountSaving ? '保存中...' : '保存' }}
          </button>
        </div>
      </div>
    </div>

    <div v-if="showCheatDetailModal" class="modal-mask" @click.self="closeCheatDetailModal">
      <div class="modal-panel cheat-detail-modal">
        <div class="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-3">
          <div>
            <h5 class="mb-1">学员异常详情</h5>
            <div class="small text-muted">
              账号：{{ cheatDetailUser.username || '—' }} · 用户ID：{{ cheatDetailUser.userId }}
            </div>
          </div>
          <div class="d-flex gap-2 flex-wrap">
            <button type="button" class="btn btn-sm btn-primary" @click="exportCheatDetailCsv">导出该学员记录</button>
            <button type="button" class="btn btn-sm btn-light" @click="closeCheatDetailModal">关闭</button>
          </div>
        </div>
        <div class="result-shell cheat-detail-table-wrap">
          <table class="table table-striped table-sm align-middle modern-table mb-0">
            <thead>
              <tr>
                <th>时间</th>
                <th>考试记录ID</th>
                <th>异常类型</th>
                <th>说明</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="r in cheatDetailRows" :key="'cd-' + r.id">
                <td>{{ $fmtDateTime(r.createTime) }}</td>
                <td>{{ r.recordId }}</td>
                <td>{{ cheatTypeLabelZh(r.type) }}</td>
                <td class="text-break">{{ cheatDetailNoteZh(r) }}</td>
              </tr>
              <tr v-if="cheatDetailRows.length === 0">
                <td colspan="4" class="text-muted">暂无明细</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div v-if="showUserEditModal" class="modal-mask" @click.self="closeUserEditModal">
      <div class="modal-panel">
        <h5 class="mb-3">编辑用户</h5>
        <div class="row g-2">
          <div class="col-md-6">
            <label class="form-label">账号</label>
            <input v-model="editingUser.username" class="form-control" disabled />
          </div>
          <div class="col-md-6">
            <label class="form-label">姓名</label>
            <input v-model="editingUser.realName" class="form-control" />
          </div>
          <div class="col-md-6">
            <label class="form-label">角色</label>
            <select v-model="editingUser.role" class="form-select">
              <option value="admin">管理员</option>
              <option value="teacher">教师</option>
              <option value="student">学生</option>
            </select>
          </div>
          <div class="col-md-6">
            <label class="form-label">状态</label>
            <select v-model.number="editingUser.status" class="form-select">
              <option :value="1">正常</option>
              <option :value="0">禁用</option>
            </select>
          </div>
          <div class="col-md-6">
            <label class="form-label">手机号</label>
            <input v-model="editingUser.phone" class="form-control" />
          </div>
          <div class="col-md-6">
            <label class="form-label">省份</label>
            <select v-model="editingUser.province" class="form-select">
              <option value="">请选择省份</option>
              <option v-for="p in provinceOptions" :key="p" :value="p">{{ p }}</option>
            </select>
          </div>
          <div class="col-md-6">
            <label class="form-label">地市</label>
            <select v-model="editingUser.city" class="form-select" :disabled="!editingUser.province">
              <option value="">请选择地市</option>
              <option v-for="c in editCityOptions" :key="c" :value="c">{{ c }}</option>
            </select>
          </div>
          <div class="col-md-6">
            <label class="form-label">新密码（可空）</label>
            <input v-model="editingUser.password" type="password" class="form-control" />
          </div>
        </div>
        <div class="d-flex justify-content-end gap-2 mt-3">
          <button class="btn btn-light" @click="closeUserEditModal">取消</button>
          <button class="btn btn-primary" @click="saveUserEdit">保存修改</button>
        </div>
      </div>
    </div>

    <div v-if="showAnswerDetailModal" class="modal-mask" @click.self="closeAnswerDetailModal">
      <div class="modal-panel modal-wide">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h5 class="mb-0">学员作答详情</h5>
          <div class="d-flex gap-2">
            <button class="btn btn-sm btn-outline-secondary" :disabled="savingAnswerScores || answerDetailRows.length === 0" @click="restoreAllAnswerScores">
              {{ savingAnswerScores ? '处理中...' : '恢复系统原始判分' }}
            </button>
            <button class="btn btn-sm btn-primary" :disabled="savingAnswerScores || answerDetailRows.length === 0" @click="saveAllAnswerScores">
              {{ savingAnswerScores ? '保存中...' : '保存全部成绩' }}
            </button>
            <button class="btn btn-sm btn-light" @click="closeAnswerDetailModal">关闭</button>
          </div>
        </div>
        <div class="small text-muted mb-2">
          记录ID：{{ currentAnswerRecord.recordId || '-' }} /
          学员：{{ currentAnswerRecord.username || '-' }}(ID: {{ currentAnswerRecord.userId || '-' }}) /
          修改前总分：{{ currentAnswerRecord.originalScore || 0 }} /
          修改后总分：{{ currentAnswerRecord.score || 0 }}
        </div>
        <div class="result-shell">
          <table class="table table-striped align-middle modern-table mb-0">
            <thead>
              <tr>
                <th>序号</th>
                <th>题型</th>
                <th>题目</th>
                <th>作答选项/答案</th>
                <th>正确答案</th>
                <th>该题得分</th>
                <th>系统判分</th>
                <th>修改分数</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in answerDetailRows" :key="item.questionId">
                <td>{{ item.sort }}</td>
                <td>{{ item.typeText || item.type }}</td>
                <td class="detail-title">{{ item.title || '-' }}</td>
                <td class="detail-answer">
                  <template v-if="String(item.type || '').toLowerCase() === MATERIAL_COLLECT_TYPE">
                    <div class="small text-muted">说明</div>
                    <pre class="mb-2" style="white-space: pre-wrap; max-width: 420px">{{ item.materialCollectText || '—' }}</pre>
                    <div class="small text-muted">附件</div>
                    <ul v-if="(item.materialAttachments || []).length" class="list-unstyled small mb-0">
                      <li v-for="(a, ai) in item.materialAttachments" :key="'adm-mat-' + item.questionId + '-' + ai">
                        <a :href="a.downloadUrl || a.viewUrl" target="_blank" rel="noopener">{{ a.originalName || '附件' }}</a>
                      </li>
                    </ul>
                    <div v-else class="text-muted small">无附件</div>
                  </template>
                  <span v-else>{{ item.userAnswer || '-' }}</span>
                </td>
                <td class="detail-answer">{{ item.correctAnswer || '-' }}</td>
                <td>{{ item.answerScore ?? 0 }} / {{ item.maxScore ?? 0 }}</td>
                <td>{{ item.systemScore ?? 0 }} / {{ item.maxScore ?? 0 }}</td>
                <td style="min-width: 260px;">
                  <div class="d-flex gap-2 align-items-center">
                    <input
                      v-model.number="item.editingScore"
                      type="number"
                      class="form-control form-control-sm"
                      min="0"
                      :max="item.maxScore ?? 0"
                    />
                    <button class="btn btn-sm btn-primary" :disabled="savingAnswerScores" @click="saveAnswerScore(item)">保存</button>
                    <button class="btn btn-sm btn-outline-secondary" :disabled="savingAnswerScores" @click="restoreAnswerScore(item)">恢复</button>
                  </div>
                </td>
              </tr>
              <tr v-if="answerDetailRows.length === 0">
                <td colspan="8" class="text-muted">暂无作答详情</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div v-if="showEntryPhotoModal" class="modal-mask" @click.self="closeEntryPhotoModal">
      <div class="modal-panel">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h5 class="mb-0">考前拍照信息</h5>
          <button class="btn btn-sm btn-light" @click="closeEntryPhotoModal">关闭</button>
        </div>
        <div class="small text-muted mb-2">
          考试：{{ entryPhotoRow.examNameDisplay || '—' }} · 学员账号：{{ entryPhotoRow.studentUsername || '—' }}
        </div>
        <div class="entry-photo-wrap">
          <img v-if="entryPhotoRow.cameraPhoto" :src="entryPhotoRow.cameraPhoto" alt="entry-photo" class="entry-photo-img" />
          <div v-else class="text-muted">暂无照片</div>
        </div>
      </div>
    </div>

    <div v-if="showNoticeEditModal" class="modal-mask" @click.self="closeNoticeEditModal">
      <div class="modal-panel">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h5 class="mb-0">{{ noticeForm.id ? '编辑公告' : '发布公告' }}</h5>
          <button class="btn btn-sm btn-light" @click="closeNoticeEditModal">关闭</button>
        </div>
        <div class="row g-2">
          <div class="col-md-6">
            <label class="form-label">公告标题</label>
            <input v-model="noticeForm.title" class="form-control" placeholder="请输入标题" />
          </div>
          <div class="col-md-3">
            <label class="form-label">排序</label>
            <input v-model.number="noticeForm.sort" type="number" class="form-control" />
          </div>
          <div class="col-md-3">
            <label class="form-label">状态</label>
            <select v-model.number="noticeForm.status" class="form-select">
              <option :value="1">发布</option>
              <option :value="0">下线</option>
            </select>
          </div>
          <div class="col-md-6">
            <label class="form-label">发布日期（管理员指定）</label>
            <input v-model="noticeForm.publishTime" type="datetime-local" class="form-control" />
          </div>
          <div class="col-md-12">
            <label class="form-label">公告文字内容</label>
            <textarea v-model="noticeForm.contentText" class="form-control" rows="3" placeholder="可填写正文内容"></textarea>
          </div>
          <div class="col-md-8">
            <label class="form-label">附件/图片/压缩包</label>
            <input ref="noticeFileInput" type="file" class="form-control" @change="onNoticeFileChange" />
          </div>
          <div class="col-md-4 d-flex align-items-end">
            <button class="btn btn-light w-100" :disabled="noticeUploading" @click="uploadNoticeAsset">
              {{ noticeUploading ? '上传中...' : '上传附件/图片' }}
            </button>
          </div>
        </div>
        <div class="small text-muted mt-2">{{ noticeUploadingText }}</div>
        <div class="mt-2" v-if="noticeForm.assets.length > 0">
          <div class="small mb-1">已添加附件：</div>
          <div class="d-flex flex-wrap gap-2">
            <span v-for="(asset, idx) in noticeForm.assets" :key="'asset-modal-' + idx" class="badge text-bg-light">
              {{ asset.originalName || '附件' }}
              <button class="btn btn-sm btn-link p-0 ms-1" @click="removeNoticeAsset(idx)">移除</button>
            </span>
          </div>
        </div>
        <div class="d-flex justify-content-end gap-2 mt-3">
          <button class="btn btn-light" @click="closeNoticeEditModal">取消</button>
          <button class="btn btn-primary" @click="saveNotice">保存</button>
        </div>
      </div>
    </div>

    <div
      v-if="entryHoverPreviewVisible"
      class="entry-hover-preview"
      :style="{ left: `${entryHoverPreviewX}px`, top: `${entryHoverPreviewY}px` }"
    >
      <img :src="entryHoverPreviewSrc" alt="entry-hover-preview" />
    </div>
  </div>
</template>

<script>
 import { appAlert, appConfirm } from '../utils/appDialog'
 import { provinceCityMap, provinceOptions } from '../utils/chinaRegions'
 import { MATERIAL_COLLECT_TYPE } from '../utils/materialCollect'
 import AdminCityPaperManageView from './AdminCityPaperManageView.vue'
 import AdminTicketLoginPageManageView from './AdminTicketLoginPageManageView.vue'
 import TeacherQuestionManageView from './TeacherQuestionManageView.vue'

export default {
  name: 'AdminHomeView',
  components: {
    AdminCityPaperManageView,
    AdminTicketLoginPageManageView,
    TeacherQuestionManageView
  },
  data() {
    return {
      MATERIAL_COLLECT_TYPE,
      user: {},
      activeMenu: 'dashboard',
      dashboardStats: null,
      chartPie: null,
      chartBar: null,
      dashboardPollTimer: null,
      users: [],
      userPage: 0,
      userPageSize: 10,
      userTotalPages: 1,
      userTotalElements: 0,
      userExcelFile: null,
      userFilters: { keyword: '', role: '', status: '', province: '', city: '' },
      createForm: { username: '', realName: '', phone: '', password: '', role: 'student', province: '', city: '' },
      exams: [],
      notices: [],
      noticeUploadFile: null,
      noticeUploading: false,
      noticeUploadingText: '',
      showNoticeEditModal: false,
      examFilters: { keyword: '', status: '' },
      noticeFilters: { keyword: '', status: '' },
      noticeForm: { id: null, title: '', contentText: '', assets: [], sort: 0, status: 1, publishTime: '' },
      answerRows: [],
      currentExamId: null,
      currentExamScorePublic: 0,
      entryFilters: { examId: '', userId: '', status: '' },
      entryChecks: [],
      entryPage: 0,
      entryPageSize: 10,
      entryTotalPages: 1,
      entryTotalElements: 0,
      entryLoading: false,
      showUserEditModal: false,
      editingUser: { id: null, username: '', realName: '', role: 'student', status: 1, phone: '', province: '', city: '', password: '' },
      showAnswerDetailModal: false,
      answerDetailRows: [],
      savingAnswerScores: false,
      currentAnswerRecord: { recordId: null, userId: null, username: '', score: 0, originalScore: 0 },
      showEntryPhotoModal: false,
      entryPhotoRow: {
        id: null,
        cameraPhoto: '',
        examNameDisplay: '',
        studentUsername: ''
      },
      entryHoverPreviewVisible: false,
      entryHoverPreviewSrc: '',
      entryHoverPreviewX: 0,
      entryHoverPreviewY: 0,
      cheatUserSummaries: [],
      cheatFilters: { examId: '', username: '', userId: '' },
      cheatPage: 0,
      cheatPageSize: 15,
      cheatTotalPages: 1,
      cheatTotalElements: 0,
      showCheatDetailModal: false,
      cheatDetailUser: { userId: null, username: '' },
      cheatDetailRows: [],
      // event manage
      eventManageLoading: false,
      eventSeasons: [],
      eventSeasonSelected: 0,
      eventSeasonForm: { year: null, seasonName: '', enabled: 1, sort: null },
      eventSeasonSaving: false,
      eventBanners: [],
      eventBannerLoading: false,
      eventBannerDraggingIndex: -1,
      eventBannerDragOverIndex: -1,
      eventBannerSavingOrder: false,
      showEventBannerModal: false,
      showEventDetailBannerModal: false,
      eventDetailBanners: [],
      eventDetailBannerLoading: false,
      eventDetailBannerDraggingIndex: -1,
      eventDetailBannerDragOverIndex: -1,
      eventDetailBannerSavingOrder: false,
      eventDetailAssetUploading: false,
      eventDetailAssetMode: 'file',
      showEventDetailRichModal: false,
      eventDetailFontSize: '16',
      eventDetailTextColor: '#1f2937',
      eventDetailBackColor: '#ffffff',
      eventDetailSavedRange: null,
      eventDetailDraftAtOpen: '',
      eventList: [],
      eventListLoading: false,
      showEventEditModal: false,
      eventEditSaving: false,
      eventEditSnapshot: '',
      eventCategoryOptions: ['信息学', '机器人', '电子设计', '数学', '综合'],
      eventTagOptions: ['A组', 'B组', 'C组', '小学组', '初中组', '高中组', '个人赛', '团队赛'],
      eventCategoryDraft: '',
      eventTagDraft: '',
      eventEditForm: {
        id: null,
        seasonYear: null,
        title: '',
        category: '',
        tags: '',
        status: '',
        timeText: '',
        summary: '',
        detail: '',
        joinPayload: '',
        moreButtonText: '查看更多赛事信息',
        sort: 0,
        enabled: 1
      },
      citySignupRows: [],
      citySignupBannerLoadedMap: {},
      citySignupListFilters: {
        examNameLike: '',
        province: '',
        city: '',
        examPhase: '',
        status: ''
      },
      citySignupPage: 0,
      citySignupPageSize: 10,
      citySignupTotalPages: 1,
      citySignupTotalElements: 0,
      citySignupForm: {
        id: null,
        examName: '',
        province: '',
        city: '',
        principalName: '',
        principalPhone: '',
        organizer: '',
        venue: '',
        bannerUrl: '',
        attachmentUrl: '',
        attachmentName: '',
        attachments: [],
        examTime: '',
        signupStartTime: '',
        signupEndTime: '',
        quota: 0,
        status: 1,
        selectedProjects: [],
        extraConfig: ''
      },
      citySignupBannerFile: null,
      citySignupBannerUploading: false,
      citySignupBannerHint: '',
      citySignupBannerMeta: { ok: true, w: 0, h: 0, msg: '' },
      citySignupAttachmentFile: null,
      citySignupAttachmentUploading: false,
      citySignupAttachmentHint: '',
      citySignupAttachmentMeta: { ok: true, msg: '' },
      showCitySignupEntryModal: false,
      citySignupEntryRows: [],
      citySignupEntryPage: 0,
      citySignupEntryPageSize: 15,
      citySignupEntryTitle: '',
      citySignupEntryFilters: { candidateName: '', idCard: '', projectName: '', status: '' },
      citySignupEntryCurrentSignupId: null,
      citySignupReviewNote: '',
      citySignupExportMaskIdCard: true,
      citySignupEntrySelectedIds: [],
      citySignupBatchReviewing: false,
      showCitySignupEditModal: false,
      citySignupTab: 'signup',
      cityProjectRows: [],
      cityProjectForm: { projectName: '' },
      cityProjectSaving: false,
      showCitySignupPreInfoModal: false,
      citySignupPreInfoSaving: false,
      citySignupPreInfoSignupId: null,
      citySignupPreInfoTitle: '',
      citySignupPreInfoText: '',
      showCitySignupEventIntroModal: false,
      citySignupEventIntroSaving: false,
      citySignupEventIntroSignupId: null,
      citySignupEventIntroTitle: '',
      citySignupEventIntroText: '',
      showCitySignupProjectModal: false,
      showCitySignupAutoAccountModal: false,
      citySignupAutoAccountRow: null,
      citySignupAutoAccountValue: 0,
      citySignupAutoAccountSaving: false,
      citySignupProjectSaving: false,
      citySignupProjectSignupId: null,
      citySignupProjectTitle: '',
      citySignupProjectSelected: [],
      showCitySignupEntryEditModal: false,
      citySignupEntryEditSaving: false,
      citySignupEntryEditForm: {
        id: null,
        candidateName: '',
        gender: '',
        idCard: '',
        phone: '',
        province: '',
        city: '',
        projectName: '',
        schoolName: '',
        gradeName: '',
        remark: '',
        examUsername: '',
        password: '',
        generatedUserId: null
      }
    }
  },
  computed: {
    eventSeasonsEnabled() {
      return (this.eventSeasons || []).filter((s) => Number(s.enabled) === 1)
    },
    provinceOptions() {
      return provinceOptions
    },
    filterCityOptions() {
      return provinceCityMap[this.userFilters.province] || []
    },
    createCityOptions() {
      return provinceCityMap[this.createForm.province] || []
    },
    editCityOptions() {
      return provinceCityMap[this.editingUser.province] || []
    },
    citySignupCityOptions() {
      return provinceCityMap[this.citySignupForm.province] || []
    },
    citySignupListFilterCityOptions() {
      return provinceCityMap[this.citySignupListFilters.province] || []
    },
    citySignupEntryEditCityOptions() {
      return provinceCityMap[this.citySignupEntryEditForm.province] || []
    },
    citySignupGradeOptions() {
      return [
        '幼儿组',
        '小学低年级组（小学一到二年级）',
        '小学高年级组（小学三到六年级）',
        '初中组',
        '高中（职）组',
        '大学组'
      ]
    },
    citySignupListEmptyHint() {
      const f = this.citySignupListFilters || {}
      const has =
        (f.examNameLike && String(f.examNameLike).trim()) ||
        (f.province && String(f.province).trim()) ||
        (f.city && String(f.city).trim()) ||
        (f.examPhase && String(f.examPhase).trim()) ||
        (f.status !== '' && f.status != null)
      return has ? '暂无符合条件的场次' : '暂无场次，请先新建。'
    },
    cityProjectsActiveCount() {
      return (this.cityProjectRows || []).filter((p) => Number(p && p.status) === 1).length
    },
    cheatSelectedExamName() {
      const id = String(this.cheatFilters.examId || '').trim()
      if (!id) return ''
      const hit = this.exams.find((e) => String(e.id) === id)
      return hit && hit.examName ? hit.examName : `考试 #${id}`
    },
    citySignupPendingIdsOnPage() {
      return (this.citySignupEntryRowsPaged || [])
        .filter((r) => Number(r.status) === 1)
        .map((r) => Number(r.id))
        .filter((id) => Number.isFinite(id))
    },
    citySignupAllPendingSelected() {
      const pend = this.citySignupPendingIdsOnPage
      if (!pend.length) return false
      const sel = new Set(this.citySignupEntrySelectedIds || [])
      return pend.every((id) => sel.has(id))
    },
    citySignupBatchSelectedPendingCount() {
      const rows = this.citySignupEntryRows || []
      return (this.citySignupEntrySelectedIds || []).filter((id) =>
        rows.some((r) => Number(r.id) === Number(id) && Number(r.status) === 1)
      ).length
    },
    citySignupEntryTotalElements() {
      return (this.citySignupEntryRows || []).length
    },
    citySignupEntryTotalPages() {
      const size = Number(this.citySignupEntryPageSize) || 15
      const total = this.citySignupEntryTotalElements
      const tp = Math.ceil(total / Math.max(1, size))
      return tp < 1 ? 1 : tp
    },
    citySignupEntryRowsPaged() {
      const rows = this.citySignupEntryRows || []
      const size = Number(this.citySignupEntryPageSize) || 15
      const page = Number(this.citySignupEntryPage) || 0
      const start = page * size
      const end = start + size
      return rows.slice(start, end)
    },
    citySignupAutoAccountTitle() {
      const r = this.citySignupAutoAccountRow
      if (!r) return ''
      return String(r.examName || `场次#${r.id}`).trim()
    }
  },
  created() {
    this.loadEventOptionPrefs()
    this.user = JSON.parse(localStorage.getItem('exam_user') || '{}')
    try {
      const stored = String(localStorage.getItem('admin_active_menu') || '').trim()
      const allow = [
        'dashboard',
        'user',
        'exam',
        'notice',
        'verifyAbnormal',
        'eventManage',
        'citySignup',
        'sessionManage',
        'cityPaperManage',
        'questionManage',
        'ticketLoginPageManage'
      ]
      if (stored === 'entry' || stored === 'cheat') {
        this.activeMenu = 'verifyAbnormal'
      } else if (stored && allow.includes(stored)) {
        this.activeMenu = stored
      }
    } catch (e) {
      void e
    }
    const path = String((this.$route && this.$route.path) || '')
    if (path === '/home/city-signup') {
      const tab = String((this.$route.query && this.$route.query.adminTab) || '').trim()
      if (tab === 'eventManage') this.activeMenu = 'eventManage'
      else if (tab === 'cityPaperManage') this.activeMenu = 'cityPaperManage'
      else if (tab === 'questionManage') this.activeMenu = 'questionManage'
      else if (tab === 'ticketLoginPageManage') this.activeMenu = 'ticketLoginPageManage'
      else this.activeMenu = 'citySignup'
    } else if (path === '/home/exam-session-info') {
      this.activeMenu = 'sessionManage'
    } else if (path === '/home/city-paper-manage') {
      this.activeMenu = 'cityPaperManage'
    } else if (path === '/home/ticket-login-page-manage') {
      this.activeMenu = 'ticketLoginPageManage'
    }
    if (this.activeMenu === 'dashboard') this.loadDashboardStats()
  },
  mounted() {
    window.addEventListener('resize', this.onDashboardChartResize)
    this.dashboardPollTimer = setInterval(() => {
      if (this.activeMenu === 'dashboard') this.loadDashboardStats()
    }, 30000)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onDashboardChartResize)
    if (this.dashboardPollTimer) {
      clearInterval(this.dashboardPollTimer)
      this.dashboardPollTimer = null
    }
    this.disposeDashboardCharts()
  },
  watch: {
    activeMenu(m) {
      try {
        localStorage.setItem('admin_active_menu', String(m || 'dashboard'))
      } catch (e) {
        void e
      }
      if (m === 'user') this.loadUsers()
      if (m === 'dashboard') this.loadDashboardStats()
      if (m === 'verifyAbnormal') {
        this.loadEntryChecks()
        if (!this.exams.length) this.loadExams()
        this.cheatPage = 0
        this.loadCheatUserSummaries()
      }
      if (m === 'eventManage') {
        this.loadEventManageAll()
      }
      if (m === 'citySignup') this.loadCitySignups()
      if (m === 'sessionManage') {
        this.searchCitySignupList()
      }
      if (
        m === 'citySignup' ||
        m === 'eventManage' ||
        m === 'sessionManage' ||
        m === 'cityPaperManage' ||
        m === 'questionManage' ||
        m === 'ticketLoginPageManage'
      ) {
        this.syncAdminHomeRouteByMenu(m)
      }
    },
    $route(to) {
      if (to.path === '/home/city-signup') {
        const tab = String((to.query && to.query.adminTab) || '').trim()
        if (tab === 'eventManage') this.activeMenu = 'eventManage'
        else if (tab === 'cityPaperManage') this.activeMenu = 'cityPaperManage'
        else if (tab === 'questionManage') this.activeMenu = 'questionManage'
        else if (tab === 'ticketLoginPageManage') this.activeMenu = 'ticketLoginPageManage'
        else this.activeMenu = 'citySignup'
      } else if (to.path === '/home/exam-session-info') {
        this.activeMenu = 'sessionManage'
      } else if (to.path === '/home/city-paper-manage') {
        this.activeMenu = 'cityPaperManage'
      } else if (to.path === '/home/ticket-login-page-manage') {
        this.activeMenu = 'ticketLoginPageManage'
      }
    },
    'userFilters.province'() {
      // Province filter changes should clear city filter.
      this.userFilters.city = ''
    },
    'createForm.province'(v) {
      // Create form requires province/city; when province changes, reset city to first option.
      this.createForm.city = ''
      if (!v) return
      const list = provinceCityMap[v] || []
      this.createForm.city = list[0] || ''
    },
    'editingUser.province'(v) {
      if (!v) {
        this.editingUser.city = ''
        return
      }
      const list = provinceCityMap[v] || []
      // If city is empty, pick a default.
      // If city exists but doesn't belong to the selected province (not in our dictionary),
      // clear it so the admin must re-select from dropdown.
      if (!this.editingUser.city) {
        this.editingUser.city = list[0] || ''
      } else if (!list.includes(this.editingUser.city)) {
        this.editingUser.city = ''
      }
    },
    'citySignupForm.province'(v) {
      if (!v) {
        this.citySignupForm.city = ''
        return
      }
      const list = provinceCityMap[v] || []
      if (!this.citySignupForm.city || !list.includes(this.citySignupForm.city)) {
        this.citySignupForm.city = list[0] || ''
      }
    },
    'citySignupListFilters.province'(v) {
      if (!v) {
        this.citySignupListFilters.city = ''
        return
      }
      const list = provinceCityMap[v] || []
      if (this.citySignupListFilters.city && !list.includes(this.citySignupListFilters.city)) {
        this.citySignupListFilters.city = ''
      }
    },
    'citySignupEntryEditForm.province'(v) {
      if (!v) {
        this.citySignupEntryEditForm.city = ''
        return
      }
      const list = provinceCityMap[v] || []
      if (!this.citySignupEntryEditForm.city || !list.includes(this.citySignupEntryEditForm.city)) {
        this.citySignupEntryEditForm.city = list[0] || ''
      }
    }
  },
  methods: {
    isCitySignupBannerLoaded(row) {
      const id = row && row.id != null ? String(row.id) : ''
      if (!id) return false
      return this.citySignupBannerLoadedMap && this.citySignupBannerLoadedMap[id] === true
    },
    loadCitySignupBanner(row) {
      const id = row && row.id != null ? String(row.id) : ''
      if (!id) return
      if (!this.citySignupBannerLoadedMap) this.citySignupBannerLoadedMap = {}
      this.citySignupBannerLoadedMap = { ...this.citySignupBannerLoadedMap, [id]: true }
    },
    openEventPublicIntro() {
      // Open in a new browser tab/window (do not navigate inside admin page).
      try {
        const base = String(window.location.href || '').split('#')[0]
        const url = `${base}#/event`
        window.open(url, '_blank', 'noopener,noreferrer')
      } catch (e) {
        // Fallback: open relative hash URL
        window.open('#/event', '_blank')
      }
    },
    async loadEventManageAll() {
      this.eventManageLoading = true
      try {
        await this.loadEventSeasons()
        await this.loadEventBannersAndEvents()
      } finally {
        this.eventManageLoading = false
      }
    },
    async loadEventSeasons() {
      const res = await fetch('/api/admin/event/seasons').then((r) => r.json())
      if (!res || res.code !== 200) throw new Error((res && res.message) || '加载赛季失败')
      this.eventSeasons = res.data || []
      const enabled = this.eventSeasonsEnabled
      if (!this.eventSeasonSelected) {
        this.eventSeasonSelected = enabled.length ? Number(enabled[0].year) : 0
      } else if (enabled.length && !enabled.some((s) => Number(s.year) === Number(this.eventSeasonSelected))) {
        this.eventSeasonSelected = Number(enabled[0].year)
      }
    },
    async saveEventSeason() {
      const f = this.eventSeasonForm || {}
      const year = Number(f.year)
      if (!Number.isFinite(year) || year < 2000) {
        window.alert('请输入正确的赛季年份，如 2026')
        return
      }
      this.eventSeasonSaving = true
      try {
        const payload = {
          year,
          seasonName: String(f.seasonName || ''),
          enabled: Number(f.enabled) === 0 ? 0 : 1,
          sort: Number.isFinite(Number(f.sort)) ? Number(f.sort) : year
        }
        const res = await fetch('/api/admin/event/seasons', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        }).then((r) => r.json())
        if (!res || res.code !== 200) throw new Error((res && res.message) || '保存失败')
        this.eventSeasonForm = { year: null, seasonName: '', enabled: 1, sort: null }
        await this.loadEventSeasons()
      } catch (e) {
        window.alert(e.message || '保存赛季失败')
      } finally {
        this.eventSeasonSaving = false
      }
    },
    editEventSeasonRow(row) {
      this.eventSeasonForm = {
        year: Number(row.year),
        seasonName: row.seasonName || '',
        enabled: Number(row.enabled) === 0 ? 0 : 1,
        sort: row.sort == null ? null : Number(row.sort)
      }
    },
    async deleteEventSeasonRow(row) {
      if (!(await appConfirm(`确认删除赛季 ${row.year} 吗？`))) return
      try {
        const res = await fetch(`/api/admin/event/seasons/${row.year}`, { method: 'DELETE' }).then((r) => r.json())
        if (!res || res.code !== 200) throw new Error((res && res.message) || '删除失败')
        await this.loadEventSeasons()
        window.alert('删除成功')
      } catch (e) {
        window.alert(e.message || '删除赛季失败')
      }
    },
    async loadEventBannersAndEvents() {
      await Promise.all([this.loadEventBanners(), this.loadEventList()])
    },
    async openEventBannerModal() {
      this.showEventBannerModal = true
      await this.loadEventBanners()
    },
    closeEventBannerModal() {
      this.showEventBannerModal = false
    },
    async openEventDetailBannerModal() {
      if (!this.eventEditForm.id) {
        window.alert('请先保存赛事，再管理详情轮播图')
        return
      }
      this.showEventDetailBannerModal = true
      await this.loadEventDetailBanners()
    },
    closeEventDetailBannerModal() {
      this.showEventDetailBannerModal = false
    },
    async loadEventBanners() {
      this.eventBannerLoading = true
      try {
        const season = this.eventSeasonSelected ? `?season=${encodeURIComponent(String(this.eventSeasonSelected))}` : ''
        const res = await fetch(`/api/admin/event/banners${season}`).then((r) => r.json())
        if (!res || res.code !== 200) throw new Error((res && res.message) || '加载轮播失败')
        this.eventBanners = (res.data || []).map((x) => ({
          ...x,
          enabled: Number(x.enabled) === 0 ? 0 : 1,
          sort: x.sort == null ? 0 : Number(x.sort)
        }))
      } catch (e) {
        window.alert(e.message || '加载轮播失败')
      } finally {
        this.eventBannerLoading = false
      }
    },
    triggerEventBannerPick() {
      try {
        const el = this.$refs.eventBannerFileInput
        if (el && typeof el.click === 'function') el.click()
      } catch (e) {
        void e
      }
    },
    async onEventBannerFilesPicked(e) {
      const files = (e && e.target && e.target.files) ? Array.from(e.target.files) : []
      if (!files.length) return
      for (const f of files) {
        await this.uploadOneEventBanner(f)
      }
      try {
        if (e && e.target) e.target.value = ''
      } catch (err) {
        void err
      }
      await this.loadEventBanners()
    },
    async uploadOneEventBanner(file) {
      const fd = new FormData()
      fd.append('file', file)
      if (this.eventSeasonSelected) fd.append('seasonYear', String(this.eventSeasonSelected))
      const res = await fetch('/api/admin/event/banners/upload', { method: 'POST', body: fd }).then((r) => r.json())
      if (!res || res.code !== 200) {
        window.alert((res && res.message) || '轮播上传失败')
      }
    },
    async saveEventBannerMeta(b) {
      try {
        const res = await fetch(`/api/admin/event/banners/${b.id}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            seasonYear: this.eventSeasonSelected,
            title: b.title || '',
            subtitle: b.subtitle || '',
            sort: Number(b.sort) || 0,
            enabled: Number(b.enabled) === 0 ? 0 : 1
          })
        }).then((r) => r.json())
        if (!res || res.code !== 200) throw new Error((res && res.message) || '保存失败')
        window.alert('已保存')
      } catch (e) {
        window.alert(e.message || '保存失败')
      }
    },
    onEventBannerDragStart(idx) {
      this.eventBannerDraggingIndex = Number(idx)
      this.eventBannerDragOverIndex = Number(idx)
    },
    onEventBannerDragEnd() {
      this.eventBannerDraggingIndex = -1
      this.eventBannerDragOverIndex = -1
    },
    onEventBannerDragEnter(idx) {
      this.eventBannerDragOverIndex = Number(idx)
    },
    onEventBannerDragLeave(idx) {
      if (Number(this.eventBannerDragOverIndex) === Number(idx)) {
        this.eventBannerDragOverIndex = -1
      }
    },
    onEventBannerDrop(targetIdx) {
      const from = Number(this.eventBannerDraggingIndex)
      const to = Number(targetIdx)
      this.eventBannerDraggingIndex = -1
      this.eventBannerDragOverIndex = -1
      if (!Number.isFinite(from) || !Number.isFinite(to) || from < 0 || to < 0 || from === to) return
      const arr = Array.isArray(this.eventBanners) ? [...this.eventBanners] : []
      if (from >= arr.length || to >= arr.length) return
      const [moved] = arr.splice(from, 1)
      arr.splice(to, 0, moved)
      const n = arr.length
      this.eventBanners = arr.map((x, i) => ({ ...x, sort: n - i }))
    },
    async saveEventBannerOrder() {
      if (!this.eventBanners.length) return
      this.eventBannerSavingOrder = true
      try {
        const n = this.eventBanners.length
        for (let i = 0; i < this.eventBanners.length; i += 1) {
          const b = this.eventBanners[i]
          b.sort = n - i
          const res = await fetch(`/api/admin/event/banners/${b.id}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              seasonYear: this.eventSeasonSelected,
              title: b.title || '',
              subtitle: b.subtitle || '',
              sort: Number(b.sort) || 0,
              enabled: Number(b.enabled) === 0 ? 0 : 1
            })
          }).then((r) => r.json())
          if (!res || res.code !== 200) throw new Error((res && res.message) || '排序保存失败')
        }
        window.alert('轮播图排序已保存')
        await this.loadEventBanners()
      } catch (e) {
        window.alert(e.message || '排序保存失败')
      } finally {
        this.eventBannerSavingOrder = false
      }
    },
    async deleteEventBannerRow(b) {
      if (!(await appConfirm('确认删除该轮播图吗？'))) return
      try {
        const res = await fetch(`/api/admin/event/banners/${b.id}`, { method: 'DELETE' }).then((r) => r.json())
        if (!res || res.code !== 200) throw new Error((res && res.message) || '删除失败')
        await this.loadEventBanners()
        window.alert('删除成功')
      } catch (e) {
        window.alert(e.message || '删除失败')
      }
    },
    async loadEventDetailBanners() {
      if (!this.eventEditForm.id) return
      this.eventDetailBannerLoading = true
      try {
        const res = await fetch(`/api/admin/event/events/${this.eventEditForm.id}/detail-banners`).then((r) => r.json())
        if (!res || res.code !== 200) throw new Error((res && res.message) || '加载详情轮播失败')
        this.eventDetailBanners = (res.data || []).map((x) => ({
          ...x,
          enabled: Number(x.enabled) === 0 ? 0 : 1,
          sort: x.sort == null ? 0 : Number(x.sort)
        }))
      } catch (e) {
        window.alert(e.message || '加载详情轮播失败')
      } finally {
        this.eventDetailBannerLoading = false
      }
    },
    triggerEventDetailBannerPick() {
      try {
        const el = this.$refs.eventDetailBannerFileInput
        if (el && typeof el.click === 'function') el.click()
      } catch (e) {
        void e
      }
    },
    async onEventDetailBannerFilesPicked(e) {
      const files = (e && e.target && e.target.files) ? Array.from(e.target.files) : []
      if (!files.length || !this.eventEditForm.id) return
      for (const f of files) {
        const fd = new FormData()
        fd.append('file', f)
        const res = await fetch(`/api/admin/event/events/${this.eventEditForm.id}/detail-banners/upload`, {
          method: 'POST',
          body: fd
        }).then((r) => r.json())
        if (!res || res.code !== 200) window.alert((res && res.message) || '上传失败')
      }
      try {
        if (e && e.target) e.target.value = ''
      } catch (err) {
        void err
      }
      await this.loadEventDetailBanners()
    },
    async saveEventDetailBannerMeta(b) {
      try {
        const res = await fetch(`/api/admin/event/detail-banners/${b.id}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            title: b.title || '',
            subtitle: b.subtitle || '',
            sort: Number(b.sort) || 0,
            enabled: Number(b.enabled) === 0 ? 0 : 1
          })
        }).then((r) => r.json())
        if (!res || res.code !== 200) throw new Error((res && res.message) || '保存失败')
        window.alert('已保存')
      } catch (e) {
        window.alert(e.message || '保存失败')
      }
    },
    async deleteEventDetailBannerRow(b) {
      if (!(await appConfirm('确认删除该详情轮播图吗？'))) return
      try {
        const res = await fetch(`/api/admin/event/detail-banners/${b.id}`, { method: 'DELETE' }).then((r) => r.json())
        if (!res || res.code !== 200) throw new Error((res && res.message) || '删除失败')
        await this.loadEventDetailBanners()
        window.alert('删除成功')
      } catch (e) {
        window.alert(e.message || '删除失败')
      }
    },
    onEventDetailBannerDragStart(idx) {
      this.eventDetailBannerDraggingIndex = Number(idx)
      this.eventDetailBannerDragOverIndex = Number(idx)
    },
    onEventDetailBannerDragEnd() {
      this.eventDetailBannerDraggingIndex = -1
      this.eventDetailBannerDragOverIndex = -1
    },
    onEventDetailBannerDragEnter(idx) {
      this.eventDetailBannerDragOverIndex = Number(idx)
    },
    onEventDetailBannerDragLeave(idx) {
      if (Number(this.eventDetailBannerDragOverIndex) === Number(idx)) this.eventDetailBannerDragOverIndex = -1
    },
    onEventDetailBannerDrop(targetIdx) {
      const from = Number(this.eventDetailBannerDraggingIndex)
      const to = Number(targetIdx)
      this.eventDetailBannerDraggingIndex = -1
      this.eventDetailBannerDragOverIndex = -1
      if (!Number.isFinite(from) || !Number.isFinite(to) || from < 0 || to < 0 || from === to) return
      const arr = Array.isArray(this.eventDetailBanners) ? [...this.eventDetailBanners] : []
      if (from >= arr.length || to >= arr.length) return
      const [moved] = arr.splice(from, 1)
      arr.splice(to, 0, moved)
      const n = arr.length
      this.eventDetailBanners = arr.map((x, i) => ({ ...x, sort: n - i }))
    },
    async saveEventDetailBannerOrder() {
      if (!this.eventDetailBanners.length) return
      this.eventDetailBannerSavingOrder = true
      try {
        const n = this.eventDetailBanners.length
        for (let i = 0; i < this.eventDetailBanners.length; i += 1) {
          const b = this.eventDetailBanners[i]
          b.sort = n - i
          const res = await fetch(`/api/admin/event/detail-banners/${b.id}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              title: b.title || '',
              subtitle: b.subtitle || '',
              sort: Number(b.sort) || 0,
              enabled: Number(b.enabled) === 0 ? 0 : 1
            })
          }).then((r) => r.json())
          if (!res || res.code !== 200) throw new Error((res && res.message) || '排序保存失败')
        }
        window.alert('详情轮播图排序已保存')
        await this.loadEventDetailBanners()
      } catch (e) {
        window.alert(e.message || '排序保存失败')
      } finally {
        this.eventDetailBannerSavingOrder = false
      }
    },
    async loadEventList() {
      this.eventListLoading = true
      try {
        const season = this.eventSeasonSelected ? `?season=${encodeURIComponent(String(this.eventSeasonSelected))}` : ''
        const res = await fetch(`/api/admin/event/events${season}`).then((r) => r.json())
        if (!res || res.code !== 200) throw new Error((res && res.message) || '加载赛事失败')
        this.eventList = res.data || []
        this.absorbEventOptionsFromRows(this.eventList)
      } catch (e) {
        window.alert(e.message || '加载赛事失败')
      } finally {
        this.eventListLoading = false
      }
    },
    openEventEditNew() {
      const season = this.eventSeasonSelected || (this.eventSeasonsEnabled[0] && Number(this.eventSeasonsEnabled[0].year)) || null
      this.eventEditForm = {
        id: null,
        seasonYear: season,
        title: '',
        category: '',
        tags: '',
        status: '',
        timeText: '',
        summary: '',
        detail: '',
        joinPayload: '',
        moreButtonText: '查看更多赛事信息',
        sort: 0,
        enabled: 1
      }
      this.showEventEditModal = true
      this.eventEditSnapshot = JSON.stringify(this.pickEventEditComparable(this.eventEditForm))
    },
    openEventEditExisting(row) {
      this.eventEditForm = { ...row }
      if (this.eventEditForm.enabled == null) this.eventEditForm.enabled = 1
      if (this.eventEditForm.sort == null) this.eventEditForm.sort = 0
      if (!this.eventEditForm.moreButtonText) this.eventEditForm.moreButtonText = '查看更多赛事信息'
      if (this.eventEditForm.detail == null) this.eventEditForm.detail = ''
      this.showEventEditModal = true
      this.eventEditSnapshot = JSON.stringify(this.pickEventEditComparable(this.eventEditForm))
    },
    closeEventEditModal() {
      this.tryCloseEventEditModal()
    },
    async tryCloseEventEditModal() {
      if (this.showEventDetailRichModal) {
        const okCloseRich = await this.closeEventDetailRichModal()
        if (!okCloseRich) return
      }
      this.syncEventDetailFromEditor()
      const changed = JSON.stringify(this.pickEventEditComparable(this.eventEditForm)) !== String(this.eventEditSnapshot || '')
      if (!changed) {
        this.showEventEditModal = false
        this.showEventDetailBannerModal = false
        return
      }
      const shouldSave = await appConfirm('检测到你修改了内容，是否保存后再退出？')
      if (shouldSave) {
        const ok = await this.saveEventEdit()
        if (!ok) return
        return
      }
      this.showEventEditModal = false
      this.showEventDetailBannerModal = false
    },
    async openEventDetailRichModal() {
      this.showEventDetailRichModal = true
      await this.$nextTick()
      this.initEventDetailEditor()
      this.eventDetailDraftAtOpen = String((this.eventEditForm && this.eventEditForm.detail) || '')
    },
    applyEventDetailRichModal() {
      this.syncEventDetailFromEditor()
      this.eventDetailDraftAtOpen = String((this.eventEditForm && this.eventEditForm.detail) || '')
      this.showEventDetailRichModal = false
    },
    async closeEventDetailRichModal() {
      this.syncEventDetailFromEditor()
      const now = String((this.eventEditForm && this.eventEditForm.detail) || '')
      const atOpen = String(this.eventDetailDraftAtOpen || '')
      if (now !== atOpen) {
        const ok = await appConfirm('检测到你修改了赛事介绍资料但尚未点击“应用到赛事”，确认直接关闭吗？')
        if (!ok) return false
      }
      this.showEventDetailRichModal = false
      return true
    },
    pickEventEditComparable(form) {
      const f = form || {}
      return {
        id: f.id || null,
        seasonYear: f.seasonYear == null ? null : Number(f.seasonYear),
        title: String(f.title || ''),
        category: String(f.category || ''),
        tags: String(f.tags || ''),
        status: String(f.status || ''),
        timeText: String(f.timeText || ''),
        summary: String(f.summary || ''),
        detail: String(f.detail || ''),
        joinPayload: String(f.joinPayload || ''),
        moreButtonText: String(f.moreButtonText || ''),
        sort: Number(f.sort) || 0,
        enabled: Number(f.enabled) === 0 ? 0 : 1
      }
    },
    splitEventOptions(raw) {
      return String(raw || '')
        .split(',')
        .map((x) => String(x || '').trim())
        .filter((x) => x.length > 0)
    },
    loadEventOptionPrefs() {
      try {
        const raw = localStorage.getItem('event_option_prefs_v1')
        if (!raw) return
        const data = JSON.parse(raw)
        const categories = Array.isArray(data && data.categories) ? data.categories : []
        const tags = Array.isArray(data && data.tags) ? data.tags : []
        if (categories.length) this.eventCategoryOptions = Array.from(new Set(categories.map((x) => String(x || '').trim()).filter(Boolean)))
        if (tags.length) this.eventTagOptions = Array.from(new Set(tags.map((x) => String(x || '').trim()).filter(Boolean)))
      } catch (e) {
        void e
      }
    },
    saveEventOptionPrefs() {
      try {
        localStorage.setItem(
          'event_option_prefs_v1',
          JSON.stringify({
            categories: this.eventCategoryOptions,
            tags: this.eventTagOptions
          })
        )
      } catch (e) {
        void e
      }
    },
    absorbEventOptionsFromRows(rows) {
      const list = Array.isArray(rows) ? rows : []
      const categorySet = new Set(this.eventCategoryOptions)
      const tagSet = new Set(this.eventTagOptions)
      for (const r of list) {
        this.splitEventOptions(r && r.category).forEach((x) => categorySet.add(x))
        this.splitEventOptions(r && r.tags).forEach((x) => tagSet.add(x))
      }
      this.eventCategoryOptions = Array.from(categorySet)
      this.eventTagOptions = Array.from(tagSet)
      this.saveEventOptionPrefs()
    },
    isEventOptionChecked(raw, option) {
      const opt = String(option || '').trim()
      if (!opt) return false
      return this.splitEventOptions(raw).includes(opt)
    },
    toggleEventOption(field, option, checked) {
      if (!this.eventEditForm || (field !== 'category' && field !== 'tags')) return
      const opt = String(option || '').trim()
      if (!opt) return
      const next = this.splitEventOptions(this.eventEditForm[field])
      const idx = next.indexOf(opt)
      if (checked && idx < 0) next.push(opt)
      if (!checked && idx >= 0) next.splice(idx, 1)
      this.eventEditForm[field] = next.join(',')
    },
    addEventOption(field) {
      const isCategory = field === 'category'
      const isTags = field === 'tags'
      if (!isCategory && !isTags) return
      const draft = String(isCategory ? this.eventCategoryDraft : this.eventTagDraft).trim()
      if (!draft) return
      const list = isCategory ? this.eventCategoryOptions : this.eventTagOptions
      if (!list.includes(draft)) list.push(draft)
      this.toggleEventOption(field, draft, true)
      if (isCategory) this.eventCategoryDraft = ''
      if (isTags) this.eventTagDraft = ''
      this.saveEventOptionPrefs()
    },
    removeEventOption(field, option) {
      const isCategory = field === 'category'
      const isTags = field === 'tags'
      if (!isCategory && !isTags) return
      const opt = String(option || '').trim()
      if (!opt) return
      const list = isCategory ? this.eventCategoryOptions : this.eventTagOptions
      const idx = list.indexOf(opt)
      if (idx >= 0) list.splice(idx, 1)
      this.toggleEventOption(field, opt, false)
      this.saveEventOptionPrefs()
    },
    initEventDetailEditor() {
      const el = this.$refs.eventDetailEditor
      if (!el) return
      el.innerHTML = String((this.eventEditForm && this.eventEditForm.detail) || '')
      if (typeof el.focus === 'function') el.focus()
      this.saveEventDetailSelection()
    },
    onEventDetailEditorInput(e) {
      this.eventEditForm.detail = String((e && e.target && e.target.innerHTML) || '')
      this.saveEventDetailSelection()
    },
    saveEventDetailSelection() {
      const el = this.$refs.eventDetailEditor
      if (!el) return
      const sel = window.getSelection && window.getSelection()
      if (!sel || !sel.rangeCount) return
      const range = sel.getRangeAt(0)
      if (!el.contains(range.commonAncestorContainer)) return
      this.eventDetailSavedRange = range.cloneRange()
    },
    restoreEventDetailSelection() {
      const el = this.$refs.eventDetailEditor
      const range = this.eventDetailSavedRange
      if (!el || !range) return
      const sel = window.getSelection && window.getSelection()
      if (!sel) return
      if (typeof el.focus === 'function') el.focus()
      sel.removeAllRanges()
      sel.addRange(range)
    },
    applyEventDetailInlineStyle(styleName, styleValue) {
      const el = this.$refs.eventDetailEditor
      if (!el) return
      this.restoreEventDetailSelection()
      const sel = window.getSelection && window.getSelection()
      if (!sel || !sel.rangeCount) return
      const range = sel.getRangeAt(0)
      if (!el.contains(range.commonAncestorContainer)) return
      if (range.collapsed) {
        const span = document.createElement('span')
        span.style[styleName] = styleValue
        span.innerHTML = '&#8203;'
        range.insertNode(span)
        const newRange = document.createRange()
        newRange.setStart(span.firstChild, 1)
        newRange.collapse(true)
        sel.removeAllRanges()
        sel.addRange(newRange)
        this.eventDetailSavedRange = newRange.cloneRange()
        this.syncEventDetailFromEditor()
        return
      }
      const content = range.extractContents()
      const span = document.createElement('span')
      span.style[styleName] = styleValue
      span.appendChild(content)
      range.insertNode(span)
      const newRange = document.createRange()
      newRange.selectNodeContents(span)
      sel.removeAllRanges()
      sel.addRange(newRange)
      this.eventDetailSavedRange = newRange.cloneRange()
      this.syncEventDetailFromEditor()
    },
    applyEventDetailCommand(cmd, value) {
      const el = this.$refs.eventDetailEditor
      if (!el) return
      this.restoreEventDetailSelection()
      try {
        if (typeof el.focus === 'function') el.focus()
        document.execCommand(cmd, false, value == null ? null : value)
      } catch (e) {
        void e
      }
      this.syncEventDetailFromEditor()
      this.saveEventDetailSelection()
    },
    applyEventDetailFontSize() {
      const px = `${String(this.eventDetailFontSize || '16').replace(/[^\d]/g, '') || '16'}px`
      this.applyEventDetailInlineStyle('fontSize', px)
    },
    applyEventDetailTextColor() {
      this.applyEventDetailCommand('foreColor', String(this.eventDetailTextColor || '#1f2937'))
    },
    applyEventDetailBackColor() {
      this.applyEventDetailCommand('backColor', String(this.eventDetailBackColor || '#ffffff'))
    },
    syncEventDetailFromEditor() {
      const el = this.$refs.eventDetailEditor
      if (!el) return
      this.eventEditForm.detail = String(el.innerHTML || '')
    },
    triggerEventDetailAssetPick(mode) {
      this.eventDetailAssetMode = mode === 'image' ? 'image' : (mode === 'video' ? 'video' : 'file')
      const el = this.$refs.eventDetailAssetInput
      if (!el) return
      el.value = ''
      if (this.eventDetailAssetMode === 'image') el.accept = 'image/*'
      else if (this.eventDetailAssetMode === 'video') el.accept = 'video/*'
      else el.accept = '*/*'
      el.click()
    },
    insertHtmlToDetailEditor(html) {
      const el = this.$refs.eventDetailEditor
      if (!el) return
      try {
        if (typeof el.focus === 'function') el.focus()
        document.execCommand('insertHTML', false, String(html || ''))
      } catch (err) {
        el.innerHTML += String(html || '')
      }
      this.syncEventDetailFromEditor()
    },
    async onEventDetailAssetPicked(e) {
      const file = e && e.target && e.target.files && e.target.files[0]
      if (!file) return
      this.eventDetailAssetUploading = true
      try {
        const fd = new FormData()
        fd.append('file', file)
        const res = await fetch('/api/notice-asset/upload', { method: 'POST', body: fd }).then((r) => r.json())
        if (!res || res.code !== 200) throw new Error((res && res.message) || '上传失败')
        const data = res.data || {}
        const viewUrl = String(data.viewUrl || data.downloadUrl || '').trim()
        const fileName = String(data.originalName || file.name || '附件')
        const contentType = String(data.contentType || file.type || '')
        if (!viewUrl) throw new Error('未获得文件访问地址')

        const safeName = fileName.replace(/"/g, '&quot;')
        if (this.eventDetailAssetMode === 'image' || contentType.startsWith('image/')) {
          this.insertHtmlToDetailEditor(`<p><img src="${viewUrl}" alt="${safeName}" style="max-width:100%;height:auto;border-radius:8px;" /></p>`)
        } else if (this.eventDetailAssetMode === 'video' || contentType.startsWith('video/')) {
          const safeType = contentType.replace(/"/g, '')
          this.insertHtmlToDetailEditor(
            `<p><video controls preload="metadata" style="max-width:100%;width:100%;border-radius:8px;background:#000;"><source src="${viewUrl}" type="${safeType}" />您的浏览器不支持 video 标签播放。</video></p>`
          )
        } else {
          this.insertHtmlToDetailEditor(`<p><a href="${viewUrl}" target="_blank" rel="noopener noreferrer">${safeName}</a></p>`)
        }
      } catch (err) {
        window.alert(err.message || '上传失败')
      } finally {
        this.eventDetailAssetUploading = false
        try {
          if (e && e.target) e.target.value = ''
        } catch (ignore) {
          void ignore
        }
      }
    },
    async saveEventEdit() {
      const f = this.eventEditForm || {}
      this.syncEventDetailFromEditor()
      if (!f.seasonYear) {
        window.alert('请选择赛季')
        return false
      }
      if (!String(f.title || '').trim()) {
        window.alert('请输入赛事标题')
        return false
      }
      this.eventEditSaving = true
      try {
        const res = await fetch('/api/admin/event/events', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: f.id || null,
            seasonYear: Number(f.seasonYear),
            title: String(f.title || ''),
            category: String(f.category || ''),
            tags: String(f.tags || ''),
            status: String(f.status || ''),
            timeText: String(f.timeText || ''),
            summary: String(f.summary || ''),
            detail: String(f.detail || ''),
            joinPayload: String(f.joinPayload || ''),
            moreButtonText: String(f.moreButtonText || '查看更多赛事信息'),
            sort: Number(f.sort) || 0,
            enabled: Number(f.enabled) === 0 ? 0 : 1
          })
        }).then((r) => r.json())
        if (!res || res.code !== 200) throw new Error((res && res.message) || '保存失败')
        this.eventEditSnapshot = JSON.stringify(this.pickEventEditComparable(this.eventEditForm))
        window.alert('内容保存成功')
        this.showEventEditModal = false
        await this.loadEventList()
        return true
      } catch (e) {
        window.alert(e.message || '保存失败')
        return false
      } finally {
        this.eventEditSaving = false
      }
    },
    async deleteEventRow(row) {
      if (!(await appConfirm('确认删除该赛事吗？'))) return
      try {
        const res = await fetch(`/api/admin/event/events/${row.id}`, { method: 'DELETE' }).then((r) => r.json())
        if (!res || res.code !== 200) throw new Error((res && res.message) || '删除失败')
        await this.loadEventList()
        window.alert('删除成功')
      } catch (e) {
        window.alert(e.message || '删除失败')
      }
    },
    async onEventCoverPicked(e) {
      const file = e && e.target && e.target.files && e.target.files[0]
      if (!file) return
      if (!this.eventEditForm.id) {
        window.alert('请先保存赛事基本信息，再上传封面图片')
        try {
          e.target.value = ''
        } catch (err) {
          void err
        }
        return
      }
      const fd = new FormData()
      fd.append('file', file)
      const res = await fetch(`/api/admin/event/events/${this.eventEditForm.id}/cover`, { method: 'POST', body: fd }).then((r) => r.json())
      if (!res || res.code !== 200) {
        window.alert((res && res.message) || '封面上传失败')
      } else {
        window.alert('封面已上传')
      }
      try {
        e.target.value = ''
      } catch (err) {
        void err
      }
    },
    goCitySignupEntryPage(next) {
      const tp = this.citySignupEntryTotalPages
      let n = Number(next)
      if (!Number.isFinite(n)) n = 0
      if (n < 0) n = 0
      if (n > tp - 1) n = tp - 1
      this.citySignupEntryPage = n
    },
    openSessionManageEntries(row) {
      if (!row || !row.id) return
      this.loadCityProjects()
      this.citySignupEntryTitle = row.examName || `场次#${row.id}`
      this.citySignupEntryCurrentSignupId = row.id
      this.citySignupEntryFilters = { candidateName: '', idCard: '', projectName: '', status: '' }
      this.citySignupEntryPage = 0
      this.citySignupReviewNote = ''
      this.citySignupEntrySelectedIds = []
      this.loadCitySignupEntries()
    },
    closeSessionManageEntries() {
      this.citySignupEntryRows = []
      this.citySignupEntryTitle = ''
      this.citySignupEntryCurrentSignupId = null
      this.citySignupEntryFilters = { candidateName: '', idCard: '', projectName: '', status: '' }
      this.citySignupEntryPage = 0
      this.citySignupReviewNote = ''
      this.citySignupExportMaskIdCard = true
      this.citySignupEntrySelectedIds = []
      this.citySignupBatchReviewing = false
    },
    syncAdminHomeRouteByMenu(menu) {
      if (menu === 'sessionManage') {
        if (this.$route.path !== '/home/exam-session-info') {
          this.$router.push({ path: '/home/exam-session-info' }).catch(() => {})
        }
        return
      }
      if (menu === 'cityPaperManage') {
        if (this.$route.path === '/home/city-signup' && String(this.$route.query.adminTab) === 'cityPaperManage') return
        this.$router.push({ path: '/home/city-signup', query: { adminTab: 'cityPaperManage' } }).catch(() => {})
        return
      }
      if (menu === 'questionManage') {
        if (this.$route.path === '/home/city-signup' && String(this.$route.query.adminTab) === 'questionManage') return
        this.$router.push({ path: '/home/city-signup', query: { adminTab: 'questionManage' } }).catch(() => {})
        return
      }
      if (menu === 'ticketLoginPageManage') {
        if (this.$route.path === '/home/city-signup' && String(this.$route.query.adminTab) === 'ticketLoginPageManage') return
        this.$router.push({ path: '/home/city-signup', query: { adminTab: 'ticketLoginPageManage' } }).catch(() => {})
        return
      }
      if (menu === 'citySignup') {
        if (this.$route.path === '/home/city-signup' && String(this.$route.query.adminTab) === 'citySignup') return
        this.$router.push({ path: '/home/city-signup', query: { adminTab: 'citySignup' } }).catch(() => {})
        return
      }
      if (menu === 'eventManage') {
        if (this.$route.path === '/home/city-signup' && String(this.$route.query.adminTab) === 'eventManage') return
        this.$router.push({ path: '/home/city-signup', query: { adminTab: 'eventManage' } }).catch(() => {})
      }
    },
    openExamMenu() {
      this.activeMenu = 'exam'
      this.loadExams()
    },
    openExamSessionInfoMenu() {
      this.activeMenu = 'sessionManage'
      this.searchCitySignupList()
      this.syncAdminHomeRouteByMenu('sessionManage')
    },
    openCityPaperManageMenu() {
      this.activeMenu = 'cityPaperManage'
      this.syncAdminHomeRouteByMenu('cityPaperManage')
    },
    openQuestionManageMenu() {
      this.activeMenu = 'questionManage'
      this.syncAdminHomeRouteByMenu('questionManage')
    },
    openTicketLoginPageManageMenu() {
      this.activeMenu = 'ticketLoginPageManage'
      this.syncAdminHomeRouteByMenu('ticketLoginPageManage')
    },
    openVerifyAbnormalMenu() {
      this.activeMenu = 'verifyAbnormal'
    },
    openNoticeMenu() {
      this.activeMenu = 'notice'
      this.loadNotices()
    },
    openEventManageMenu() {
      this.activeMenu = 'eventManage'
    },
    openCitySignupMenu() {
      this.activeMenu = 'citySignup'
      this.loadCitySignups()
    },
    openCreateCitySignupModal() {
      this.resetCitySignupForm()
      this.loadCityProjects()
      this.showCitySignupEditModal = true
    },
    closeCitySignupEditModal() {
      this.showCitySignupEditModal = false
    },
    loadCitySignups() {
      const params = new URLSearchParams({
        page: String(this.citySignupPage),
        size: String(this.citySignupPageSize),
        sortBy: 'id',
        sort: 'desc'
      })
      const f = this.citySignupListFilters || {}
      if (f.examNameLike && String(f.examNameLike).trim()) params.append('examNameLike', String(f.examNameLike).trim())
      if (f.province && String(f.province).trim()) params.append('province', String(f.province).trim())
      if (f.city && String(f.city).trim()) params.append('city', String(f.city).trim())
      if (f.examPhase && String(f.examPhase).trim()) params.append('examPhase', String(f.examPhase).trim())
      if (f.status !== '' && f.status != null) params.append('status', String(f.status))
      fetch(`/api/crud/city-exam-signup?${params.toString()}`)
        .then((r) => r.json())
        .then((res) => {
          const page = res && res.data
          this.citySignupRows = this.sanitizeObjectArray(page && page.content)
          // Reset banner lazy-load flags on each refresh so we don't keep stale ids across pages/filters.
          this.citySignupBannerLoadedMap = {}
          const total = page && page.totalElements != null ? Number(page.totalElements) : 0
          this.citySignupTotalElements = total
          let tp = page && page.totalPages != null ? Number(page.totalPages) : 1
          if (!Number.isFinite(tp) || tp < 1) tp = 1
          this.citySignupTotalPages = tp
          if (page && page.number != null) this.citySignupPage = Number(page.number)
          if (this.citySignupRows.length === 0 && total > 0 && this.citySignupPage > 0) {
            this.citySignupPage -= 1
            this.loadCitySignups()
          }
        })
        .catch(() => {
          this.citySignupRows = []
          this.citySignupTotalElements = 0
          this.citySignupTotalPages = 1
        })
    },
    searchCitySignupList() {
      this.citySignupPage = 0
      this.loadCitySignups()
    },
    resetCitySignupListFilters() {
      this.citySignupListFilters = {
        examNameLike: '',
        province: '',
        city: '',
        examPhase: '',
        status: ''
      }
      this.citySignupPage = 0
      this.loadCitySignups()
    },
    goCitySignupPage(next) {
      const n = Number(next)
      if (!Number.isFinite(n) || n < 0) return
      if (n >= this.citySignupTotalPages && this.citySignupTotalPages > 0) return
      if (n === this.citySignupPage) return
      this.citySignupPage = n
      this.loadCitySignups()
    },
    onCitySignupPageSizeChange() {
      let s = Number(this.citySignupPageSize)
      if (!Number.isFinite(s) || s < 1) s = 10
      this.citySignupPageSize = s
      this.citySignupPage = 0
      this.loadCitySignups()
    },
    openCitySignupProjectTab() {
      this.citySignupTab = 'project'
      this.loadCityProjects()
    },
    loadCityProjects() {
      fetch('/api/crud/city-exam-project?page=0&size=200&sortBy=id&sort=desc')
        .then((r) => r.json())
        .then((res) => {
          this.cityProjectRows = this.sanitizeObjectArray(res && res.data && res.data.content)
        })
        .catch(() => {
          this.cityProjectRows = []
        })
    },
    createCityProject() {
      const name = String(this.cityProjectForm.projectName || '').trim()
      if (!name) {
        window.alert('请先填写项目名称')
        return
      }
      this.cityProjectSaving = true
      fetch('/api/crud/city-exam-project', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ projectName: name, status: 1 })
      })
        .then((r) => r.json())
        .then((res) => {
          if (!res || res.code !== 200) {
            window.alert((res && res.message) || '新增失败')
            return
          }
          this.cityProjectForm.projectName = ''
          this.loadCityProjects()
        })
        .catch(() => window.alert('新增失败，请检查网络后重试'))
        .finally(() => {
          this.cityProjectSaving = false
        })
    },
    toggleCityProjectStatus(row) {
      if (!row || row.id == null) return
      const nextStatus = Number(row.status) === 1 ? 0 : 1
      fetch(`/api/crud/city-exam-project/${row.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...row, status: nextStatus })
      })
        .then((r) => r.json())
        .then((res) => {
          if (!res || res.code !== 200) {
            window.alert((res && res.message) || '更新失败')
            return
          }
          this.loadCityProjects()
        })
        .catch(() => window.alert('更新失败，请检查网络后重试'))
    },
    async deleteCityProject(row) {
      if (!row || row.id == null) return
      if (!(await appConfirm('确认删除该项目？删除后学生端将无法选择该项目。'))) return
      fetch(`/api/crud/city-exam-project/${row.id}`, { method: 'DELETE' })
        .then((r) => r.json())
        .then((res) => {
          if (!res || res.code !== 200) {
            window.alert((res && res.message) || '删除失败')
            return
          }
          window.alert('删除成功')
          this.loadCityProjects()
        })
        .catch(() => window.alert('删除失败，请检查网络后重试'))
    },
    citySignupPreInfoSnippet(row) {
      const t = this.citySignupResolvePreExamInfo(row)
      const s = String(t || '').replace(/\s+/g, ' ').trim()
      return s ? (s.length > 18 ? `${s.slice(0, 18)}...` : s) : '未配置（将使用默认模板）'
    },
    citySignupResolveEventIntro(row) {
      const raw = row && row.extraConfig != null ? String(row.extraConfig) : ''
      if (!raw || !raw.trim()) return ''
      try {
        const parsed = JSON.parse(raw)
        const text = parsed && (parsed.eventIntro || parsed.eventIntroduction)
        return text != null ? String(text) : ''
      } catch (e) {
        return ''
      }
    },
    citySignupEventIntroSnippet(row) {
      const t = this.citySignupResolveEventIntro(row)
      const s = String(t || '').replace(/\s+/g, ' ').trim()
      return s ? (s.length > 18 ? `${s.slice(0, 18)}...` : s) : '未配置'
    },
    citySignupResolvePreExamInfo(row) {
      const raw = row && row.extraConfig != null ? String(row.extraConfig) : ''
      if (!raw || !raw.trim()) return ''
      try {
        const parsed = JSON.parse(raw)
        const text = parsed && (parsed.preExamInfo || parsed.preExamNotice || parsed.preExamText)
        return text != null ? String(text) : ''
      } catch (e) {
        // If admin stored plain text, treat it as the pre-exam info body.
        return raw
      }
    },
    citySignupResolveProjectNames(row) {
      const raw = row && row.extraConfig != null ? String(row.extraConfig) : ''
      if (!raw || !raw.trim()) return []
      try {
        const parsed = JSON.parse(raw)
        const list = parsed && parsed.projectNames
        if (!Array.isArray(list)) return []
        return list.map((x) => String(x == null ? '' : x).trim()).filter((x) => x !== '')
      } catch (e) {
        return []
      }
    },
    citySignupProjectNames(row) {
      return this.citySignupResolveProjectNames(row)
    },
    citySignupProjectSummary(row) {
      const list = this.citySignupResolveProjectNames(row)
      if (!list.length) return '未设置'
      if (list.length <= 2) return list.join(' / ')
      return `${list.slice(0, 2).join(' / ')} 等${list.length}项`
    },
    openCitySignupPreInfoModal(row) {
      if (!row || row.id == null) return
      this.citySignupPreInfoSignupId = row.id
      this.citySignupPreInfoTitle = row.examName || `场次#${row.id}`
      this.citySignupPreInfoText = this.citySignupResolvePreExamInfo(row) || ''
      this.showCitySignupPreInfoModal = true
    },
    openCitySignupEventIntroModal(row) {
      if (!row || row.id == null) return
      this.citySignupEventIntroSignupId = row.id
      this.citySignupEventIntroTitle = row.examName || `场次#${row.id}`
      this.citySignupEventIntroText = this.citySignupResolveEventIntro(row) || ''
      this.showCitySignupEventIntroModal = true
    },
    closeCitySignupEventIntroModal() {
      if (this.citySignupEventIntroSaving) return
      this.showCitySignupEventIntroModal = false
      this.citySignupEventIntroSignupId = null
      this.citySignupEventIntroTitle = ''
      this.citySignupEventIntroText = ''
    },
    openCitySignupProjectModal(row) {
      if (!row || row.id == null) return
      this.citySignupProjectSignupId = row.id
      this.citySignupProjectTitle = row.examName || `场次#${row.id}`
      this.citySignupProjectSelected = this.citySignupResolveProjectNames(row)
      this.loadCityProjects()
      this.showCitySignupProjectModal = true
    },
    closeCitySignupProjectModal() {
      if (this.citySignupProjectSaving) return
      this.showCitySignupProjectModal = false
      this.citySignupProjectSignupId = null
      this.citySignupProjectTitle = ''
      this.citySignupProjectSelected = []
    },
    openCitySignupAutoAccountModal(row) {
      if (!row || row.id == null) return
      this.citySignupAutoAccountRow = row
      this.citySignupAutoAccountValue = Number(row.autoGenerateExamAccount) === 1 ? 1 : 0
      this.citySignupAutoAccountSaving = false
      this.showCitySignupAutoAccountModal = true
    },
    closeCitySignupAutoAccountModal() {
      if (this.citySignupAutoAccountSaving) return
      this.showCitySignupAutoAccountModal = false
      this.citySignupAutoAccountRow = null
    },
    saveCitySignupAutoAccount() {
      const row = this.citySignupAutoAccountRow
      if (!row || row.id == null) return
      this.citySignupAutoAccountSaving = true
      fetch(`/api/crud/city-exam-signup/${row.id}`)
        .then((r) => r.json())
        .then((res) => {
          if (!res || res.code !== 200 || !res.data) {
            throw new Error((res && res.message) || '加载场次失败')
          }
          const data = { ...res.data }
          data.autoGenerateExamAccount = Number(this.citySignupAutoAccountValue) === 1 ? 1 : 0
          return fetch(`/api/crud/city-exam-signup/${row.id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(data)
          }).then((r2) => r2.json())
        })
        .then((res) => {
          if (!res || res.code !== 200) {
            throw new Error((res && res.message) || '保存失败')
          }
          appAlert('修改成功')
          this.showCitySignupAutoAccountModal = false
          this.citySignupAutoAccountRow = null
          this.loadCitySignups()
        })
        .catch((e) => {
          window.alert(e && e.message ? e.message : '保存失败，请检查网络后重试')
        })
        .finally(() => {
          this.citySignupAutoAccountSaving = false
        })
    },
    saveCitySignupProjects() {
      const id = this.citySignupProjectSignupId
      if (!id) return
      const row = (this.citySignupRows || []).find((r) => r && r.id === id)
      if (!row) {
        window.alert('未找到场次数据，请刷新后重试')
        return
      }
      this.citySignupProjectSaving = true
      const extraConfig = this.mergeCitySignupExtraConfig(row.extraConfig, this.citySignupProjectSelected)
      fetch(`/api/crud/city-exam-signup/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...row, extraConfig })
      })
        .then((r) => r.json())
        .then((res) => {
          if (!res || res.code !== 200) {
            window.alert((res && res.message) || '保存失败')
            return
          }
          const count = Array.isArray(this.citySignupProjectSelected) ? this.citySignupProjectSelected.length : 0
          window.alert(`保存成功，当前场次已生效 ${count} 个赛项`)
          this.loadCitySignups()
          this.closeCitySignupProjectModal()
        })
        .catch(() => window.alert('保存失败，请检查网络后重试'))
        .finally(() => {
          this.citySignupProjectSaving = false
        })
    },
    closeCitySignupPreInfoModal() {
      if (this.citySignupPreInfoSaving) return
      this.showCitySignupPreInfoModal = false
      this.citySignupPreInfoSignupId = null
      this.citySignupPreInfoTitle = ''
      this.citySignupPreInfoText = ''
    },
    buildCitySignupExtraConfigWithPreInfo(row, preInfoText) {
      const base = row && row.extraConfig != null ? String(row.extraConfig) : ''
      const t = String(preInfoText || '')
      try {
        const parsed = base && base.trim() ? JSON.parse(base) : {}
        const obj = parsed && typeof parsed === 'object' ? parsed : {}
        obj.preExamInfo = t
        return JSON.stringify(obj)
      } catch (e) {
        return JSON.stringify({ preExamInfo: t })
      }
    },
    buildCitySignupExtraConfigWithEventIntro(row, introText) {
      const base = row && row.extraConfig != null ? String(row.extraConfig) : ''
      const t = String(introText || '')
      try {
        const parsed = base && base.trim() ? JSON.parse(base) : {}
        const obj = parsed && typeof parsed === 'object' ? parsed : {}
        obj.eventIntro = t
        return JSON.stringify(obj)
      } catch (e) {
        return JSON.stringify({ eventIntro: t })
      }
    },
    mergeCitySignupExtraConfig(rawText, selectedProjects) {
      const base = String(rawText || '')
      let obj = {}
      try {
        const parsed = base && base.trim() ? JSON.parse(base) : {}
        obj = parsed && typeof parsed === 'object' ? parsed : {}
      } catch (e) {
        obj = {}
      }
      const list = Array.isArray(selectedProjects) ? selectedProjects : []
      obj.projectNames = Array.from(new Set(list.map((x) => String(x == null ? '' : x).trim()).filter((x) => x !== '')))
      return JSON.stringify(obj)
    },
    saveCitySignupPreInfo() {
      if (!this.citySignupPreInfoSignupId) return
      const id = this.citySignupPreInfoSignupId
      const row = (this.citySignupRows || []).find((r) => r && r.id === id)
      if (!row) {
        window.alert('未找到场次数据，请刷新后重试')
        return
      }
      this.citySignupPreInfoSaving = true
      const extraConfig = this.buildCitySignupExtraConfigWithPreInfo(row, this.citySignupPreInfoText)
      fetch(`/api/crud/city-exam-signup/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...row, extraConfig })
      })
        .then((r) => r.json())
        .then((res) => {
          if (!res || res.code !== 200) {
            window.alert((res && res.message) || '保存失败')
            return
          }
          this.loadCitySignups()
          this.closeCitySignupPreInfoModal()
        })
        .catch(() => window.alert('保存失败，请检查网络后重试'))
        .finally(() => {
          this.citySignupPreInfoSaving = false
        })
    },
    saveCitySignupEventIntro() {
      if (!this.citySignupEventIntroSignupId) return
      const id = this.citySignupEventIntroSignupId
      const row = (this.citySignupRows || []).find((r) => r && r.id === id)
      if (!row) {
        window.alert('未找到场次数据，请刷新后重试')
        return
      }
      this.citySignupEventIntroSaving = true
      const extraConfig = this.buildCitySignupExtraConfigWithEventIntro(row, this.citySignupEventIntroText)
      fetch(`/api/crud/city-exam-signup/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...row, extraConfig })
      })
        .then((r) => r.json())
        .then((res) => {
          if (!res || res.code !== 200) {
            window.alert((res && res.message) || '保存失败')
            return
          }
          window.alert('赛事介绍保存成功')
          this.loadCitySignups()
          this.closeCitySignupEventIntroModal()
        })
        .catch(() => window.alert('保存失败，请检查网络后重试'))
        .finally(() => {
          this.citySignupEventIntroSaving = false
        })
    },
    resetCitySignupForm() {
      this.citySignupForm = {
        id: null,
        examName: '',
        province: '',
        city: '',
        principalName: '',
        principalPhone: '',
        organizer: '',
        venue: '',
        bannerUrl: '',
        attachmentUrl: '',
        attachmentName: '',
        attachments: [],
        examTime: '',
        signupStartTime: '',
        signupEndTime: '',
        quota: 0,
        status: 1,
        selectedProjects: [],
        extraConfig: ''
      }
      this.citySignupBannerFile = null
      this.citySignupBannerUploading = false
      this.citySignupBannerHint = ''
      this.citySignupBannerMeta = { ok: true, w: 0, h: 0, msg: '' }
      if (this.$refs.citySignupBannerInput) this.$refs.citySignupBannerInput.value = ''
      this.citySignupAttachmentFile = null
      this.citySignupAttachmentUploading = false
      this.citySignupAttachmentHint = ''
      this.citySignupAttachmentMeta = { ok: true, msg: '' }
      if (this.$refs.citySignupAttachmentInput) this.$refs.citySignupAttachmentInput.value = ''
    },
    saveCitySignup() {
      const required = ['examName', 'province', 'city', 'principalName', 'principalPhone', 'examTime', 'signupStartTime', 'signupEndTime']
      const invalid = required.filter((k) => !this.citySignupFieldOk(k))
      if (invalid.length > 0) {
        window.alert('请先完善所有带 * 的必填项后再保存')
        return
      }
      const hasId = !!this.citySignupForm.id
      const url = hasId ? `/api/crud/city-exam-signup/${this.citySignupForm.id}` : '/api/crud/city-exam-signup'
      const method = hasId ? 'PUT' : 'POST'
      const doSave = () => {
        if (this.citySignupBannerMeta && this.citySignupBannerMeta.ok === false) {
          window.alert(this.citySignupBannerMeta.msg || '横幅图片尺寸不符合要求')
          return
        }
        // Build payload at the last moment so it includes latest bannerUrl (after uploading).
        const payload = {
          examName: String(this.citySignupForm.examName || '').trim(),
          province: String(this.citySignupForm.province || '').trim(),
          city: String(this.citySignupForm.city || '').trim(),
          principalName: String(this.citySignupForm.principalName || '').trim(),
          principalPhone: String(this.citySignupForm.principalPhone || '').trim(),
          organizer: String(this.citySignupForm.organizer || '').trim(),
          venue: String(this.citySignupForm.venue || '').trim(),
          bannerUrl: String(this.citySignupForm.bannerUrl || '').trim(),
          attachmentUrl: String(this.citySignupForm.attachmentUrl || '').trim(),
          attachmentName: String(this.citySignupForm.attachmentName || '').trim(),
          attachmentsJson: this.buildCitySignupAttachmentsJson(),
          examTime: this.toBackendDateTime(this.citySignupForm.examTime),
          signupStartTime: this.toBackendDateTime(this.citySignupForm.signupStartTime),
          signupEndTime: this.toBackendDateTime(this.citySignupForm.signupEndTime),
          quota: Number(this.citySignupForm.quota || 0),
          status: Number(this.citySignupForm.status) === 0 ? 0 : 1,
          extraConfig: this.mergeCitySignupExtraConfig(this.citySignupForm.extraConfig, this.citySignupForm.selectedProjects)
        }
        if (hasId) {
          const cur = (this.citySignupRows || []).find((r) => Number(r.id) === Number(this.citySignupForm.id))
          payload.autoGenerateExamAccount =
            cur != null && Number(cur.autoGenerateExamAccount) === 1 ? 1 : 0
          // 保留历史报名链接：编辑场次时不重置 token/route，关闭后再开启仍可使用旧地址。
          const keepToken = cur && cur.signupToken ? String(cur.signupToken).trim() : ''
          if (keepToken) {
            payload.signupToken = keepToken
            payload.signupRoute = cur && cur.signupRoute
              ? String(cur.signupRoute).trim()
              : `/#/city-signup/${keepToken}`
          }
        } else {
          payload.autoGenerateExamAccount = 0
        }
        fetch(url, {
          method,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(hasId ? { ...this.citySignupForm, ...payload } : payload)
        })
          .then((r) => r.json())
          .then((res) => {
            if (!res || res.code !== 200) {
              window.alert((res && res.message) || '保存失败')
              return
            }
            appAlert(hasId ? '更新场次成功' : '新建场次成功')
            this.loadCitySignups()
            this.resetCitySignupForm()
            this.showCitySignupEditModal = false
          })
          .catch(() => window.alert('保存失败，请检查网络后重试'))
      }
      if (this.citySignupBannerFile) {
        this.uploadCitySignupBanner(() => {
          if (this.citySignupAttachmentFile) {
            this.uploadCitySignupAttachment(doSave)
          } else {
            doSave()
          }
        })
      } else if (this.citySignupAttachmentFile) {
        this.uploadCitySignupAttachment(doSave)
      } else {
        doSave()
      }
    },
    citySignupFieldOk(fieldName) {
      const f = this.citySignupForm || {}
      const val = String(f[fieldName] == null ? '' : f[fieldName]).trim()
      if (fieldName === 'principalPhone') {
        return /^[0-9-]{7,20}$/.test(val)
      }
      if (fieldName === 'examTime' || fieldName === 'signupStartTime' || fieldName === 'signupEndTime') {
        if (!val) return false
        const t = new Date(val.replace(' ', 'T')).getTime()
        return Number.isFinite(t) && t > 0
      }
      return val !== ''
    },
    editCitySignup(row) {
      if (!row) return
      const parsedAttachments = this.parseCitySignupAttachments(row && row.attachmentsJson)
      const selectedProjects = this.citySignupResolveProjectNames(row)
      this.citySignupForm = {
        id: row.id,
        examName: row.examName || '',
        province: row.province || '',
        city: row.city || '',
        principalName: row.principalName || '',
        principalPhone: row.principalPhone || '',
        organizer: row.organizer || '',
        venue: row.venue || '',
        bannerUrl: row.bannerUrl || '',
        attachmentUrl: row.attachmentUrl || '',
        attachmentName: row.attachmentName || '',
        attachments: parsedAttachments && parsedAttachments.length ? parsedAttachments : this.attachmentsFromSingle(row),
        examTime: this.toDateTimeLocalValue(row.examTime || ''),
        signupStartTime: this.toDateTimeLocalValue(row.signupStartTime || ''),
        signupEndTime: this.toDateTimeLocalValue(row.signupEndTime || ''),
        quota: Number(row.quota || 0),
        status: Number(row.status) === 0 ? 0 : 1,
        selectedProjects,
        extraConfig: row.extraConfig || ''
      }
      this.loadCityProjects()
      this.citySignupBannerFile = null
      this.citySignupBannerHint = ''
      this.citySignupBannerMeta = { ok: true, w: 0, h: 0, msg: '' }
      if (this.$refs.citySignupBannerInput) this.$refs.citySignupBannerInput.value = ''
      this.citySignupAttachmentFile = null
      this.citySignupAttachmentHint = ''
      this.citySignupAttachmentMeta = { ok: true, msg: '' }
      if (this.$refs.citySignupAttachmentInput) this.$refs.citySignupAttachmentInput.value = ''
      this.showCitySignupEditModal = true
    },
    onCitySignupAttachmentFileChange(e) {
      const files = (e && e.target && e.target.files) || []
      this.citySignupAttachmentFile = files.length > 0 ? files[0] : null
      this.citySignupAttachmentHint = this.citySignupAttachmentFile ? `已选择：${this.citySignupAttachmentFile.name}` : ''
      this.citySignupAttachmentMeta = { ok: true, msg: '' }
      if (!this.citySignupAttachmentFile) return
      const maxSize = 20 * 1024 * 1024
      if (this.citySignupAttachmentFile.size > maxSize) {
        this.citySignupAttachmentMeta = { ok: false, msg: '附件过大（最大 20MB），请压缩后再上传。' }
      } else {
        this.citySignupAttachmentMeta = { ok: true, msg: '附件已选择，可上传。' }
      }
    },
    clearCitySignupAttachment() {
      this.citySignupForm.attachmentUrl = ''
      this.citySignupForm.attachmentName = ''
      this.citySignupAttachmentFile = null
      this.citySignupAttachmentHint = ''
      this.citySignupAttachmentMeta = { ok: true, msg: '' }
      if (this.$refs.citySignupAttachmentInput) this.$refs.citySignupAttachmentInput.value = ''
    },
    uploadCitySignupAttachment(onSuccess) {
      if (!this.citySignupAttachmentFile) {
        if (typeof onSuccess === 'function') onSuccess()
        return
      }
      if (this.citySignupAttachmentMeta && this.citySignupAttachmentMeta.ok === false) {
        window.alert(this.citySignupAttachmentMeta.msg || '附件不符合要求')
        return
      }
      const form = new FormData()
      form.append('file', this.citySignupAttachmentFile)
      this.citySignupAttachmentUploading = true
      this.citySignupAttachmentHint = `正在上传：${this.citySignupAttachmentFile.name}`
      fetch('/api/city-signup-asset/upload', { method: 'POST', body: form })
        .then(async (r) => {
          const ct = String(r.headers.get('content-type') || '').toLowerCase()
          if (ct.includes('application/json')) return r.json()
          const text = await r.text().catch(() => '')
          throw new Error(text || `HTTP ${r.status}`)
        })
        .then((res) => {
          if (!res || res.code !== 200 || !res.data) {
            window.alert((res && res.message) || '附件上传失败')
            return
          }
          const data = res.data || {}
          this.citySignupForm.attachmentUrl = String(data.downloadUrl || '').trim()
          this.citySignupForm.attachmentName = String(data.originalName || this.citySignupAttachmentFile.name || '').trim()
          this.addCitySignupAttachmentToList({
            url: this.citySignupForm.attachmentUrl,
            name: this.citySignupForm.attachmentName
          })
          this.citySignupAttachmentHint = '附件上传成功'
          this.citySignupAttachmentFile = null
          if (this.$refs.citySignupAttachmentInput) this.$refs.citySignupAttachmentInput.value = ''
          if (typeof onSuccess === 'function') onSuccess()
        })
        .catch((e) => window.alert(`附件上传失败：${(e && e.message) || '请稍后重试'}`))
        .finally(() => {
          this.citySignupAttachmentUploading = false
        })
    },
    addCitySignupAttachmentToList(item) {
      const url = String(item && item.url ? item.url : '').trim()
      if (!url) return
      const name = String(item && item.name ? item.name : '').trim()
      const list = Array.isArray(this.citySignupForm.attachments) ? this.citySignupForm.attachments : []
      const exists = list.some((x) => String(x && x.url ? x.url : '').trim() === url)
      if (exists) return
      this.citySignupForm.attachments = [...list, { url, name }]
    },
    removeCitySignupAttachmentAt(idx) {
      const list = Array.isArray(this.citySignupForm.attachments) ? this.citySignupForm.attachments : []
      const i = Number(idx)
      if (!Number.isFinite(i) || i < 0 || i >= list.length) return
      const next = list.slice(0, i).concat(list.slice(i + 1))
      this.citySignupForm.attachments = next
      // If single attachment matches removed one, clear single fields too.
      const singleUrl = String(this.citySignupForm.attachmentUrl || '').trim()
      if (singleUrl && !next.some((x) => String(x && x.url ? x.url : '').trim() === singleUrl)) {
        // keep single as-is unless it was removed
      } else if (singleUrl && !next.length) {
        this.citySignupForm.attachmentUrl = ''
        this.citySignupForm.attachmentName = ''
      }
    },
    buildCitySignupAttachmentsJson() {
      const list = Array.isArray(this.citySignupForm.attachments) ? this.citySignupForm.attachments : []
      const cleaned = list
        .map((x) => ({
          url: String(x && x.url ? x.url : '').trim(),
          name: String(x && x.name ? x.name : '').trim()
        }))
        .filter((x) => !!x.url)
      // Backward compat: if single attachment exists and not included, include it.
      const singleUrl = String(this.citySignupForm.attachmentUrl || '').trim()
      if (singleUrl && !cleaned.some((x) => x.url === singleUrl)) {
        cleaned.unshift({
          url: singleUrl,
          name: String(this.citySignupForm.attachmentName || '').trim()
        })
      }
      return JSON.stringify(cleaned)
    },
    parseCitySignupAttachments(rawJson) {
      try {
        const parsed = JSON.parse(String(rawJson || ''))
        if (!Array.isArray(parsed)) return []
        return parsed
          .map((x) => ({
            url: String(x && x.url ? x.url : '').trim(),
            name: String(x && x.name ? x.name : '').trim()
          }))
          .filter((x) => !!x.url)
      } catch (e) {
        return []
      }
    },
    attachmentsFromSingle(row) {
      const url = String(row && row.attachmentUrl ? row.attachmentUrl : '').trim()
      if (!url) return []
      const name = String(row && row.attachmentName ? row.attachmentName : '').trim()
      return [{ url, name }]
    },
    onCitySignupBannerFileChange(e) {
      const files = (e && e.target && e.target.files) || []
      this.citySignupBannerFile = files.length > 0 ? files[0] : null
      this.citySignupBannerHint = this.citySignupBannerFile ? `已选择：${this.citySignupBannerFile.name}` : ''
      this.citySignupBannerMeta = { ok: true, w: 0, h: 0, msg: '' }
      if (!this.citySignupBannerFile) return
      this.validateCitySignupBannerFile(this.citySignupBannerFile)
    },
    validateCitySignupBannerFile(file) {
      // Recommend 1920x420 (16:3). Accept ratio within ~2% tolerance.
      const reader = new FileReader()
      reader.onload = () => {
        const img = new Image()
        img.onload = () => {
          const w = Number(img.naturalWidth || img.width || 0)
          const h = Number(img.naturalHeight || img.height || 0)
          const ratio = h > 0 ? w / h : 0
          const target = 16 / 3
          const tol = 0.02
          const ratioOk = ratio > 0 && Math.abs(ratio - target) / target <= tol
          const minOk = w >= 1280 && h >= 280
          const exactOk = w === 1920 && h === 420
          if (!w || !h) {
            this.citySignupBannerMeta = { ok: false, w, h, msg: '无法识别图片尺寸，请更换图片文件。' }
            return
          }
          if (!ratioOk) {
            this.citySignupBannerMeta = {
              ok: false,
              w,
              h,
              msg: `横幅图片比例不符合要求：当前 ${w}x${h}，建议 1920x420（16:3）。请按 16:3 比例重新裁剪。`
            }
            return
          }
          if (!minOk) {
            this.citySignupBannerMeta = {
              ok: false,
              w,
              h,
              msg: `横幅图片分辨率过小：当前 ${w}x${h}。建议至少 1280x280，推荐 1920x420。`
            }
            return
          }
          this.citySignupBannerMeta = {
            ok: true,
            w,
            h,
            msg: exactOk ? `尺寸正确：${w}x${h}` : `比例正确：${w}x${h}（推荐 1920x420）`
          }
        }
        img.onerror = () => {
          this.citySignupBannerMeta = { ok: false, w: 0, h: 0, msg: '图片解析失败，请更换图片文件。' }
        }
        img.src = String(reader.result || '')
      }
      reader.onerror = () => {
        this.citySignupBannerMeta = { ok: false, w: 0, h: 0, msg: '读取图片失败，请重试。' }
      }
      reader.readAsDataURL(file)
    },
    uploadCitySignupBanner(onSuccess) {
      if (!this.citySignupBannerFile) {
        if (typeof onSuccess === 'function') onSuccess()
        return
      }
      if (this.citySignupBannerMeta && this.citySignupBannerMeta.ok === false) {
        window.alert(this.citySignupBannerMeta.msg || '横幅图片尺寸不符合要求')
        return
      }
      const form = new FormData()
      form.append('file', this.citySignupBannerFile)
      this.citySignupBannerUploading = true
      this.citySignupBannerHint = `正在上传：${this.citySignupBannerFile.name}`
      fetch('/api/notice-asset/upload', { method: 'POST', body: form })
        .then(async (r) => {
          const ct = String(r.headers.get('content-type') || '').toLowerCase()
          if (ct.includes('application/json')) return r.json()
          const text = await r.text().catch(() => '')
          throw new Error(text || `HTTP ${r.status}`)
        })
        .then((res) => {
          if (!res || res.code !== 200 || !res.data) {
            window.alert((res && res.message) || '横幅上传失败')
            return
          }
          const data = res.data || {}
          this.citySignupForm.bannerUrl = String(data.viewUrl || data.downloadUrl || '').trim()
          this.citySignupBannerHint = '横幅上传成功'
          this.citySignupBannerFile = null
          if (this.$refs.citySignupBannerInput) this.$refs.citySignupBannerInput.value = ''
          if (typeof onSuccess === 'function') onSuccess()
        })
        .catch((e) => window.alert(`横幅上传失败：${(e && e.message) || '请稍后重试'}`))
        .finally(() => {
          this.citySignupBannerUploading = false
        })
    },
    deleteCitySignup(row) {
      if (!row || !row.id) return
      appConfirm(`确认删除场次【${row.examName || row.id}】吗？`).then((ok) => {
        if (!ok) return
        fetch(`/api/crud/city-exam-signup/${row.id}`, { method: 'DELETE' })
          .then((r) => r.json())
          .then((res) => {
            if (!res || res.code !== 200) {
              window.alert((res && res.message) || '删除失败')
              return
            }
            window.alert('删除成功')
            this.loadCitySignups()
            if (String(this.citySignupForm.id || '') === String(row.id)) {
              this.resetCitySignupForm()
            }
          })
          .catch(() => window.alert('删除失败，请稍后重试'))
      })
    },
    citySignupAbsLink(row) {
      if (!row) return ''
      const route = String(row.signupRoute || '').trim()
      if (!route) return ''
      const base = `${window.location.origin}${window.location.pathname}`
      if (route.startsWith('/#/')) return `${window.location.origin}${route}`
      if (route.startsWith('#/')) return `${base}${route}`
      if (route.startsWith('http://') || route.startsWith('https://')) return route
      return `${window.location.origin}/#/${route.replace(/^\/+/, '')}`
    },
    citySignupBannerPreviewUrl() {
      const raw = String((this.citySignupForm && this.citySignupForm.bannerUrl) || '').trim()
      if (!raw) return ''
      if (raw.startsWith('http://') || raw.startsWith('https://') || raw.startsWith('data:image')) return raw
      if (raw.startsWith('/')) return raw
      return `/${raw}`
    },
    citySignupRowBannerUrl(row) {
      const raw = String((row && row.bannerUrl) || '').trim()
      if (!raw) return ''
      if (raw.startsWith('http://') || raw.startsWith('https://') || raw.startsWith('data:image')) return raw
      if (raw.startsWith('/')) return raw
      return `/${raw}`
    },
    copyCitySignupLink(row) {
      const link = this.citySignupAbsLink(row)
      if (!link) return
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(link)
          .then(() => window.alert('报名地址已复制'))
          .catch(() => window.alert(`请手动复制：${link}`))
      } else {
        window.alert(`请手动复制：${link}`)
      }
    },
    openCitySignupLink(row) {
      const link = this.citySignupAbsLink(row)
      if (!link) return
      window.open(link, '_blank', 'noopener,noreferrer')
    },
    openCitySignupEntries(row) {
      if (!row || !row.id) return
      this.loadCityProjects()
      this.citySignupEntryTitle = row.examName || `场次#${row.id}`
      this.citySignupEntryCurrentSignupId = row.id
      this.citySignupEntryFilters = { candidateName: '', idCard: '', projectName: '', status: '' }
      this.citySignupEntryPage = 0
      this.citySignupReviewNote = ''
      this.citySignupEntrySelectedIds = []
      this.showCitySignupEntryModal = true
      this.loadCitySignupEntries()
    },
    loadCitySignupEntries() {
      if (!this.citySignupEntryCurrentSignupId) return
      this.citySignupEntryPage = 0
      const params = new URLSearchParams({ signupId: String(this.citySignupEntryCurrentSignupId) })
      if (this.citySignupEntryFilters.candidateName) params.append('candidateName', this.citySignupEntryFilters.candidateName)
      if (this.citySignupEntryFilters.idCard) params.append('idCard', this.citySignupEntryFilters.idCard)
      if (this.citySignupEntryFilters.projectName) params.append('projectName', this.citySignupEntryFilters.projectName)
      if (this.citySignupEntryFilters.status !== '' && this.citySignupEntryFilters.status != null) {
        params.append('status', String(this.citySignupEntryFilters.status))
      }
      fetch(`/api/admin/city-signup-entry/list?${params.toString()}`)
        .then((r) => r.json())
        .then((res) => {
          if (!res || res.code !== 200) {
            this.citySignupEntryRows = []
            return
          }
          this.citySignupEntryRows = this.sanitizeObjectArray(res.data)
          this.citySignupEntrySelectedIds = []
        })
        .catch(() => {
          this.citySignupEntryRows = []
        })
    },
    closeCitySignupEntries() {
      this.showCitySignupEntryModal = false
      this.citySignupEntryRows = []
      this.citySignupEntryTitle = ''
      this.citySignupEntryCurrentSignupId = null
      this.citySignupEntryFilters = { candidateName: '', idCard: '', projectName: '', status: '' }
      this.citySignupEntryPage = 0
      this.citySignupReviewNote = ''
      this.citySignupExportMaskIdCard = true
      this.citySignupEntrySelectedIds = []
      this.citySignupBatchReviewing = false
    },
    resetCitySignupEntryEditForm() {
      this.citySignupEntryEditForm = {
        id: null,
        candidateName: '',
        gender: '',
        idCard: '',
        phone: '',
        province: '',
        city: '',
        projectName: '',
        schoolName: '',
        gradeName: '',
        remark: '',
        examUsername: '',
        password: '',
        generatedUserId: null
      }
    },
    openCitySignupEntryEdit(row) {
      if (!row || !row.id) return
      this.loadCityProjects()
      const gidRaw = row.generatedUserId
      const gidNum = gidRaw != null && gidRaw !== '' ? Number(gidRaw) : NaN
      const gid = Number.isFinite(gidNum) && gidNum > 0 ? gidNum : null
      this.citySignupEntryEditForm = {
        id: row.id,
        candidateName: row.candidateName || '',
        gender: row.gender || '',
        idCard: row.idCard || '',
        phone: row.phone || '',
        province: row.province || '',
        city: row.city || '',
        projectName: row.projectName || '',
        schoolName: row.schoolName || '',
        gradeName: row.gradeName || '',
        remark: row.remark || '',
        examUsername: row.generatedExamUsername || '',
        password: '',
        generatedUserId: gid
      }
      this.showCitySignupEntryEditModal = true
    },
    closeCitySignupEntryEditModal() {
      this.showCitySignupEntryEditModal = false
      this.citySignupEntryEditSaving = false
      this.resetCitySignupEntryEditForm()
    },
    saveCitySignupEntryEdit() {
      const f = this.citySignupEntryEditForm
      if (!f || !f.id) return
      if (!String(f.candidateName || '').trim()) {
        appAlert('请填写姓名')
        return
      }
      this.citySignupEntryEditSaving = true
      const body = {
        id: Number(f.id),
        candidateName: f.candidateName,
        gender: f.gender,
        idCard: f.idCard,
        phone: f.phone,
        province: f.province,
        city: f.city,
        projectName: f.projectName,
        schoolName: f.schoolName,
        gradeName: f.gradeName,
        remark: f.remark
      }
      if (f.generatedUserId) {
        body.examUsername = f.examUsername
        if (f.password && String(f.password).trim()) {
          body.password = String(f.password).trim()
        }
      }
      fetch('/api/admin/city-signup-entry/update', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      })
        .then((r) => r.json())
        .then((res) => {
          this.citySignupEntryEditSaving = false
          if (!res || res.code !== 200) {
            appAlert((res && res.message) || '保存失败')
            return
          }
          appAlert('保存成功')
          this.closeCitySignupEntryEditModal()
          this.loadCitySignupEntries()
        })
        .catch(() => {
          this.citySignupEntryEditSaving = false
          appAlert('网络异常')
        })
    },
    citySignupEntryStatusText(s) {
      const v = Number(s)
      if (v === 2) return '通过'
      if (v === 0) return '驳回'
      return '待审'
    },
    postCitySignupEntryReview(id, nextStatus, reviewNote) {
      return fetch('/api/admin/city-signup-entry/review', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: Number(id),
          status: Number(nextStatus),
          reviewNote: reviewNote != null ? String(reviewNote) : ''
        })
      }).then((r) => r.json())
    },
    reviewCitySignupEntry(row, nextStatus) {
      if (!row || !row.id) return
      const actionText = Number(nextStatus) === 2 ? '通过' : '驳回'
      appConfirm(`确认将【${row.candidateName || row.id}】审核为「${actionText}」吗？`).then((ok) => {
        if (!ok) return
        this.postCitySignupEntryReview(row.id, nextStatus, this.citySignupReviewNote)
          .then((res) => {
            if (!res || res.code !== 200) {
              window.alert((res && res.message) || '审核失败')
              return
            }
            this.loadCitySignupEntries()
          })
          .catch(() => window.alert('审核失败，请稍后重试'))
      })
    },
    onCitySignupEntryRowCheck(row, ev) {
      const id = Number(row.id)
      if (!Number.isFinite(id) || Number(row.status) !== 1) return
      const checked = Boolean(ev.target.checked)
      const arr = [...(this.citySignupEntrySelectedIds || [])]
      const i = arr.indexOf(id)
      if (checked && i < 0) arr.push(id)
      if (!checked && i >= 0) arr.splice(i, 1)
      this.citySignupEntrySelectedIds = arr
    },
    onCitySignupSelectAllPending(ev) {
      const checked = Boolean(ev.target.checked)
      const pend = this.citySignupPendingIdsOnPage
      let arr = [...(this.citySignupEntrySelectedIds || [])]
      if (checked) {
        const set = new Set(arr)
        pend.forEach((id) => set.add(id))
        arr = Array.from(set)
      } else {
        const drop = new Set(pend)
        arr = arr.filter((id) => !drop.has(id))
      }
      this.citySignupEntrySelectedIds = arr
    },
    runCitySignupBatchApprove(ids) {
      if (!ids || !ids.length) return
      this.citySignupBatchReviewing = true
      const note = this.citySignupReviewNote || ''
      Promise.allSettled(ids.map((id) => this.postCitySignupEntryReview(id, 2, note)))
        .then((results) => {
          this.citySignupBatchReviewing = false
          const failed = results.filter((x) => {
            if (x.status === 'rejected') return true
            const res = x.value
            return !res || res.code !== 200
          })
          if (failed.length) {
            window.alert(`部分失败：${failed.length}/${ids.length} 条未通过审核，请刷新后重试`)
          }
          this.citySignupEntrySelectedIds = []
          this.loadCitySignupEntries()
        })
        .catch(() => {
          this.citySignupBatchReviewing = false
          window.alert('批量审核失败')
        })
    },
    batchApproveCitySignupSelected() {
      const rows = this.citySignupEntryRows || []
      const ids = (this.citySignupEntrySelectedIds || []).filter((id) =>
        rows.some((r) => Number(r.id) === Number(id) && Number(r.status) === 1)
      )
      if (!ids.length) {
        window.alert('请先勾选待审报名')
        return
      }
      appConfirm(`确认批量通过 ${ids.length} 条报名吗？`).then((ok) => {
        if (!ok) return
        this.runCitySignupBatchApprove(ids)
      })
    },
    approveAllPendingCitySignupEntries() {
      if (!this.citySignupEntryCurrentSignupId) return
      const signupId = this.citySignupEntryCurrentSignupId
      const params = new URLSearchParams({ signupId: String(signupId), status: '1' })
      fetch(`/api/admin/city-signup-entry/list?${params.toString()}`)
        .then((r) => r.json())
        .then((res) => {
          if (!res || res.code !== 200) {
            window.alert((res && res.message) || '加载待审列表失败')
            return
          }
          const list = this.sanitizeObjectArray(res.data)
          const ids = list.map((row) => Number(row.id)).filter((id) => Number.isFinite(id))
          if (!ids.length) {
            window.alert('当前场次暂无待审报名')
            return
          }
          appConfirm(`确认同意本场次全部 ${ids.length} 条待审报名吗？（含当前列表筛选以外的待审记录）`).then((ok) => {
            if (!ok) return
            this.runCitySignupBatchApprove(ids)
          })
        })
        .catch(() => window.alert('加载待审列表失败'))
    },
    maskIdCard(v) {
      const s = String(v || '').trim()
      if (s.length <= 8) return s
      return `${s.slice(0, 4)}****${s.slice(-4)}`
    },
    async exportCitySignupEntriesCsv() {
      if (!this.citySignupExportMaskIdCard) {
        const ok = await appConfirm('导出文件将包含完整身份证号，请妥善保管。\n\n确认继续导出？')
        if (!ok) return
      }
      const headers = ['姓名', '性别', '身份证号', '联系电话', '省份', '地市', '学校', '年级', '报名项目', '状态', '审核备注', '提交时间']
      const rows = this.citySignupEntryRows.map((r) => ([
        r.candidateName || '',
        r.gender || '',
        this.citySignupExportMaskIdCard ? this.maskIdCard(r.idCard) : (r.idCard || ''),
        r.phone || '',
        r.province || '',
        r.city || '',
        r.schoolName || '',
        r.gradeName || '',
        r.projectName || '',
        this.citySignupEntryStatusText(r.status),
        r.reviewNote || '',
        this.$fmtDateTime(r.createTime)
      ]))
      const esc = (v) => `"${String(v == null ? '' : v).replace(/"/g, '""')}"`
      const csv = [headers, ...rows].map((line) => line.map(esc).join(',')).join('\r\n')
      const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' })
      const a = document.createElement('a')
      const url = URL.createObjectURL(blob)
      a.href = url
      a.download = `报名名单_${this.citySignupEntryTitle || '导出'}.csv`
      a.click()
      URL.revokeObjectURL(url)
    },
    runCheatQuery() {
      this.cheatPage = 0
      this.loadCheatUserSummaries()
    },
    resetCheatFilters() {
      this.cheatFilters = { examId: '', username: '', userId: '' }
      this.cheatPage = 0
      this.loadCheatUserSummaries()
    },
    goCheatPage(p) {
      const max = Math.max(0, this.cheatTotalPages - 1)
      const next = Math.max(0, Math.min(Number(p) || 0, max))
      if (next === this.cheatPage) return
      this.cheatPage = next
      this.loadCheatUserSummaries()
    },
    loadCheatUserSummaries() {
      const params = new URLSearchParams({
        page: String(this.cheatPage),
        size: String(this.cheatPageSize)
      })
      if (this.cheatFilters.examId) params.append('examId', this.cheatFilters.examId)
      if (this.cheatFilters.username) params.append('username', this.cheatFilters.username)
      if (this.cheatFilters.userId) params.append('userId', this.cheatFilters.userId)
      fetch(`/api/admin/cheat-logs/user-summary?${params.toString()}`, {
        headers: this.authHeaders()
      })
        .then((r) => r.json())
        .then((res) => {
          const page = (res && res.data) || {}
          this.cheatUserSummaries = this.sanitizeObjectArray(page.content)
          const total = page.totalElements != null ? Number(page.totalElements) : this.cheatUserSummaries.length
          this.cheatTotalElements = Number.isFinite(total) ? total : 0
          let tp = page.totalPages != null ? Number(page.totalPages) : Math.ceil(this.cheatTotalElements / this.cheatPageSize)
          if (!Number.isFinite(tp) || tp < 1) tp = 1
          this.cheatTotalPages = tp
          if (page.number != null) this.cheatPage = Number(page.number)
          if (this.cheatUserSummaries.length === 0 && this.cheatTotalElements > 0 && this.cheatPage > 0) {
            this.cheatPage -= 1
            this.loadCheatUserSummaries()
          }
        })
        .catch(() => {
          this.cheatUserSummaries = []
        })
    },
    openCheatDetailModal(row) {
      if (!row || row.userId == null) return
      this.cheatDetailUser = {
        userId: row.userId,
        username: row.username || ''
      }
      this.cheatDetailRows = []
      this.showCheatDetailModal = true
      this.loadCheatDetailForUser(row.userId)
    },
    closeCheatDetailModal() {
      this.showCheatDetailModal = false
      this.cheatDetailRows = []
      this.cheatDetailUser = { userId: null, username: '' }
    },
    loadCheatDetailForUser(userId) {
      const params = new URLSearchParams({
        page: '0',
        size: '2000',
        userId: String(userId)
      })
      if (this.cheatFilters.examId) params.append('examId', this.cheatFilters.examId)
      fetch(`/api/admin/cheat-logs?${params.toString()}`, {
        headers: this.authHeaders()
      })
        .then((r) => r.json())
        .then((res) => {
          const page = (res && res.data) || {}
          const list = this.sanitizeObjectArray(page.content)
          this.cheatDetailRows = list.slice().sort((a, b) => {
            const ta = new Date(String(a.createTime || '').replace(' ', 'T')).getTime() || 0
            const tb = new Date(String(b.createTime || '').replace(' ', 'T')).getTime() || 0
            return tb - ta
          })
        })
        .catch(() => {
          this.cheatDetailRows = []
        })
    },
    cheatTypeLabelZh(type) {
      const t = String(type || '').trim()
      const u = t.toUpperCase()
      if (u === 'SCREEN_SWITCH' || u.startsWith('SCREEN')) return '切换窗口/切屏'
      if (u === 'CONTEXT_MENU') return '使用右键菜单'
      if (u === 'PASTE_BLOCK') return '尝试粘贴（已拦截）'
      if (u === 'CAM_OCCUPIED') return '摄像头无法读取（设备占用或权限）'
      if (u === 'CAM_HEALTH_FAIL') return '摄像头监控异常（画面未就绪）'
      if (u.startsWith('KEYBOARD_')) {
        const k = u.replace('KEYBOARD_', '')
        if (k === 'C') return '尝试复制（快捷键 Ctrl+C）'
        if (k === 'V') return '尝试粘贴（快捷键 Ctrl+V）'
        if (k === 'X') return '尝试剪切（快捷键 Ctrl+X）'
        return `键盘异常（${k}）`
      }
      if (u === 'UNKNOWN' || u === '') return '未知类型'
      return t
    },
    cheatExamNameDisplay(row) {
      if (row && row.examName) return row.examName
      if (this.cheatSelectedExamName) return this.cheatSelectedExamName
      return '全部考试'
    },
    cheatDetailNoteZh(row) {
      const raw = row && row.detail != null ? String(row.detail).trim() : ''
      const typ = String(row && row.type ? row.type : '').toUpperCase()
      if (!raw) {
        if (typ.includes('SCREEN')) return '系统检测到页面可见性变化（可能切换标签或窗口）'
        return '—'
      }
      const map = {
        visibility_hidden: '浏览器页面被隐藏或切换到后台',
        paste_event: '触发了粘贴操作（已被拦截）',
        right_click: '点击了鼠标右键（已被拦截）',
        fullscreen_exit: '曾退出全屏（旧版逻辑，现已取消全屏要求）',
        NotReadableError: '摄像头无法访问（可能被其他程序占用或无权限）',
        'track not live': '摄像头画面未就绪或视频流已中断'
      }
      if (map[raw]) return map[raw]
      const rawLower = raw.toLowerCase()
      if (rawLower === 'notreadableerror') return map.NotReadableError
      if (rawLower === 'track not live') return map['track not live']
      if (raw === 'TEXTAREA' || raw === 'INPUT') return '在输入框内触发复制/剪切快捷键（已被拦截）'
      return raw
    },
    exportCheatDetailCsv() {
      const uid = this.cheatDetailUser.userId
      if (uid == null) return
      const uname = String(this.cheatDetailUser.username || 'user').replace(/[^\w\u4e00-\u9fa5-]/g, '_')
      const header = ['时间', '考试场次', '异常类型', '说明']
      const lines = [header.join(',')]
      this.cheatDetailRows.forEach((r) => {
        const cols = [
          this.$fmtDateTime(r.createTime),
          this.cheatExamNameDisplay(r),
          this.cheatTypeLabelZh(r.type),
          this.cheatDetailNoteZh(r)
        ].map((c) => `"${String(c).replace(/"/g, '""')}"`)
        lines.push(cols.join(','))
      })
      const blob = new Blob(['\ufeff' + lines.join('\r\n')], { type: 'text/csv;charset=utf-8' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `学员异常记录_${uname}_${uid}.csv`
      a.click()
      URL.revokeObjectURL(url)
    },
    authHeaders(extra = {}) {
      return {
        'X-Role': 'admin',
        'X-User-Id': this.user && this.user.id != null ? String(this.user.id) : '',
        'X-Username': this.user && this.user.username ? String(this.user.username) : 'admin',
        ...extra
      }
    },
    examStatusText(status) {
      const s = String(status || '').toUpperCase()
      if (s === 'NOT_START') return '未开始'
      if (s === 'ING') return '进行中'
      if (s === 'END') return '已结束'
      return status || '-'
    },
    answerRecordStatusText(status) {
      const s = String(status || '').toUpperCase()
      if (s === 'ASSIGNED') return '已分配'
      if (s === 'EXAMING') return '考试中'
      if (s === 'COMMIT') return '已交卷'
      if (s === 'FORCE_END') return '已强制交卷'
      if (s === 'GRADED') return '已阅卷'
      return status || '-'
    },
    logout() {
      localStorage.removeItem('exam_user')
      window.location.hash = '#/'
    },
    onDashboardChartResize() {
      if (this.chartPie) this.chartPie.resize()
      if (this.chartBar) this.chartBar.resize()
    },
    disposeDashboardCharts() {
      if (this.chartPie) {
        this.chartPie.dispose()
        this.chartPie = null
      }
      if (this.chartBar) {
        this.chartBar.dispose()
        this.chartBar = null
      }
    },
    renderDashboardCharts() {
      const ec = typeof window !== 'undefined' ? window.echarts : null
      if (!ec || !this.dashboardStats) return
      const pieEl = this.$refs.dashboardPie
      const barEl = this.$refs.dashboardBar
      if (!pieEl || !barEl) return
      this.disposeDashboardCharts()
      this.chartPie = ec.init(pieEl)
      this.chartBar = ec.init(barEl)
      const bluePalette = ['#2f6feb', '#5ca2ff', '#8eb9ff', '#b8d4ff', '#d9e8ff']
      const pieRows = this.sanitizeObjectArray(this.dashboardStats.pie).map((p) => ({
        name: String((p && p.name) || '未命名'),
        value: this.normalizeDashboardValue(p && p.value)
      }))
      this.chartPie.setOption(
        {
        backgroundColor: 'transparent',
        color: bluePalette,
        tooltip: { trigger: 'item', formatter: '{b}<br/>{c} 人 ({d}%)' },
        legend: {
          bottom: 0,
          textStyle: { color: '#5c7098', fontSize: 11 }
        },
        series: [
          {
            type: 'pie',
            radius: ['38%', '62%'],
            center: ['50%', '46%'],
            avoidLabelOverlap: true,
            itemStyle: { borderColor: '#f0f6ff', borderWidth: 2 },
            label: { color: '#1f2a44' },
            data: pieRows
          }
        ]
        },
        { notMerge: true }
      )
      const bars = this.sanitizeObjectArray(this.dashboardStats.maxScoresByExam)
      const names = bars.map((r) => {
        const n = String(r.examName || '')
        return n.length > 10 ? `${n.slice(0, 10)}…` : n
      })
      const scores = bars.map((r) => this.normalizeDashboardValue(r.maxScore))
      this.chartBar.setOption(
        {
        backgroundColor: 'transparent',
        tooltip: { trigger: 'axis' },
        grid: { left: 48, right: 16, top: 24, bottom: 56 },
        xAxis: {
          type: 'category',
          data: names,
          axisLabel: { rotate: 28, color: '#5c7098', fontSize: 11 },
          axisLine: { lineStyle: { color: '#bfd6ff' } }
        },
        yAxis: {
          type: 'value',
          minInterval: 1,
          axisLabel: { color: '#5c7098' },
          splitLine: { lineStyle: { color: 'rgba(191, 214, 255, 0.45)' } }
        },
        series: [
          {
            type: 'bar',
            data: scores,
            barMaxWidth: 36,
            itemStyle: {
              color:
                ec.graphic && ec.graphic.LinearGradient
                  ? new ec.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 0, color: '#5ca2ff' },
                      { offset: 1, color: '#2f6feb' }
                    ])
                  : '#4f8dff',
              borderRadius: [6, 6, 0, 0]
            }
          }
        ]
        },
        { notMerge: true }
      )
      this.onDashboardChartResize()
    },
    loadDashboardStats() {
      fetch('/api/admin/dashboard/stats')
        .then((r) => r.json())
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.dashboardStats = this.normalizeDashboardStats(res.data)
            this.$nextTick(() => this.renderDashboardCharts())
          }
        })
        .catch(() => {})
    },
    normalizeDashboardValue(v) {
      if (Array.isArray(v)) {
        // Compatible with Jackson default typing output like ["java.lang.Long", 14]
        if (v.length >= 2 && typeof v[0] === 'string' && v[0].startsWith('java.')) return this.normalizeDashboardValue(v[1])
        return 0
      }
      if (v == null || v === '') return 0
      const n = Number(v)
      return Number.isFinite(n) ? n : 0
    },
    normalizeTypedPayload(v) {
      if (Array.isArray(v) && v.length >= 2 && typeof v[0] === 'string' && v[0].startsWith('java.')) {
        return this.normalizeTypedPayload(v[1])
      }
      return v
    },
    normalizeDashboardStats(raw) {
      const normalizedRaw = this.normalizeTypedPayload(raw)
      const src = normalizedRaw && typeof normalizedRaw === 'object' ? normalizedRaw : {}
      const pieRaw = this.normalizeTypedPayload(src.pie)
      const maxScoresRaw = this.normalizeTypedPayload(src.maxScoresByExam)
      return {
        ...src,
        examiningCount: this.normalizeDashboardValue(src.examiningCount),
        onlineStudentCount: this.normalizeDashboardValue(src.onlineStudentCount),
        onlineAllRolesCount: this.normalizeDashboardValue(src.onlineAllRolesCount),
        studentTotal: this.normalizeDashboardValue(src.studentTotal),
        pie: this.sanitizeObjectArray(pieRaw).map((p) => ({
          name: String((p && p.name) || '未命名'),
          value: this.normalizeDashboardValue(p && p.value)
        })),
        maxScoresByExam: this.sanitizeObjectArray(maxScoresRaw).map((r) => ({
          examName: String((r && r.examName) || ''),
          maxScore: this.normalizeDashboardValue(r && r.maxScore)
        }))
      }
    },
    sanitizeObjectArray(list) {
      if (!Array.isArray(list)) return []
      return list.filter((item) => item && typeof item === 'object')
    },
    runUserQuery() {
      this.userPage = 0
      this.loadUsers()
    },
    roleText(role) {
      const r = String(role || '').trim().toLowerCase()
      if (r === 'admin') return '管理员'
      if (r === 'teacher') return '教师'
      if (r === 'student') return '学生'
      return role || '-'
    },
    resetCreateUserForm() {
      this.createForm = { username: '', realName: '', phone: '', password: '', role: 'student', province: '', city: '' }
    },
    goUserPage(p) {
      const max = Math.max(0, this.userTotalPages - 1)
      const next = Math.max(0, Math.min(Number(p) || 0, max))
      if (next === this.userPage) return
      this.userPage = next
      this.loadUsers()
    },
    loadUsers() {
      const params = new URLSearchParams({
        page: String(this.userPage),
        size: String(this.userPageSize),
        sortBy: 'id',
        sort: 'desc'
      })
      if (this.userFilters.keyword) params.append('keyword', this.userFilters.keyword)
      if (this.userFilters.role) params.append('role', this.userFilters.role)
      if (this.userFilters.status) params.append('status', this.userFilters.status)
      if (this.userFilters.province) params.append('province', this.userFilters.province)
      if (this.userFilters.city) params.append('city', this.userFilters.city)
      fetch(`/api/crud/sys-user?${params.toString()}`, { headers: this.authHeaders() })
        .then((r) => r.json())
        .then((res) => {
          const page = (res && res.data) || {}
          const list = this.sanitizeObjectArray(page.content)
          this.users = list
          const total = page.totalElements != null ? Number(page.totalElements) : list.length
          this.userTotalElements = Number.isFinite(total) ? total : 0
          const size = page.size != null ? Number(page.size) : this.userPageSize
          const pageSize = Number.isFinite(size) && size > 0 ? size : this.userPageSize
          let totalPages = page.totalPages != null ? Number(page.totalPages) : Math.ceil(this.userTotalElements / pageSize)
          if (!Number.isFinite(totalPages) || totalPages < 1) totalPages = 1
          this.userTotalPages = totalPages
          if (page.number != null) this.userPage = Number(page.number)
          if (list.length === 0 && this.userTotalElements > 0 && this.userPage > 0) {
            this.userPage -= 1
            this.loadUsers()
          }
        })
    },
    createUser() {
      const username = String(this.createForm.username || '').trim()
      const password = String(this.createForm.password || '')
      if (!username) {
        window.alert('请填写账号')
        return
      }
      if (!password) {
        window.alert('请填写密码')
        return
      }
      fetch('/api/crud/sys-user', {
        method: 'POST',
        headers: this.authHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify({
          ...this.createForm,
          username,
          realName: String(this.createForm.realName || '').trim(),
          phone: String(this.createForm.phone || '').trim(),
          status: 1
        })
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.code === 200) {
            window.alert('新增用户成功')
            this.resetCreateUserForm()
            this.userPage = 0
            this.loadUsers()
            return
          }
          window.alert(res.message || '新增失败')
        })
        .catch(() => {
          window.alert('新增失败，请稍后重试')
        })
    },
    openUserEditModal(u) {
      this.editingUser = {
        id: u.id,
        username: u.username || '',
        realName: u.realName || '',
        role: u.role || 'student',
        status: Number(u.status) === 1 ? 1 : 0,
        phone: u.phone || '',
        province: u.province || '',
        city: u.city || '',
        password: ''
      }
      this.showUserEditModal = true
    },
    closeUserEditModal() {
      this.showUserEditModal = false
    },
    saveUserEdit() {
      if (!this.editingUser.id) return
      fetch(`/api/crud/sys-user/${this.editingUser.id}`, {
        method: 'PUT',
        headers: this.authHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify({
          ...this.editingUser,
          role: (this.editingUser.role || 'student').trim(),
          password: this.editingUser.password || ''
        })
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.code === 200 || res.code === undefined) {
            this.closeUserEditModal()
            this.loadUsers()
            return
          }
          window.alert(res.message || '保存失败')
        })
    },
    toggleUserStatus(u) {
      fetch(`/api/crud/sys-user/${u.id}`, {
        method: 'PUT',
        headers: this.authHeaders({ 'Content-Type': 'application/json' }),
        body: JSON.stringify({
          ...u,
          status: Number(u.status) === 1 ? 0 : 1,
          password: ''
        })
      }).then(() => this.loadUsers())
    },
    async deleteUser(id) {
      if (!id) return
      if (!(await appConfirm('确认删除该用户吗？此操作不可撤销。'))) return
      try {
        const r = await fetch(`/api/crud/sys-user/${id}`, {
          method: 'DELETE',
          headers: this.authHeaders()
        })
        const raw = await r.text()
        let res = null
        try {
          res = raw ? JSON.parse(raw) : null
        } catch (e) {
          res = null
        }
        if (!r.ok || (res && res.code !== undefined && res.code !== 200)) {
          window.alert((res && res.message) || `删除失败（HTTP ${r.status}）`)
          return
        }
        window.alert('删除成功')
        this.loadUsers()
      } catch (e) {
        window.alert('删除失败，请检查网络后重试')
      }
    },
    onUserExcelChange(e) {
      this.userExcelFile = (e.target.files && e.target.files[0]) || null
    },
    importUsersByExcel() {
      if (!this.userExcelFile) {
        window.alert('请先选择Excel文件')
        return
      }
      const form = new FormData()
      form.append('file', this.userExcelFile)
      fetch('/api/crud/sys-user/import-excel', {
        method: 'POST',
        headers: this.authHeaders(),
        body: form
      })
        .then((r) => r.json())
        .then((res) => {
          window.alert(res.data || res.message || '导入完成')
          this.loadUsers()
        })
    },
    downloadUserTemplate() {
      fetch('/api/crud/sys-user/import-template', { headers: this.authHeaders() })
        .then((r) => r.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = url
          a.download = 'sys_user_import_template.xlsx'
          a.click()
          window.URL.revokeObjectURL(url)
        })
    },
    loadExams() {
      this.answerRows = []
      this.currentExamId = null
      this.currentExamScorePublic = 0
      const params = new URLSearchParams({ page: '0', size: '200', sortBy: 'id', sort: 'desc' })
      if (this.examFilters.keyword) params.append('examNameLike', this.examFilters.keyword)
      if (this.examFilters.status) params.append('status', this.examFilters.status)
      fetch(`/api/crud/exam?${params.toString()}`)
        .then((r) => r.json())
        .then((res) => {
          this.exams = this.sanitizeObjectArray(res && res.data && res.data.content)
        })
    },
    loadNotices() {
      const params = new URLSearchParams({ page: '0', size: '200', sortBy: 'sort', sort: 'desc' })
      if (this.noticeFilters.keyword) params.append('keyword', this.noticeFilters.keyword)
      if (this.noticeFilters.status !== '') params.append('status', String(this.noticeFilters.status))
      fetch(`/api/crud/notice?${params.toString()}`)
        .then((r) => r.json())
        .then((res) => {
          this.notices = this.sanitizeObjectArray(res && res.data && res.data.content)
        })
    },
    parseNoticeContent(raw) {
      const fallback = { text: String(raw || ''), assets: [] }
      if (!raw) return fallback
      try {
        const obj = JSON.parse(raw)
        if (!obj || typeof obj !== 'object') return fallback
        return {
          text: String(obj.text || ''),
          assets: Array.isArray(obj.assets) ? obj.assets : []
        }
      } catch (e) {
        return fallback
      }
    },
    noticeSummary(row) {
      const parsed = this.parseNoticeContent(row && row.content)
      const textPart = parsed.text ? parsed.text.slice(0, 28) : ''
      const filesPart = parsed.assets.length > 0 ? `，附件${parsed.assets.length}个` : ''
      return textPart ? `${textPart}${filesPart}` : (filesPart ? filesPart.slice(1) : '-')
    },
    toDateTimeLocalValue(input) {
      if (!input) return ''
      const raw = String(input).replace(' ', 'T')
      return raw.length >= 16 ? raw.slice(0, 16) : raw
    },
    toBackendDateTime(input) {
      const v = String(input || '').trim()
      if (!v) return null
      const t = v.replace(' ', 'T')
      if (t.length === 16) return `${t}:00`
      if (t.length === 19) return t
      return t
    },
    openCreateNoticeModal() {
      this.resetNoticeForm()
      this.noticeForm.publishTime = this.toDateTimeLocalValue(new Date().toISOString())
      this.showNoticeEditModal = true
    },
    closeNoticeEditModal() {
      this.showNoticeEditModal = false
      this.resetNoticeForm()
    },
    resetNoticeForm() {
      this.noticeForm = { id: null, title: '', contentText: '', assets: [], sort: 0, status: 1, publishTime: '' }
      this.noticeUploadFile = null
      this.noticeUploadingText = ''
      if (this.$refs.noticeFileInput) this.$refs.noticeFileInput.value = ''
    },
    saveNotice() {
      if (!String(this.noticeForm.title || '').trim()) {
        window.alert('请输入公告标题')
        return
      }
      const doSave = () => {
        const contentPayload = {
          format: 'rich_notice_v1',
          text: String(this.noticeForm.contentText || '').trim(),
          assets: this.noticeForm.assets || []
        }
        const body = {
          title: String(this.noticeForm.title || '').trim(),
          content: JSON.stringify(contentPayload),
          sort: Number(this.noticeForm.sort || 0),
          status: Number(this.noticeForm.status) === 0 ? 0 : 1,
          publisher: this.user.username || 'admin',
          publishTime: this.toBackendDateTime(this.noticeForm.publishTime)
        }
        const hasId = !!this.noticeForm.id
        const url = hasId
          ? `/api/crud/notice/${this.noticeForm.id}`
          : '/api/crud/notice'
        const method = hasId ? 'PUT' : 'POST'
        fetch(url, {
          method,
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(hasId ? { ...this.noticeForm, ...body } : body)
        })
          .then((r) => r.json())
          .then((res) => {
            if (res.code === 200 || res.code === undefined) {
              this.showNoticeEditModal = false
              this.resetNoticeForm()
              this.loadNotices()
              return
            }
            window.alert(res.message || '公告保存失败')
          })
      }
      // If a file is chosen but not uploaded yet, auto-upload before save.
      if (this.noticeUploadFile) {
        this.uploadNoticeAsset(() => {
          doSave()
        })
        return
      }
      doSave()
    },
    editNotice(row) {
      const parsed = this.parseNoticeContent(row.content)
      this.noticeForm = {
        id: row.id,
        title: row.title || '',
        contentText: parsed.text || '',
        assets: parsed.assets || [],
        sort: Number(row.sort || 0),
        status: Number(row.status) === 0 ? 0 : 1,
        publishTime: this.toDateTimeLocalValue(row.publishTime || row.createTime || '')
      }
      this.noticeUploadFile = null
      this.noticeUploadingText = ''
      if (this.$refs.noticeFileInput) this.$refs.noticeFileInput.value = ''
      this.showNoticeEditModal = true
    },
    toggleNoticeStatus(row) {
      if (!row || !row.id) return
      fetch(`/api/crud/notice/${row.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...row,
          status: Number(row.status) === 1 ? 0 : 1
        })
      }).then(() => this.loadNotices())
    },
    async deleteNotice(id) {
      if (!id) return
      if (!(await appConfirm('确认删除该公告吗？此操作不可撤销。'))) return
      try {
        const r = await fetch(`/api/crud/notice/${id}`, { method: 'DELETE' })
        const raw = await r.text()
        let res = null
        try {
          res = raw ? JSON.parse(raw) : null
        } catch (e) {
          res = null
        }
        if (!r.ok || (res && res.code !== undefined && res.code !== 200)) {
          window.alert((res && res.message) || `删除失败（HTTP ${r.status}）`)
          return
        }
        window.alert('删除成功')
        this.loadNotices()
        if (String(this.noticeForm.id || '') === String(id)) this.resetNoticeForm()
      } catch (e) {
        window.alert('删除失败，请检查网络后重试')
      }
    },
    onNoticeFileChange(e) {
      this.noticeUploadFile = (e.target.files && e.target.files[0]) || null
      this.noticeUploadingText = this.noticeUploadFile ? `已选择：${this.noticeUploadFile.name}` : ''
    },
    uploadNoticeAsset(onSuccess) {
      if (!this.noticeUploadFile) {
        window.alert('请先选择文件')
        return
      }
      const form = new FormData()
      form.append('file', this.noticeUploadFile)
      this.noticeUploading = true
      this.noticeUploadingText = `正在上传：${this.noticeUploadFile.name}`
      fetch('/api/notice-asset/upload', {
        method: 'POST',
        body: form
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.code === 200 && res.data) {
            this.noticeForm.assets.push(res.data)
            this.noticeUploadingText = `已上传：${res.data.originalName || '文件'}`
            this.noticeUploadFile = null
            if (this.$refs.noticeFileInput) this.$refs.noticeFileInput.value = ''
            if (typeof onSuccess === 'function') onSuccess()
            return
          }
          window.alert(res.message || '上传失败')
          this.noticeUploadingText = '上传失败'
        })
        .catch(() => {
          this.noticeUploadingText = '上传失败'
          window.alert('上传失败')
        })
        .finally(() => {
          this.noticeUploading = false
        })
    },
    removeNoticeAsset(index) {
      this.noticeForm.assets.splice(index, 1)
    },
    loadExamAnswers(examId) {
      this.currentExamId = Number(examId)
      const currentExam = this.exams.find((e) => String(e.id) === String(examId))
      this.currentExamScorePublic = Number((currentExam && currentExam.scorePublic) || 0)
      fetch(`/api/student/exam/answers/exam/${examId}`, {
        headers: this.authHeaders()
      })
        .then((r) => r.json())
        .then((res) => {
          this.answerRows = this.sanitizeObjectArray(res && res.data)
        })
    },
    viewAnswerDetail(recordRow) {
      fetch(`/api/student/exam/answers/record/${recordRow.recordId}`, {
        headers: this.authHeaders()
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.code === 200) {
            this.answerDetailRows = this.sanitizeObjectArray(res.data).map((item) => ({
              ...item,
              editingScore: Number(item.answerScore ?? 0)
            }))
            this.currentAnswerRecord = {
              recordId: recordRow.recordId,
              userId: recordRow.userId,
              username: recordRow.username,
              score: recordRow.score || 0,
              originalScore: recordRow.score || 0
            }
            this.showAnswerDetailModal = true
            return
          }
          window.alert(res.message || '加载作答详情失败')
        })
    },
    closeAnswerDetailModal() {
      this.showAnswerDetailModal = false
      this.answerDetailRows = []
      this.savingAnswerScores = false
      this.currentAnswerRecord = { recordId: null, userId: null, username: '', score: 0, originalScore: 0 }
    },
    normalizeAnswerScore(item) {
      const maxScore = Math.max(0, Number((item && item.maxScore) ?? 0) || 0)
      let score = Number((item && item.editingScore) ?? 0)
      if (!Number.isFinite(score)) score = 0
      score = Math.round(score)
      if (score < 0) score = 0
      if (score > maxScore) score = maxScore
      return score
    },
    refreshAnswerRowTotal(totalScore) {
      const total = Number(totalScore ?? 0) || 0
      this.currentAnswerRecord.score = total
      const hit = this.answerRows.find((r) => String(r.recordId) === String(this.currentAnswerRecord.recordId))
      if (hit) hit.score = total
    },
    async saveAnswerScore(item, silent = false) {
      if (!item || !this.currentAnswerRecord.recordId) return false
      const score = this.normalizeAnswerScore(item)
      item.editingScore = score
      const params = new URLSearchParams({
        recordId: String(this.currentAnswerRecord.recordId),
        questionId: String(item.questionId),
        score: String(score)
      })
      const res = await fetch(`/api/student/exam/grade/manual?${params.toString()}`, {
        method: 'POST',
        headers: this.authHeaders()
      }).then((r) => r.json())
      if (res.code !== 200) {
        if (!silent) window.alert(res.message || '保存成绩失败')
        return false
      }
      item.answerScore = score
      item.manualGraded = true
      this.refreshAnswerRowTotal(res.data && res.data.totalScore)
      if (!silent) window.alert('该题成绩已保存')
      return true
    },
    async saveAllAnswerScores() {
      if (!this.answerDetailRows.length) return
      this.savingAnswerScores = true
      try {
        for (const item of this.answerDetailRows) {
          const ok = await this.saveAnswerScore(item, true)
          if (!ok) {
            window.alert(`保存失败：第 ${item.sort || '-'} 题未保存成功`)
            return
          }
        }
        window.alert('该学生所有题目成绩已保存')
      } catch (e) {
        window.alert('保存成绩失败')
      } finally {
        this.savingAnswerScores = false
      }
    },
    async restoreAnswerScore(item, silent = false) {
      if (!item || !this.currentAnswerRecord.recordId) return false
      const params = new URLSearchParams({
        recordId: String(this.currentAnswerRecord.recordId),
        questionId: String(item.questionId)
      })
      const res = await fetch(`/api/student/exam/grade/restore?${params.toString()}`, {
        method: 'POST',
        headers: this.authHeaders()
      }).then((r) => r.json())
      if (res.code !== 200) {
        if (!silent) window.alert(res.message || '恢复系统判分失败')
        return false
      }
      const nextScore = Number(res.data && res.data.score) || 0
      item.answerScore = nextScore
      item.editingScore = nextScore
      item.manualGraded = false
      this.refreshAnswerRowTotal(res.data && res.data.totalScore)
      if (!silent) window.alert('该题已恢复系统原始判分')
      return true
    },
    async restoreAllAnswerScores() {
      if (!this.answerDetailRows.length) return
      this.savingAnswerScores = true
      try {
        for (const item of this.answerDetailRows) {
          const ok = await this.restoreAnswerScore(item, true)
          if (!ok) {
            window.alert(`恢复失败：第 ${item.sort || '-'} 题未恢复成功`)
            return
          }
        }
        window.alert('该学生所有题目已恢复为系统原始判分')
      } catch (e) {
        window.alert('恢复系统判分失败')
      } finally {
        this.savingAnswerScores = false
      }
    },
    openEntryPhotoModal(row) {
      this.entryPhotoRow = {
        id: row.id,
        cameraPhoto: row.cameraPhoto || '',
        examNameDisplay: row.examNameDisplay || '',
        studentUsername: row.studentUsername || ''
      }
      this.showEntryPhotoModal = true
    },
    closeEntryPhotoModal() {
      this.showEntryPhotoModal = false
      this.entryPhotoRow = {
        id: null,
        cameraPhoto: '',
        examNameDisplay: '',
        studentUsername: ''
      }
    },
    showEntryHoverPreview(event, src) {
      if (!src) return
      this.entryHoverPreviewSrc = src
      this.entryHoverPreviewVisible = true
      this.moveEntryHoverPreview(event)
    },
    moveEntryHoverPreview(event) {
      if (!this.entryHoverPreviewVisible) return
      const previewW = 280
      const previewH = 280
      const gap = 16
      const pad = 10
      const clientX = Number((event && event.clientX) || 0)
      const clientY = Number((event && event.clientY) || 0)
      const maxX = Math.max(pad, window.innerWidth - previewW - pad)
      const maxY = Math.max(pad, window.innerHeight - previewH - pad)
      const x = Math.min(Math.max(clientX + gap, pad), maxX)
      const y = Math.min(Math.max(clientY + gap, pad), maxY)
      this.entryHoverPreviewX = x
      this.entryHoverPreviewY = y
    },
    hideEntryHoverPreview() {
      this.entryHoverPreviewVisible = false
      this.entryHoverPreviewSrc = ''
    },
    exportExamScores(examId) {
      fetch(`/api/student/exam/scores/exam/${examId}/export`, {
        headers: this.authHeaders()
      })
        .then((r) => r.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = url
          a.download = `exam_scores_${examId}.xlsx`
          a.click()
          window.URL.revokeObjectURL(url)
        })
    },
    publishExamScores(examId) {
      fetch(`/api/student/exam/scores/exam/${examId}/publish`, {
        method: 'POST',
        headers: this.authHeaders()
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.code === 200) {
            window.alert(res.data || '已公开当前考试成绩')
            this.loadExams()
            this.currentExamScorePublic = 1
            return
          }
          window.alert(res.message || '公开成绩失败')
        })
    },
    unpublishExamScores(examId) {
      fetch(`/api/student/exam/scores/exam/${examId}/unpublish`, {
        method: 'POST',
        headers: this.authHeaders()
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.code === 200) {
            window.alert(res.data || '已取消公开当前考试成绩')
            this.loadExams()
            this.currentExamScorePublic = 0
            return
          }
          window.alert(res.message || '取消公开失败')
        })
    },
    exportAnswerExcel(recordId) {
      fetch(`/api/student/exam/answers/record/${recordId}/export`, {
        headers: this.authHeaders()
      })
        .then((r) => r.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = url
          a.download = `student_answers_record_${recordId}.xlsx`
          a.click()
          window.URL.revokeObjectURL(url)
        })
    },
    resetEntryCheckFilters() {
      this.entryFilters = { examId: '', userId: '', status: '' }
      this.entryPage = 0
      this.loadEntryChecks()
    },
    searchEntryChecks() {
      this.entryPage = 0
      this.loadEntryChecks()
    },
    goEntryPage(next) {
      const page = Number(next)
      if (!Number.isFinite(page) || page < 0) return
      if (page === this.entryPage) return
      if (page >= this.entryTotalPages) return
      this.entryPage = page
      this.loadEntryChecks()
    },
    updateEntryStatus(row, event) {
      const nextStatus = String((event && event.target && event.target.value) || '').trim()
      if (!row || !row.id || !nextStatus) return
      fetch(`/api/crud/exam-entry-check/${row.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...row,
          status: nextStatus
        })
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.code === 200 || res.code === undefined) {
            row.status = nextStatus
            return
          }
          window.alert(res.message || '核验状态更新失败')
          this.loadEntryChecks()
        })
        .catch(() => {
          window.alert('核验状态更新失败')
          this.loadEntryChecks()
        })
    },
    async deleteEntryCheck(row) {
      if (!row || !row.id) return
      const who = row.studentUsername && row.studentUsername !== '—' ? `学员：${row.studentUsername}` : '该条记录'
      if (!(await appConfirm(`确认删除该条核验记录吗？（${who}）`))) return
      fetch(`/api/crud/exam-entry-check/${row.id}`, {
        method: 'DELETE'
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.code === 200 || res.code === undefined) {
            window.alert('删除成功')
            if (this.entryChecks.length <= 1 && this.entryPage > 0) {
              this.entryPage -= 1
            }
            this.loadEntryChecks()
            return
          }
          window.alert(res.message || '删除失败')
        })
        .catch(() => {
          window.alert('删除失败')
        })
    },
    enrichEntryCheckRows(rows) {
      const userIds = [...new Set(rows.map((r) => r.userId).filter((id) => id != null))]
      const examIds = [...new Set(rows.map((r) => r.examId).filter((id) => id != null))]
      const userMap = {}
      const examMap = {}
      const fetchJson = (url) =>
        fetch(url)
          .then((r) => r.json())
          .catch(() => ({}))
      return Promise.all([
        ...userIds.map((id) =>
          fetchJson(`/api/crud/sys-user/${id}`).then((res) => {
            if (res && res.data && res.data.username != null) userMap[id] = res.data.username
          })
        ),
        ...examIds.map((id) =>
          fetchJson(`/api/crud/exam/${id}`).then((res) => {
            if (res && res.data && res.data.examName != null) examMap[id] = res.data.examName
          })
        )
      ]).then(() =>
        rows.map((r) => ({
          ...r,
          studentUsername: userMap[r.userId] != null ? userMap[r.userId] : '—',
          examNameDisplay: examMap[r.examId] != null ? examMap[r.examId] : '—'
        }))
      )
    },
    loadEntryChecks() {
      const examId = String(this.entryFilters.examId || '').trim()
      const userId = String(this.entryFilters.userId || '').trim()
      const status = String(this.entryFilters.status || '').trim()
      const params = new URLSearchParams({
        page: String(this.entryPage || 0),
        size: String(this.entryPageSize || 10),
        sortBy: 'id',
        sort: 'desc'
      })
      if (status) params.append('status', status)
      if (examId) params.append('examId', examId)
      if (userId) params.append('userId', userId)
      this.entryLoading = true
      fetch(`/api/crud/exam-entry-check?${params.toString()}`)
        .then((r) => r.json())
        .then((res) => {
          const page = res.data || {}
          const rows = page.content || []
          this.entryTotalElements = Number(page.totalElements || 0)
          let tp = page.totalPages != null ? Number(page.totalPages) : 1
          if (!Number.isFinite(tp) || tp < 1) tp = 1
          this.entryTotalPages = tp
          if (this.entryPage > tp - 1) {
            this.entryPage = Math.max(0, tp - 1)
          }
          return this.enrichEntryCheckRows(rows)
        })
        .then((rows) => {
          this.entryChecks = rows
        })
        .catch(() => {
          this.entryChecks = []
          this.entryTotalElements = 0
          this.entryTotalPages = 1
        })
        .finally(() => {
          this.entryLoading = false
        })
    }
  }
}
</script>

<style scoped>
.role-page {
  min-height: 100vh;
  padding: 20px;
  background:
    radial-gradient(circle at 8% 10%, rgba(82, 149, 255, 0.16), transparent 34%),
    radial-gradient(circle at 92% 20%, rgba(120, 170, 255, 0.14), transparent 30%),
    linear-gradient(160deg, #f7faff 0%, #eef4ff 55%, #f8fbff 100%);
  color: #1f2a44;
}

.side-nav {
  width: 240px;
  min-height: calc(100vh - 40px);
  flex: 0 0 240px;
  flex-shrink: 0;
  margin-right: 16px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: rgba(255, 255, 255, 0.78);
  border: 1px solid #d8e6ff;
  border-radius: 12px;
  box-shadow: 0 12px 30px rgba(63, 108, 199, 0.1);
  backdrop-filter: blur(8px);
}

.nav-btn {
  border: 1px solid #d8e6ff;
  border-radius: 10px;
  padding: 10px 12px;
  color: #335896;
  background: #f6f9ff;
  text-align: left;
  transition: all 0.2s ease;
}

.nav-btn:hover {
  background: #eef5ff;
  border-color: #bfd6ff;
  transform: translateY(-1px);
}

.nav-btn.active {
  background: linear-gradient(120deg, #2f6feb, #5ca2ff);
  color: #fff;
  border-color: transparent;
}

.group-header {
  font-size: 12px;
  font-weight: 700;
  color: #5c7098;
  letter-spacing: 0.4px;
  margin-top: 2px;
}

/* 企业风左侧菜单：色块清晰、层次明显、文字高对比 */
.side-nav .sub-btn {
  border: 1px solid #aeb9c8 !important;
  border-left: 6px solid #8398b0 !important;
  border-radius: 10px !important;
  padding: 12px 14px !important;
  margin-bottom: 2px;
  color: #111827 !important;
  background: #dbe9ff !important;
  text-align: left;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;
  box-shadow: 0 2px 5px rgba(15, 23, 42, 0.1);
  transition: background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.side-nav .sub-btn:hover {
  color: #0b1322 !important;
  background: #cfe2ff !important;
  border-color: #93a4b9 !important;
  border-left-color: #667f9d !important;
  box-shadow: 0 5px 12px rgba(15, 23, 42, 0.18);
  transform: translateY(-1px);
}

.side-nav .sub-btn.active {
  color: #09111f !important;
  background: #bed6ff !important;
  border-color: #6f87a7 !important;
  border-left: 8px solid #294e79 !important;
  box-shadow:
    0 7px 16px rgba(31, 57, 92, 0.28),
    inset 0 0 0 1px rgba(255, 255, 255, 0.35);
}

.side-nav .sub-btn.active:hover {
  color: #061020 !important;
  background: #b2ceff !important;
  border-color: #607da1 !important;
  border-left: 8px solid #1f446f !important;
}

.side-nav .side-nav-logout-btn {
  margin-top: 6px;
}

.content-area {
  flex: 1;
  min-width: 0;
}

.card-box {
  background: linear-gradient(165deg, rgba(255, 255, 255, 0.82), rgba(245, 250, 255, 0.92));
  border: 1px solid #d8e6ff;
  border-radius: 14px;
  padding: 16px;
  margin-bottom: 16px;
  box-shadow: 0 10px 26px rgba(48, 96, 192, 0.1);
}

.ticket-login-host-card {
  padding-bottom: 10px;
}

.ticket-login-host-desc {
  line-height: 1.6;
  max-width: 720px;
}

.ticket-login-host-card :deep(.city-paper-card) {
  box-shadow: 0 6px 16px rgba(48, 96, 192, 0.08);
}

.card-box h4,
.card-box h5 {
  color: #1f2a44;
  font-weight: 700;
}

.result-shell {
  border: 1px solid rgba(145, 180, 240, 0.35);
  border-radius: 12px;
  padding: 8px;
  background: linear-gradient(165deg, rgba(255, 255, 255, 0.82), rgba(245, 250, 255, 0.92));
  overflow-x: auto;
}

.table :deep(th),
.table :deep(td) {
  white-space: nowrap;
  vertical-align: middle;
}

.city-signup-name-cell {
  min-width: 260px;
  max-width: 420px;
  white-space: normal !important;
  word-break: keep-all;
  overflow-wrap: anywhere;
  line-height: 1.35;
  font-size: inherit;
  font-weight: 400;
}

.city-signup-preinfo-snippet {
  max-width: 240px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 地市报名场次列表：单行摘要 + 按钮；单元格与表格 align-middle 齐平 */
.city-signup-session-table td.city-signup-cell-stack {
  white-space: normal !important;
  vertical-align: middle;
}

.city-signup-session-table .city-signup-action-stack {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.35rem;
}

.city-signup-session-table td.city-signup-link-cell-td {
  white-space: nowrap !important;
}

.city-signup-session-table .city-signup-one-line {
  display: block;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.35;
}

.city-signup-session-table .city-signup-one-line--narrow {
  max-width: 128px;
}

/* 地市报名列表：压缩「项目分类」列占位 */
th.city-signup-project-col,
td.city-signup-project-col {
  width: 0.1%;
  max-width: 132px;
  white-space: normal !important;
}

.city-signup-project-pick-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 14px;
  padding: 8px 10px;
  border: 1px dashed #cfe0ff;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.6);
}

.city-signup-project-pick {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: #355b9f;
  user-select: none;
}

.city-signup-project-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  max-width: 280px;
}

.city-signup-project-tag {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid #cfe0ff;
  background: #f4f8ff;
  color: #355b9f;
  font-size: 12px;
  line-height: 1.4;
}

.city-signup-link-cell {
  max-width: 320px;
  white-space: normal !important;
}

.city-signup-link-text {
  word-break: break-all;
  white-space: normal !important;
  line-height: 1.35;
}

.city-signup-toolbar {
  align-items: center;
}

.city-signup-toolbar .btn {
  margin-right: 0 !important;
}

.btn {
  border-radius: 10px;
  font-weight: 600;
}

.modal-mask {
  position: fixed;
  inset: 0;
  background: rgba(18, 36, 76, 0.35);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  z-index: 1200;
}

.modal-panel {
  width: min(720px, 100%);
  background: linear-gradient(165deg, rgba(255, 255, 255, 0.96), rgba(244, 250, 255, 0.98));
  border: 1px solid #d8e6ff;
  border-radius: 16px;
  padding: 18px;
  box-shadow: 0 20px 50px rgba(35, 72, 150, 0.22);
}

.modal-wide {
  width: min(1200px, 100%);
}

.city-signup-edit-body-scroll {
  max-height: calc(min(84vh, 860px) - 120px);
  overflow-y: auto;
  padding-right: 2px;
}

.event-edit-modal-mask {
  z-index: 5000;
}

.city-signup-edit-modal {
  width: min(980px, 100%);
  max-height: min(84vh, 860px);
  overflow-y: auto;
}

.city-signup-banner-preview {
  width: 100%;
  border: 1px solid #cfe0ff;
  border-radius: 10px;
  overflow: hidden;
  background: #f5f9ff;
}

.city-signup-banner-preview img {
  width: 100%;
  height: 160px;
  object-fit: cover;
  display: block;
}

.city-signup-banner-thumb {
  width: 120px;
  height: 34px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #cfe0ff;
  background: #f5f9ff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.city-signup-banner-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.city-signup-banner-load-btn {
  width: 100%;
  height: 100%;
  border-radius: 0 !important;
  font-size: 12px !important;
  padding: 0 !important;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

.city-signup-banner-thumb--empty {
  font-size: 12px;
  color: #5c7098;
}

.city-signup-action-btn {
  min-width: 84px;
  text-align: center;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  font-size: 12px !important;
  padding: 0.28rem 0.45rem !important;
}

.city-entry-action-nowrap {
  flex-wrap: nowrap !important;
  white-space: nowrap;
}

.city-signup-action-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 6px;
  align-items: stretch;
  justify-items: stretch;
  min-width: 176px;
}

.city-signup-action-grid .city-signup-action-btn {
  width: 100%;
}

/* Override global theme that restyles .btn-danger */
.city-signup-danger-btn {
  background: #dc3545 !important;
  border-color: #dc3545 !important;
  color: #ffffff !important;
}

.city-signup-danger-btn:hover {
  filter: brightness(0.98);
  box-shadow: 0 10px 18px rgba(220, 53, 69, 0.22);
}

.detail-title {
  min-width: 260px;
  max-width: 420px;
  white-space: normal !important;
}

.detail-answer {
  min-width: 180px;
  max-width: 320px;
  white-space: normal !important;
  word-break: break-word;
}

.entry-photo-wrap {
  border: 1px solid #d8e6ff;
  border-radius: 12px;
  padding: 10px;
  background: #f8fbff;
  text-align: center;
}

.entry-photo-img {
  max-width: 100%;
  max-height: 60vh;
  border-radius: 10px;
  border: 1px solid #c8daf7;
  box-shadow: 0 10px 24px rgba(36, 79, 168, 0.16);
}

.entry-thumb-img {
  width: 56px;
  height: 56px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #c8daf7;
  cursor: zoom-in;
  box-shadow: 0 6px 14px rgba(36, 79, 168, 0.16);
}

.entry-status-select.reject {
  border-color: #dc3545 !important;
  background: #ffe5e8 !important;
  color: #b4232c !important;
  font-weight: 700 !important;
  box-shadow: 0 0 0 0.16rem rgba(220, 53, 69, 0.2) !important;
}

.entry-delete-btn {
  background: #dc3545 !important;
  border-color: #dc3545 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
}

.entry-delete-btn:hover {
  background: #bb2d3b !important;
  border-color: #bb2d3b !important;
}

.entry-row-reject td {
  background: #fff6f7 !important;
}

.entry-hover-preview {
  position: fixed;
  z-index: 1600;
  width: 280px;
  height: 280px;
  padding: 6px;
  border-radius: 12px;
  border: 1px solid #c8daf7;
  background: #ffffff;
  box-shadow: 0 18px 40px rgba(35, 72, 150, 0.26);
  pointer-events: none;
}

.entry-hover-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

@media (max-width: 992px) {
  .role-page {
    flex-direction: column;
  }

  .side-nav {
    width: 100%;
    min-height: auto;
    margin-right: 0;
    margin-bottom: 12px;
  }
}

.admin-dashboard-section .admin-stat-tile {
  border: 1px solid #d8e6ff;
  border-radius: 12px;
  padding: 14px 16px;
  background: linear-gradient(165deg, rgba(255, 255, 255, 0.95), rgba(244, 249, 255, 0.98));
  box-shadow: 0 8px 20px rgba(63, 108, 199, 0.08);
}

.admin-stat-label {
  font-size: 12px;
  color: #5c7098;
  margin-bottom: 6px;
}

.admin-stat-value {
  font-size: 26px;
  font-weight: 800;
  color: #2b4f8f;
  letter-spacing: 0.5px;
}

.admin-chart-card {
  border: 1px solid #d8e6ff;
  border-radius: 12px;
  padding: 12px 12px 8px;
  background: linear-gradient(165deg, rgba(255, 255, 255, 0.92), rgba(248, 251, 255, 0.96));
  min-height: 360px;
  display: flex;
  flex-direction: column;
}

.admin-chart-title {
  font-size: 14px;
  font-weight: 700;
  color: #2b4f8f;
  margin-bottom: 8px;
}

.admin-chart-box {
  flex: 1;
  width: 100%;
  min-height: 300px;
}

.cheat-detail-modal {
  width: min(920px, calc(100vw - 32px));
  max-height: 90vh;
  overflow: auto;
}

.cheat-detail-table-wrap {
  max-height: 60vh;
  overflow: auto;
}

.event-detail-editor {
  min-height: 320px;
  max-height: 520px;
  overflow: auto;
  background: #fff;
  line-height: 1.7;
  white-space: normal;
}

.event-detail-editor:focus {
  outline: none;
}

.event-pick-wrap {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  padding: 6px 8px;
  border: 1px solid #cfe0ff;
  border-radius: 10px;
  background: #fbfdff;
  min-height: 38px;
}

.event-pick-item {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  color: #2f4f86;
  background: #eef4ff;
  border: 1px solid #d5e4ff;
  border-radius: 999px;
  padding: 2px 9px;
}

.event-pick-remove {
  line-height: 1;
  font-size: 12px;
  text-decoration: none;
}
</style>
